import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { listOfNotNull2woi2boe01ub4 as listOfNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../../../../kiteui-library/com/lightningkite/kiteui/reactive/PersistentProperty.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_stringsProperty() {
  _init_properties_strings_kt__kebw5s();
  return stringsProperty;
}
var stringsProperty;
function get_navDashboardTitle() {
  return 'Dashboard';
}
function get_navFormulaLabTitle() {
  return 'Formula lab';
}
function get_navSignOutTitle() {
  return 'Sign out';
}
function get_navSwitchLanguageTitle() {
  return 'Switch language';
}
function get_navProvidersTitle() {
  return 'Providers (UMB)';
}
function get_navCareLocationsTitle() {
  return 'Care Locations';
}
function get_navEmployersTitle() {
  return 'Employers';
}
function get_navGrantsTitle() {
  return 'Grants';
}
function get_navRemittancesTitle() {
  return 'Remittances';
}
function get_navCloseOutTitle() {
  return 'Close Out Month';
}
function get_navUsersTitle() {
  return 'Users';
}
function get_navProfileTitle() {
  return 'Profile';
}
function get_notificationsPromptTitle() {
  return 'Send notifications?';
}
function get_notificationsPromptBody() {
  return 'TCG Child Care Voucher Data Tool would like to send you notifications.';
}
function get_notificationsPromptAllow() {
  return 'Allow';
}
function get_crudGroupProgramTitle() {
  return 'Program';
}
function get_crudGroupNetworkTitle() {
  return 'Network';
}
function get_crudGroupFundingTitle() {
  return 'Funding';
}
function get_crudGroupAdminTitle() {
  return 'Administration';
}
function get_crudCancelButton() {
  return 'Cancel';
}
function get_crudSaveButton() {
  return 'Save';
}
function get_crudSavedToast() {
  return 'Saved';
}
function get_appTagline() {
  return 'TCG Child Care Voucher Data Tool';
}
function get_closurePaidLabel() {
  return 'Paid';
}
function get_closureUnpaidLabel() {
  return 'Unpaid';
}
function dateRangeOnwards(start) {
  return start + ' onwards';
}
function get_exportCsvButton() {
  return 'Export CSV';
}
function get_goBackDescription() {
  return 'Go back';
}
function get_emptyRowText() {
  return 'None to show';
}
function get_searchIconDescription() {
  return 'Search';
}
function get_validationInvalidPhoneMessage() {
  return 'Not a valid phone number';
}
function get_validationInvalidEmailMessage() {
  return 'Not a valid email address';
}
function get_landingPageTitle() {
  return 'Loading';
}
function get_loginPageTitle() {
  return 'Sign In';
}
function get_loginPrompt() {
  return 'Sign in to get started';
}
function get_loginServerFieldLabel() {
  return 'Server';
}
function get_homePageTitle() {
  return 'Home';
}
function get_homeEmptyStateMessage() {
  return "There's nothing here for you right now. Check back later.";
}
function get_homeApplicationsHeading() {
  return 'Your Applications';
}
function get_homeApplicationsIntro() {
  return "You've been invited to apply for child care assistance. Complete your application below to get started.";
}
function get_homeApplicationCardTitle() {
  return 'Child Care Assistance Application';
}
function get_homeProviderApplicationCardTitle() {
  return 'Care Provider Application';
}
function homeApplicationInvitedOn(date) {
  return 'Invited ' + date;
}
function get_homeApplicationStatusActionNeeded() {
  return 'Action needed';
}
function get_homeApplicationStatusSubmitted() {
  return 'Submitted';
}
function get_homeApplicationStatusApproved() {
  return 'Approved';
}
function get_homeApplicationStatusRejected() {
  return 'Not approved';
}
function get_homeApplicationStartButton() {
  return 'Start application';
}
function get_homeApplicationContinueButton() {
  return 'View application';
}
function get_checkVersionTitle() {
  return 'New Version Available';
}
function checkVersionRequiredBody(version) {
  return "We've released version " + version + ' with important updates that are required to continue using the app. Please update now to enjoy the latest features, improvements, and security enhancements.';
}
function checkVersionOptionalBody(version) {
  return 'Good news! Version ' + version + ' is now available with new features and improvements. We recommend updating soon to get the best experience, but you can continue using the current version for now.';
}
function get_checkVersionOkButton() {
  return 'OK';
}
function attendanceNeedsEntryMessage(count) {
  switch (count) {
    case 0:
      return 'All attendance for this period has been marked.';
    case 1:
      return '1 schedule day still needs an entry before this month can be submitted.';
    default:
      return '' + count + ' scheduled days still need entries before this month can be submitted.';
  }
}
function get_submitAttendance() {
  return 'Submit attendance';
}
function get_attendanceChildScheduleColumnLabel() {
  return 'Child & schedule';
}
function attendancePeriodPageTitle(period) {
  return period + ' Attendance';
}
function attendanceLocationLabel(name) {
  return 'Location: ' + name;
}
function attendanceProviderLabel(name) {
  return 'Provider: ' + name;
}
function get_attendancePeriodLabel() {
  return 'Period';
}
function get_attendanceChildrenScheduledLabel() {
  return 'Children scheduled';
}
function get_attendanceStatusLabel() {
  return 'Status';
}
function get_attendanceStatusSubmitted() {
  return 'Submitted';
}
function get_attendanceStatusOpen() {
  return 'Not submitted';
}
function get_attendancePeriodsPageTitle() {
  return 'Attendance Periods';
}
function attendancePeriodRange(start, end) {
  return start + ' to ' + end;
}
function get_attendanceClosuresHeading() {
  return 'Closures this period';
}
function get_attendanceLocationColumnLabel() {
  return 'Location';
}
function get_attendanceUnknownLocationLabel() {
  return 'Unknown location';
}
function get_attendanceSubmittedColumnLabel() {
  return 'Submitted';
}
function get_attendanceApprovedColumnLabel() {
  return 'Approved';
}
function get_attendanceStatusApproved() {
  return 'Approved';
}
function get_attendanceStatusPending() {
  return 'Pending';
}
function get_attendanceNotBegunMessage() {
  return 'Attendance period has not yet begun.';
}
function get_attendanceFilledToast() {
  return 'Attendance filled!';
}
function get_attendanceTransportProvidedLabel() {
  return 'Transport provided';
}
function get_attendanceTransportToCareLabel() {
  return 'To care';
}
function get_attendanceTransportFromCareLabel() {
  return 'From care';
}
function get_attendanceStateAttended() {
  return 'Attended';
}
function get_attendanceStateExplainedAbsence() {
  return 'Explained Absence';
}
function get_attendanceStateUnexplainedAbsence() {
  return 'Unexplained Absence';
}
function get_attendanceStateClosure() {
  return 'Closure';
}
function get_attendanceStateNotScheduled() {
  return 'Not Scheduled';
}
function get_attendanceStateNotPlaced() {
  return 'Not Placed';
}
function get_attendanceStateNeedsEntry() {
  return 'Needs Entry';
}
function get_formulaTesterHeading() {
  return 'Test this formula';
}
function get_formulaTesterInstructions() {
  return 'Change a value to see the result';
}
function formulaResultLine(result) {
  return 'Result: ' + result;
}
function get_locationNameLabel() {
  return 'Name';
}
function get_locationAddressSectionTitle() {
  return 'Address';
}
function get_locationStreetAddressLabel() {
  return 'Street Address';
}
function get_locationAptSuiteLabel() {
  return 'Apt, suite, etc (optional)';
}
function get_locationCityLabel() {
  return 'City';
}
function get_locationStateLabel() {
  return 'State';
}
function get_locationZipcodeLabel() {
  return 'Zipcode';
}
function get_locationContactSectionTitle() {
  return 'Contact';
}
function get_locationContactNameLabel() {
  return 'Contact name';
}
function get_locationContactEmailLabel() {
  return 'Contact email';
}
function get_locationContactPhoneLabel() {
  return 'Contact phone';
}
function get_locationAddDialogTitle() {
  return 'Add a location';
}
function get_locationAddButton() {
  return 'Add location';
}
function get_locationAddedToast() {
  return 'Location added!';
}
function get_locationAddClosureButton() {
  return 'Add closure';
}
function get_locationDetailsSectionTitle() {
  return 'Location Details';
}
function get_locationEditButton() {
  return 'Edit location';
}
function get_locationProviderLabel() {
  return 'Provider';
}
function get_locationActivePlacementsSectionTitle() {
  return 'Active Placements';
}
function get_locationChildColumnLabel() {
  return 'Child';
}
function get_locationRateColumnLabel() {
  return 'Rate';
}
function get_locationActiveDatesColumnLabel() {
  return 'Active dates';
}
function get_locationAgreementStatusColumnLabel() {
  return 'Agreement status';
}
function get_locationUnknownRateLabel() {
  return 'Unknown rate';
}
function get_locationNoEndDateLabel() {
  return 'no end date';
}
function locationDateRange(start, end) {
  return start + ' \u2013 ' + end;
}
function get_locationSaveButton() {
  return 'Save location';
}
function get_locationSavedToast() {
  return 'Location saved!';
}
function get_locationsPageTitle() {
  return 'Locations';
}
function locationDetailTitle(name) {
  return name + ' Location';
}
function get_locationContactColumnLabel() {
  return 'Contact';
}
function get_locationPhoneColumnLabel() {
  return 'Phone';
}
function get_locationRatesHeading() {
  return 'Rates';
}
function get_locationAddRateButton() {
  return 'Add rate';
}
function get_locationPrototypeColumnLabel() {
  return 'Prototype';
}
function get_locationPlanLabel() {
  return 'Template';
}
function get_locationUnknownPlanLabel() {
  return 'Unknown plan';
}
function get_locationAttendanceHeading() {
  return 'Attendance';
}
function get_locationAddAttendancePeriodButton() {
  return 'Add attendance period';
}
function get_locationPeriodNotSubmittedStatus() {
  return 'Not submitted';
}
function get_locationPeriodNeedsApprovalStatus() {
  return 'Submitted, needs approval';
}
function get_locationClosureDateLabel() {
  return 'Date';
}
function get_locationClosureKindColumnLabel() {
  return 'Kind';
}
function locationChooseMonthSubtext(locationName) {
  return locationName + " \u2014 choose a month that doesn't have one yet.";
}
function get_locationNoEligibleMonthsMessage() {
  return 'Every month this location has placements for already has a period.';
}
function get_locationClosureUmbrellaWarning() {
  return 'Will apply to all locations under this provider umbrella.';
}
function get_locationClosureSpecificLocationHint() {
  return "To create a closure for a specific location, visit that location's detail page.";
}
function get_locationClosureReasonLabel() {
  return 'Reason';
}
function get_locationAddClosuresButton() {
  return 'Add closures';
}
function get_locationClosureAddedToast() {
  return 'Closure added!';
}
function get_locationPrototypeNameLabel() {
  return 'Prototype name';
}
function get_locationSelectPlanPlaceholder() {
  return 'Select a plan...';
}
function get_locationRateAddedToast() {
  return 'Rate added!';
}
function get_rateInForceFromLabel() {
  return 'In force from';
}
function get_rateLocationLabel() {
  return 'Location';
}
function get_ratePlanLabel() {
  return 'Plan';
}
function get_rateChangeButton() {
  return 'Change';
}
function rateChangePlanTitle(rateName) {
  return "Change the definition of '" + rateName + "' to point to a different template";
}
function get_rateStartingAtDateLabel() {
  return 'Starting at date';
}
function get_rateToRateLabel() {
  return 'To rate';
}
function rateChangeConfirmation(targetName) {
  return 'I am SURE I want to change to ' + targetName + '. This is hard to undo!';
}
function get_rateOnThisPlanSinceLabel() {
  return 'On this plan since';
}
function get_rateCurrentRateHeading() {
  return 'Current rate';
}
function get_rateLocationCurrentRateSubtext() {
  return 'What this arrangement pays today.';
}
function get_ratePlanCurrentRateSubtext() {
  return 'What this plan pays today.';
}
function get_rateCurrentChip() {
  return 'CURRENT';
}
function rateInForceSince(range) {
  return 'In force since ' + range;
}
function get_rateHistoryHeading() {
  return 'Rate history';
}
function get_rateHistorySubtext() {
  return "Generated from the plan's own revisions \u2014 not editable here.";
}
function get_rateInForceColumnLabel() {
  return 'In force';
}
function get_rateDailyRateColumnLabel() {
  return 'Daily rate';
}
function get_rateTemplatesPageTitle() {
  return 'Rate Templates';
}
function get_rateTemplatesHeading() {
  return 'Care Rate Templates';
}
function get_rateAddTemplateButton() {
  return 'Add rate template';
}
function get_rateNameColumnLabel() {
  return 'Name';
}
function get_rateAddVersionButton() {
  return 'Add version';
}
function get_rateVersionHistoryHeading() {
  return 'Version history';
}
function get_rateVersionHistorySubtext() {
  return "Every version this template has ever had. A version can't be edited once created. To change a rate, add a new version.";
}
function get_rateNewVersionPageTitle() {
  return 'New Care Rate Template Version';
}
function rateAddVersionHeading(templateName) {
  return 'Add a new version to ' + templateName;
}
function get_rateTemplateNameHeading() {
  return 'Template name';
}
function get_rateNewVersionFormHeading() {
  return 'New version';
}
function get_rateAddTemplateSubmitButton() {
  return 'Add template';
}
function get_rateVersionAddedToast() {
  return 'Version added!';
}
function get_rateNewTemplatePageTitle() {
  return 'New Care Rate Template';
}
function get_rateNewTemplateHeading() {
  return 'Add a new care rate template';
}
function get_rateNameLabel() {
  return 'Name';
}
function get_rateShortNameLabel() {
  return 'Short name (what locations call it)';
}
function get_rateAgeStartLabel() {
  return 'Youngest age';
}
function get_rateAgeEndLabel() {
  return 'Oldest age';
}
function get_rateTransportOneWayLabel() {
  return 'Transport, one way';
}
function get_rateTransportTwoWayLabel() {
  return 'Transport, both ways';
}
function get_rateCareTimeLabel() {
  return 'Care time';
}
function get_rateAvailableAsIntermittentLabel() {
  return 'Can be used when school is out';
}
function get_rateFirstVersionFormHeading() {
  return 'First version';
}
function get_rateTemplateAddedToast() {
  return 'Template added!';
}
function get_providerNameLabel() {
  return 'Name';
}
function get_providerContactLabel() {
  return 'Contact';
}
function get_providerContactNameLabel() {
  return 'Contact name';
}
function get_providerContactEmailLabel() {
  return 'Contact email';
}
function get_providerContactPhoneLabel() {
  return 'Contact phone';
}
function get_providerOffersTransportationLabel() {
  return 'Offers transportation';
}
function get_providerAddDialogHeading() {
  return 'Add a provider';
}
function get_providerAddButtonLabel() {
  return 'Add provider';
}
function get_providerAddedToast() {
  return 'Provider added!';
}
function get_providerDetailsHeading() {
  return 'Provider Details';
}
function get_providerEditButtonDescription() {
  return 'Edit provider';
}
function get_providerYesLabel() {
  return 'Yes';
}
function get_providerNoLabel() {
  return 'No';
}
function get_providerLocationsHeading() {
  return 'Locations';
}
function get_providerAddLocationButtonLabel() {
  return 'Add location';
}
function get_providerCityLabel() {
  return 'City';
}
function get_providerSaveButtonLabel() {
  return 'Save provider';
}
function get_providerSavedToast() {
  return 'Provider saved!';
}
function get_providersPageTitle() {
  return 'Providers';
}
function get_providerEmailLabel() {
  return 'Email';
}
function get_providerPhoneLabel() {
  return 'Phone';
}
function get_providerVendorNumberLabel() {
  return 'Vendor #';
}
function get_providerVendorNumberNotSet() {
  return '[Not set]';
}
function get_childAddDialogTitle() {
  return 'Add a child';
}
function get_childAddButton() {
  return 'Add child';
}
function get_childAddedToast() {
  return 'Child added!';
}
function get_childFirstNameLabel() {
  return 'First name';
}
function get_childLastNameLabel() {
  return 'Last name';
}
function get_childBirthDateLabel() {
  return 'Birth date';
}
function get_childRaceEthnicityLabel() {
  return 'Race/Ethnicity (select all that apply)';
}
function get_childNotesLabel() {
  return 'Notes';
}
function get_childDetailsHeading() {
  return 'Child Details';
}
function childFamilyNameSuffix(familyName) {
  return familyName + ' Family';
}
function get_childUnknownLabel() {
  return 'Unknown';
}
function childBirthdateWithAge(birthDate, ageInMonths) {
  return birthDate + ' (' + ageInMonths + ' months)';
}
function get_childPlacementsHeading() {
  return 'Placements';
}
function get_childTableHeaderLocation() {
  return 'Location';
}
function get_childTableHeaderRate() {
  return 'Rate';
}
function get_childTableHeaderActiveDates() {
  return 'Active dates';
}
function get_childTableHeaderAgreementStatus() {
  return 'Agreement status';
}
function get_childUnknownLocationLabel() {
  return 'Unknown location';
}
function get_childUnknownProviderLabel() {
  return 'Unknown provider';
}
function get_childUnknownRateLabel() {
  return 'Unknown rate';
}
function get_childNoEndDateLabel() {
  return 'no end date';
}
function get_childSaveButton() {
  return 'Save child';
}
function get_childSavedToast() {
  return 'Child saved!';
}
function childPlacementDetailTitle(childName) {
  return childName + "'s Placement";
}
function get_childPlacementDetailsHeading() {
  return 'Placement Details';
}
function signatureStatusLabel(status) {
  var tmp;
  switch (status == null ? -1 : status.ordinal_1) {
    case -1:
    case 0:
      tmp = 'Sending for signing';
      break;
    case 1:
    case 2:
      tmp = 'Sent for signing';
      break;
    case 3:
      tmp = 'Signed';
      break;
    case 4:
      tmp = 'Signature declined';
      break;
    case 5:
      tmp = 'Document voided';
      break;
    case 6:
      tmp = 'Document expired';
      break;
    case 7:
      tmp = 'Status unknown';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function get_childScheduleHeading() {
  return 'Schedule';
}
function get_childScheduleTableHeaderDay() {
  return 'Day';
}
function get_childScheduleTableHeaderTime() {
  return 'Time';
}
function get_childScheduleTableHeaderIntermittent() {
  return 'Intermittent';
}
function get_childScheduleTableHeaderTransport() {
  return 'Transport';
}
function get_childNoLabel() {
  return 'No';
}
function childTransportDescription(transportFrom, transportTo) {
  return transportFrom && transportTo ? 'To & From' : transportFrom ? 'From' : transportTo ? 'To' : 'None';
}
function get_childrenListTitle() {
  return 'Children';
}
function get_childrenTableHeaderName() {
  return 'Name';
}
function get_childrenTableHeaderFamily() {
  return 'Family';
}
function get_childrenTableHeaderBirthdate() {
  return 'Birthdate';
}
function get_placementNewTitle() {
  return 'New Placement';
}
function placementAddForChildTitle(childName) {
  return 'Add a placement for ' + childName;
}
function get_placementDetailsHeading() {
  return 'Details';
}
function get_placementCareLocationLabel() {
  return 'Care location';
}
function get_placementSearchIconDescription() {
  return 'Search';
}
function placementLocationWithProvider(locationName, providerName) {
  var tmp;
  if (providerName == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = ' \xB7 ' + providerName;
  }
  var tmp1_elvis_lhs = tmp;
  return locationName + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
}
function get_placementSelectCareLocationPlaceholder() {
  return 'Select a care location...';
}
function get_placementChooseCareLocationTitle() {
  return 'Choose a care location';
}
function get_placementNoCareLocationsMatch() {
  return 'No care locations match.';
}
function get_placementStartDateLabel() {
  return 'Start date';
}
function get_placementEndDateLabel() {
  return 'End date';
}
function get_placementFundingHeading() {
  return 'Funding';
}
function get_placementPaidByGrantsLabel() {
  return 'Paid by (grants)';
}
function get_placementChooseGrantsTitle() {
  return 'Choose grants';
}
function get_placementSendForSignatureTitle() {
  return 'Send for signature?';
}
function get_placementSendForSignatureBody() {
  return 'Text explaining documents will be sent for signature and if changes need to be made, a new placement must be created and this one terminated.';
}
function get_placementSaveAndSendButton() {
  return 'Save & send for signature';
}
function get_placementAddedToast() {
  return 'Placement added!';
}
function get_placementNoneSelectedLabel() {
  return 'None selected';
}
function get_placementNoOptionsFoundLabel() {
  return 'No options found.';
}
function get_placementDoneButton() {
  return 'Done';
}
function get_childEditButton() {
  return 'Edit child';
}
function get_childFamilyLabel() {
  return 'Family';
}
function get_childBirthdateLabel() {
  return 'Birthdate';
}
function get_childAddPlacementButton() {
  return 'Add placement';
}
function get_childPlacementChildLabel() {
  return 'Child';
}
function get_childPlacementProviderLabel() {
  return 'Provider';
}
function get_childPlacementGrantsLabel() {
  return 'Grants';
}
function get_placementSearchLocationHint() {
  return 'Search location name';
}
function get_placementTransportFromLabel() {
  return 'Transport from';
}
function get_placementTransportToLabel() {
  return 'Transport to';
}
function get_placementSearchHint() {
  return 'Search';
}
function get_childCopyPlacementButton() {
  return 'Copy placement';
}
function get_placementChangeEndButton() {
  return 'Change end date';
}
function get_placementEndReasonLabel() {
  return 'End reason';
}
function get_placementEndReasonPlaceholder() {
  return 'Select a reason';
}
function get_placementEndReasonNotesLabel() {
  return 'Reason details';
}
function get_childPlacementAgreementLabel() {
  return 'Placement Agreement';
}
function get_childPlacementAgreementNoneSet() {
  return 'None set';
}
function get_childNotScheduledLabel() {
  return 'Not scheduled';
}
function get_placementWhenSchoolIsOutLabel() {
  return 'When school is out';
}
function get_placementNotIntermittentLabel() {
  return 'Not intermittent';
}
function placementPreviousEndChangeMessage(previousEnd, cutoff, newStart) {
  return 'The previous placement currently ends on ' + previousEnd + '. It will instead be ended on ' + cutoff + ', the day before this placement starts on ' + newStart + '.';
}
function get_familyFirstNameLabel() {
  return 'First name';
}
function get_familyLastNameLabel() {
  return 'Last name';
}
function get_familyPhoneNumberLabel() {
  return 'Phone number';
}
function get_familyAlternatePhoneLabel() {
  return 'Additional phone number (optional)';
}
function get_familyEmailLabel() {
  return 'Email';
}
function get_familyPreferredLanguageLabel() {
  return 'Preferred language';
}
function get_familyRaceEthnicityLabel() {
  return 'Race/Ethnicity (select all that apply)';
}
function get_familyAddSecondParentLabel() {
  return 'Add second parent';
}
function get_familyAddressLabel() {
  return 'Address';
}
function get_familyStreetAddressLabel() {
  return 'Street Address';
}
function get_familyAptSuiteLabel() {
  return 'Apt, suite, etc (optional)';
}
function get_familyCityLabel() {
  return 'City';
}
function get_familyStateLabel() {
  return 'State';
}
function get_familyZipcodeLabel() {
  return 'Zipcode';
}
function get_familyAnnualIncomeLabel() {
  return 'Annual Income';
}
function get_familySizeLabel() {
  return 'Family Size';
}
function get_familyPreferNotToSayLabel() {
  return 'Prefer not to say';
}
function familyDetailTitle(familyName) {
  return familyName + ' Family';
}
function get_familyDetailsSectionTitle() {
  return 'Family Details';
}
function get_familyEditIconDescription() {
  return 'Edit family';
}
function get_familyPrimaryParentLabel() {
  return 'Primary parent';
}
function get_familyPrimaryEmailLabel() {
  return 'Primary email';
}
function get_familyPrimaryPhoneLabel() {
  return 'Primary phone';
}
function get_familyPrimaryAlternatePhoneLabel() {
  return 'Primary alternate phone';
}
function get_familySecondaryParentLabel() {
  return 'Secondary parent';
}
function get_familySecondaryEmailLabel() {
  return 'Secondary email';
}
function get_familySecondaryPhoneLabel() {
  return 'Secondary phone';
}
function get_familySecondaryAlternatePhoneLabel() {
  return 'Secondary alternate phone';
}
function get_familyInformationVerifiedLabel() {
  return 'Information verified';
}
function get_familyNotVerifiedLabel() {
  return 'Not verified';
}
function get_familyChildrenSectionTitle() {
  return 'Children';
}
function get_familyAddChildButton() {
  return 'Add child';
}
function get_familyNameColumnLabel() {
  return 'Name';
}
function get_familyBirthdateAgeColumnLabel() {
  return 'Birthdate/Age';
}
function get_familyActivePlacementColumnLabel() {
  return 'Active Placement';
}
function familyPlacementSummary(provider, location, status) {
  return provider + ' \xB7 ' + location + ' \xB7 ' + status;
}
function get_familySaveFamilyButton() {
  return 'Save family';
}
function get_familySavedToast() {
  return 'Family saved!';
}
function get_familyListTitle() {
  return 'Families';
}
function get_familyAddFamilyButton() {
  return 'Add family';
}
function get_familyColumnLabel() {
  return 'Family';
}
function get_familyCityColumnLabel() {
  return 'City';
}
function get_familyNewFamilyTitle() {
  return 'New Family';
}
function get_familyAddPageTitle() {
  return 'Add a family';
}
function get_familyAddedToast() {
  return 'Family added!';
}
function get_familyApplicationListTitle() {
  return 'Family Applications';
}
function get_familyApplicationColumnSentTo() {
  return 'Sent To';
}
function get_familyApplicationColumnEmployer() {
  return 'Employer';
}
function get_familyApplicationColumnStatus() {
  return 'Status';
}
function get_familyApplicationColumnInvitedAt() {
  return 'Invited';
}
function familyApplicationDetailTitle(sentTo) {
  return 'Application - ' + sentTo;
}
function get_familyApplicationSentToLabel() {
  return 'Sent To';
}
function get_familyApplicationEmployerLabel() {
  return 'Employer';
}
function get_familyApplicationStatusLabel() {
  return 'Status';
}
function get_familyApplicationNotSubmittedLabel() {
  return 'Not yet submitted';
}
function get_familyApplicationApproveButton() {
  return 'Approve';
}
function get_familyApplicationApproveConfirmHeading() {
  return 'Approve this application?';
}
function get_familyApplicationApproveConfirmBody() {
  return 'This will create the family record (and any children) from the submitted information.';
}
function get_familyApplicationApprovedToast() {
  return 'Application approved';
}
function get_familyApplicationRejectedToast() {
  return 'Application rejected';
}
function get_providerApplicationListTitle() {
  return 'Provider Applications';
}
function get_providerApplicationColumnSentTo() {
  return 'Sent To';
}
function get_providerApplicationColumnInvitedAt() {
  return 'Invited';
}
function get_providerApplicationColumnStatus() {
  return 'Status';
}
function providerApplicationDetailTitle(sentTo) {
  return 'Application - ' + sentTo;
}
function get_providerApplicationSentToLabel() {
  return 'Sent To';
}
function get_providerApplicationStatusLabel() {
  return 'Status';
}
function get_providerApplicationNotSubmittedLabel() {
  return 'Not yet submitted';
}
function get_providerApplicationApproveButton() {
  return 'Approve';
}
function get_providerApplicationApproveConfirmHeading() {
  return 'Approve this application?';
}
function get_providerApplicationApproveConfirmBody() {
  return 'This will create the care provider record from the submitted information.';
}
function get_providerApplicationApprovedToast() {
  return 'Application approved';
}
function get_providerApplicationRejectedToast() {
  return 'Application rejected';
}
function get_employerNameLabel() {
  return 'Name';
}
function get_employerContactLabel() {
  return 'Contact';
}
function get_employerContactNameLabel() {
  return 'Contact name';
}
function get_employerContactEmailLabel() {
  return 'Contact email';
}
function get_employerContactPhoneLabel() {
  return 'Contact phone';
}
function get_employerEmailColumnLabel() {
  return 'Email';
}
function get_employerPhoneColumnLabel() {
  return 'Phone';
}
function get_employerBillingAddressLabel() {
  return 'Billing address';
}
function get_employerAddBillingAddressLabel() {
  return 'Add billing address';
}
function get_employerBillingContactLabel() {
  return 'Billing contact';
}
function get_employerBillingContactNameLabel() {
  return 'Billing contact name';
}
function get_employerStreetAddressLabel() {
  return 'Street Address';
}
function get_employerAptSuiteLabel() {
  return 'Apt, suite, etc (optional)';
}
function get_employerCityLabel() {
  return 'City';
}
function get_employerStateLabel() {
  return 'State';
}
function get_employerZipcodeLabel() {
  return 'Zipcode';
}
function get_employerAddDialogHeading() {
  return 'Add an employer';
}
function get_employerAddButton() {
  return 'Add employer';
}
function get_employerAddedToast() {
  return 'Employer added!';
}
function get_employerDetailsHeading() {
  return 'Employer Details';
}
function get_employerEditButtonDescription() {
  return 'Edit employer';
}
function get_employerActiveLabel() {
  return 'Active';
}
function get_employerYesLabel() {
  return 'Yes';
}
function get_employerNoLabel() {
  return 'No';
}
function get_employerBalanceLabel() {
  return 'Balance';
}
function get_employerBalanceNotSynced() {
  return 'Not synced';
}
function get_employerRatesHeading() {
  return 'Rates';
}
function get_employerRatesSubtext() {
  return 'What this employer pays per day of care.';
}
function get_employerAddNewRateButton() {
  return 'Add new rate';
}
function get_employerShareOfDayLabel() {
  return "Employer's share of one day";
}
function get_employerShareColumnLabel() {
  return 'Employer share';
}
function get_employerAdministrationColumnLabel() {
  return 'Administration';
}
function get_employerSaveButton() {
  return 'Save employer';
}
function get_employerSavedToast() {
  return 'Employer saved!';
}
function get_employerNewRatePageTitle() {
  return 'New Employer Rate';
}
function employerAddRateHeading(employerName) {
  return 'Add a rate for ' + employerName;
}
function get_employerAddRateButton() {
  return 'Add rate';
}
function get_employerRateAddedToast() {
  return 'Rate added!';
}
function get_userNameLabel() {
  return 'Name';
}
function get_userEmailLabel() {
  return 'Email';
}
function get_userPhoneLabel() {
  return 'Phone';
}
function get_userRoleLabel() {
  return 'Role';
}
function get_userDetailsSectionTitle() {
  return 'User Details';
}
function get_userEditIconDescription() {
  return 'Edit user';
}
function get_grantNameLabel() {
  return 'Name';
}
function get_grantFunderLabel() {
  return 'Funder';
}
function get_grantAwardPeriodLabel() {
  return 'Award period';
}
function get_grantStartDateLabel() {
  return 'Start date';
}
function get_grantAddEndDateLabel() {
  return 'Add end date';
}
function get_grantEndDateLabel() {
  return 'End date';
}
function get_grantAddDialogHeading() {
  return 'Add a grant';
}
function get_grantAddButton() {
  return 'Add grant';
}
function get_grantAddedToast() {
  return 'Grant added!';
}
function get_grantDetailsHeading() {
  return 'Grant Details';
}
function get_grantEditButtonDescription() {
  return 'Edit grant';
}
function get_grantBalanceLabel() {
  return 'Balance';
}
function get_grantBalanceNotSynced() {
  return 'Not synced';
}
function get_grantRatesHeading() {
  return 'Rates';
}
function get_grantRatesSubtext() {
  return 'How this grant matches one day of care.';
}
function get_grantAddNewRateButton() {
  return 'Add new rate';
}
function get_grantShareOfDayLabel() {
  return "Grant's match of one day";
}
function get_grantShareColumnLabel() {
  return 'Grant match';
}
function get_grantSaveButton() {
  return 'Save grant';
}
function get_grantSavedToast() {
  return 'Grant saved!';
}
function get_grantNewRatePageTitle() {
  return 'New Grant Rate';
}
function grantAddRateHeading(grantName) {
  return 'Add a rate for ' + grantName;
}
function get_grantAddRateButton() {
  return 'Add rate';
}
function get_grantRateAddedToast() {
  return 'Rate added!';
}
function get_remittancesPageTitle() {
  return 'Remittances';
}
function get_remittancesPreviousMonthDescription() {
  return 'Previous month';
}
function get_remittancesNextMonthDescription() {
  return 'Next month';
}
function get_remittancesProviderColumn() {
  return 'Provider';
}
function get_remittancesStatusColumn() {
  return 'Status';
}
function get_closeOutAttendanceIncomplete() {
  return 'Attendance is incomplete';
}
function get_closeOutAttendanceReviewNeeded() {
  return 'Attendance review needed';
}
function get_closeOutReadyForRemittance() {
  return 'Ready for remittance';
}
function get_closeOutComplete() {
  return 'Complete';
}
function get_remittancesAmountColumn() {
  return 'Amount';
}
function get_closeOutPageTitle() {
  return 'Close Out Month';
}
function get_remittancesDatesColumn() {
  return 'Dates';
}
function get_remittanceVoided() {
  return 'Voided';
}
function get_remittanceReviewPageTitle() {
  return 'Review Remittance';
}
function remittanceReviewHeading(providerName) {
  return 'Review remittance: ' + providerName;
}
function remittanceProblemsHeading(count) {
  return count === 1 ? '1 placement cannot be priced' : '' + count + ' placements cannot be priced';
}
function remittanceIssueButton(amount) {
  return 'Issue ' + amount;
}
function get_remittanceIssueConfirmHeading() {
  return 'Issue this remittance?';
}
function get_remittanceIssueConfirmBody() {
  return 'Once issued, the amount is stored as what this provider is owed for the period and will not change.';
}
function get_remittanceIssueConfirmButton() {
  return 'Issue';
}
function get_remittanceDetailPageTitle() {
  return 'Remittance';
}
function get_remittanceStatusLabel() {
  return 'Status';
}
function get_remittanceIssuedAtLabel() {
  return 'Issued';
}
function get_remittanceAmountLabel() {
  return 'Amount';
}
function get_remittanceChildrenLabel() {
  return 'Children';
}
function get_remittanceDaysBilledLabel() {
  return 'Days billed';
}
function get_remittanceCostOfCareLabel() {
  return 'Cost of care';
}
function get_remittanceEmployerSharesLabel() {
  return 'Employer shares';
}
function get_remittanceGrantSharesLabel() {
  return 'Grant shares';
}
function get_remittanceFamilyPaysLabel() {
  return 'Family pays the location';
}
function get_remittanceTcgPaysLabel() {
  return 'TCG pays the provider';
}
function get_remittanceAdministrationLabel() {
  return 'Administration charges';
}
function get_remittanceDayAttendanceLabel() {
  return 'Attendance';
}
function get_remittanceDayProgramLabel() {
  return 'Program';
}
function get_remittanceAbsencesLabel() {
  return 'Absences';
}
function remittanceAbsencesValue(explained, unexplained) {
  return '' + (explained + unexplained | 0) + ' (' + explained + ' explained, ' + unexplained + ' unexplained)';
}
function get_remittanceChildTotalsHeading() {
  return 'Days by child';
}
function get_remittanceChildTotalsHint() {
  return 'Select a child to see their month.';
}
function get_remittanceChildColumn() {
  return 'Child';
}
function get_remittanceDaysColumn() {
  return 'Days';
}
function remittanceIntermittentColumn(careTime) {
  return careTime + ' intermittent';
}
function get_remittanceTransportOneWayColumn() {
  return 'Transport one way';
}
function get_remittanceTransportTwoWayColumn() {
  return 'Transport two way';
}
function get_remittanceExplainedAbsencesColumn() {
  return 'Explained absences';
}
function get_remittanceUnexplainedAbsencesColumn() {
  return 'Unexplained absences';
}
function get_remittanceFamilyPaysColumn() {
  return 'Family pays';
}
function get_remittanceTcgPaysColumn() {
  return 'TCG pays';
}
function get_remittanceGrandTotal() {
  return 'Grand total';
}
function get_remittanceOpenPlacementButton() {
  return 'Open placement';
}
function yearMonthDay(period) {
  // Inline function 'kotlin.takeUnless' call
  var this_0 = period.get_years_j1r3xp_k$();
  var tmp;
  if (!(this_0 === 0)) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = '' + tmp0_safe_receiver + ' years';
  }
  var tmp_1 = tmp_0;
  // Inline function 'kotlin.takeUnless' call
  var this_1 = period.get_months_gqmrjw_k$();
  var tmp_2;
  if (!(this_1 === 0)) {
    tmp_2 = this_1;
  } else {
    tmp_2 = null;
  }
  var tmp1_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp1_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = '' + tmp1_safe_receiver + ' months';
  }
  var tmp_4 = tmp_3;
  // Inline function 'kotlin.takeUnless' call
  var this_2 = period.days_1;
  var tmp_5;
  if (!(this_2 === 0)) {
    tmp_5 = this_2;
  } else {
    tmp_5 = null;
  }
  var tmp2_safe_receiver = tmp_5;
  var tmp_6;
  if (tmp2_safe_receiver == null) {
    tmp_6 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_6 = '' + tmp2_safe_receiver + ' days';
  }
  return joinToString(listOfNotNull([tmp_1, tmp_4, tmp_6]), ', ');
}
function get_surveyTakeSubmitButton() {
  return 'Submit answers';
}
function get_surveyTakeNeedAnswerToast() {
  return 'Answer at least one question first.';
}
function get_surveyTakeThanksToast() {
  return 'Thank you! Your answers have been recorded.';
}
function get_surveyTakeSavedToast() {
  return 'Answers saved. You can finish the rest later.';
}
function get_surveyOptionalLabel() {
  return '(optional)';
}
function get_surveyCompletedText() {
  return "You've completed this survey. Thank you!";
}
function get_surveyTakeAgainButton() {
  return 'Take it again';
}
function get_surveyAnsweringForLabel() {
  return 'Answering for';
}
function get_surveyLeadershipQuestion() {
  return 'Which of the following best describes your current leadership responsibilities at [company]?';
}
function get_surveyLeadershipManagesNoOne() {
  return "I don't manage anyone";
}
function get_surveyLeadershipManagesEmployees() {
  return 'I manage employees';
}
function get_surveyLeadershipManagesManagers() {
  return 'I manage employees who manage other employees';
}
function get_surveyLeadershipSeniorLeader() {
  return 'I am a senior leader in my organization';
}
function get_surveyIncomeQuestion() {
  return 'What is your approximate annual income at [company]?';
}
function get_surveyContinueButton() {
  return 'Continue';
}
function get_surveyLanguageLabel() {
  return 'Language';
}
var BaseStringsClass;
function BaseStrings() {
  if (BaseStringsClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'BaseStrings');
    BaseStringsClass = $;
  }
  return BaseStringsClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function StringsForLanguage$Companion$_anonymous__7esads() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.StringsForLanguage', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  StringsForLanguage_English_instance = new (StringsForLanguage())('English', 0);
  StringsForLanguage_Code_instance = new (StringsForLanguage$Code())();
  StringsForLanguage_Spanish_instance = new (StringsForLanguage$Spanish())();
  StringsForLanguage_Portuguese_instance = new (StringsForLanguage$Portuguese())();
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var StringsForLanguage_English_instance;
var StringsForLanguage$CodeClass;
function StringsForLanguage$Code() {
  if (StringsForLanguage$CodeClass === VOID) {
    class $ extends StringsForLanguage() {
      constructor() {
        super('Code', 1);
        StringsForLanguage_Code_instance = this;
      }
      get_navDashboardTitle_9up0g2_k$() {
        return 'navHomeTitle';
      }
      get_navFormulaLabTitle_ewi7uf_k$() {
        return 'navFormulaLabTitle';
      }
      get_navSignOutTitle_jmnskh_k$() {
        return 'navSignOutTitle';
      }
      get_navSwitchLanguageTitle_6fj9xq_k$() {
        return 'navSwitchLanguageTitle';
      }
      get_navProvidersTitle_oa0ysw_k$() {
        return 'navProvidersTitle';
      }
      get_navCareLocationsTitle_2k6n4r_k$() {
        return 'navCareLocationsTitle';
      }
      get_navEmployersTitle_5ougl6_k$() {
        return 'navEmployersTitle';
      }
      get_navGrantsTitle_6gc2p3_k$() {
        return 'navGrantsTitle';
      }
      get_navRemittancesTitle_qthgnx_k$() {
        return 'navRemittancesTitle';
      }
      get_navCloseOutTitle_69wx5k_k$() {
        return 'navCloseOutTitle';
      }
      get_navUsersTitle_3xs496_k$() {
        return 'navUsersTitle';
      }
      get_notificationsPromptTitle_6gox63_k$() {
        return 'notificationsPromptTitle';
      }
      get_notificationsPromptBody_22ny2t_k$() {
        return 'notificationsPromptBody';
      }
      get_notificationsPromptAllow_6r39bu_k$() {
        return 'notificationsPromptAllow';
      }
      get_crudGroupProgramTitle_ph6e0k_k$() {
        return 'crudGroupProgramTitle';
      }
      get_crudGroupNetworkTitle_o69yjm_k$() {
        return 'crudGroupNetworkTitle';
      }
      get_crudGroupFundingTitle_rkjttf_k$() {
        return 'crudGroupFundingTitle';
      }
      get_crudCancelButton_yk4tir_k$() {
        return 'crudCancelButton';
      }
      get_crudSaveButton_lsaoza_k$() {
        return 'crudSaveButton';
      }
      get_crudSavedToast_xnj03d_k$() {
        return 'crudSavedToast';
      }
      get_appTagline_r1snd6_k$() {
        return 'appTagline';
      }
      get_closurePaidLabel_brac2y_k$() {
        return 'closurePaidLabel';
      }
      get_closureUnpaidLabel_5pnjh9_k$() {
        return 'closureUnpaidLabel';
      }
      dateRangeOnwards_e67e9b_k$(start) {
        return 'dateRangeOnwards(' + start + ')';
      }
      get_exportCsvButton_84ycf9_k$() {
        return 'exportCsvButton';
      }
      get_goBackDescription_2wlgbo_k$() {
        return 'goBackDescription';
      }
      get_emptyRowText_pvodpf_k$() {
        return 'emptyRowText';
      }
      get_searchIconDescription_c0d0b6_k$() {
        return 'searchIconDescription';
      }
      get_validationInvalidPhoneMessage_cvge1e_k$() {
        return 'validationInvalidPhoneMessage';
      }
      get_validationInvalidEmailMessage_1bjpq8_k$() {
        return 'validationInvalidEmailMessage';
      }
      get_landingPageTitle_9rfr0l_k$() {
        return 'landingPageTitle';
      }
      get_loginPageTitle_1ofql3_k$() {
        return 'loginPageTitle';
      }
      get_loginPrompt_y6r4qs_k$() {
        return 'loginPrompt';
      }
      get_loginServerFieldLabel_24y76r_k$() {
        return 'loginServerFieldLabel';
      }
      get_homePageTitle_o7pge7_k$() {
        return 'homePageTitle';
      }
      get_homeEmptyStateMessage_lc9n17_k$() {
        return 'homeEmptyStateMessage';
      }
      get_homeApplicationsHeading_6tsmjb_k$() {
        return 'homeApplicationsHeading';
      }
      get_homeApplicationsIntro_9aamv3_k$() {
        return 'homeApplicationsIntro';
      }
      get_homeApplicationCardTitle_1x2b5s_k$() {
        return 'homeApplicationCardTitle';
      }
      get_homeProviderApplicationCardTitle_6vkqdt_k$() {
        return 'homeProviderApplicationCardTitle';
      }
      homeApplicationInvitedOn_fh8p3l_k$(date) {
        return 'homeApplicationInvitedOn(' + date + ')';
      }
      get_homeApplicationStatusActionNeeded_pm6rp_k$() {
        return 'homeApplicationStatusActionNeeded';
      }
      get_homeApplicationStatusSubmitted_7i53pd_k$() {
        return 'homeApplicationStatusSubmitted';
      }
      get_homeApplicationStatusApproved_5joi6n_k$() {
        return 'homeApplicationStatusApproved';
      }
      get_homeApplicationStatusRejected_z7mlvs_k$() {
        return 'homeApplicationStatusRejected';
      }
      get_homeApplicationStartButton_tv1v5g_k$() {
        return 'homeApplicationStartButton';
      }
      get_homeApplicationContinueButton_kfmgbj_k$() {
        return 'homeApplicationContinueButton';
      }
      get_checkVersionTitle_5bcopt_k$() {
        return 'checkVersionTitle';
      }
      checkVersionRequiredBody_la1fe1_k$(version) {
        return 'checkVersionRequiredBody(' + version + ')';
      }
      checkVersionOptionalBody_2r7vzs_k$(version) {
        return 'checkVersionOptionalBody(' + version + ')';
      }
      get_checkVersionOkButton_hri5kp_k$() {
        return 'checkVersionOkButton';
      }
      attendanceNeedsEntryMessage_grklld_k$(count) {
        return 'attendanceNeedsEntryMessage(' + count + ')';
      }
      get_submitAttendance_kcxskq_k$() {
        return 'attendanceSubmitButton';
      }
      get_attendanceChildScheduleColumnLabel_gdvgn7_k$() {
        return 'attendanceChildScheduleColumnLabel';
      }
      attendancePeriodPageTitle_p6ycjf_k$(period) {
        return 'attendancePeriodPageTitle(' + period + ')';
      }
      attendanceLocationLabel_w7cjz0_k$(name) {
        return 'attendanceLocationLabel(' + name + ')';
      }
      attendanceProviderLabel_uwtfq8_k$(name) {
        return 'attendanceProviderLabel(' + name + ')';
      }
      get_attendancePeriodLabel_4v4nxb_k$() {
        return 'attendancePeriodLabel';
      }
      get_attendanceChildrenScheduledLabel_ceetoo_k$() {
        return 'attendanceChildrenScheduledLabel';
      }
      get_attendanceStatusLabel_3q3usw_k$() {
        return 'attendanceStatusLabel';
      }
      get_attendanceStatusSubmitted_swmv6f_k$() {
        return 'attendanceStatusSubmitted';
      }
      get_attendanceStatusOpen_y91qpa_k$() {
        return 'attendanceStatusOpen';
      }
      get_attendancePeriodsPageTitle_1e29ef_k$() {
        return 'attendancePeriodsPageTitle';
      }
      attendancePeriodRange_42l3v7_k$(start, end) {
        return 'attendancePeriodRange(' + start + ', ' + end + ')';
      }
      get_attendanceClosuresHeading_1l8eiw_k$() {
        return 'attendanceClosuresHeading';
      }
      get_attendanceLocationColumnLabel_dz9caf_k$() {
        return 'attendanceLocationColumnLabel';
      }
      get_attendanceUnknownLocationLabel_l7955l_k$() {
        return 'attendanceUnknownLocationLabel';
      }
      get_attendanceSubmittedColumnLabel_fx9tt7_k$() {
        return 'attendanceSubmittedColumnLabel';
      }
      get_attendanceApprovedColumnLabel_lbrr5h_k$() {
        return 'attendanceApprovedColumnLabel';
      }
      get_attendanceStatusApproved_oxievv_k$() {
        return 'attendanceStatusApproved';
      }
      get_attendanceStatusPending_wf20oj_k$() {
        return 'attendanceStatusPending';
      }
      get_attendanceNotBegunMessage_a7k34b_k$() {
        return 'attendanceNotBegunMessage';
      }
      get_attendanceFilledToast_roztnx_k$() {
        return 'attendanceFilledToast';
      }
      get_attendanceTransportProvidedLabel_ghqywq_k$() {
        return 'attendanceTransportProvidedLabel';
      }
      get_attendanceTransportToCareLabel_ssvsgh_k$() {
        return 'attendanceTransportToCareLabel';
      }
      get_attendanceTransportFromCareLabel_elz7b2_k$() {
        return 'attendanceTransportFromCareLabel';
      }
      get_attendanceStateAttended_v3hons_k$() {
        return 'attendanceStateAttended';
      }
      get_attendanceStateExplainedAbsence_9yyv4q_k$() {
        return 'attendanceStateExplainedAbsence';
      }
      get_attendanceStateUnexplainedAbsence_uqoym9_k$() {
        return 'attendanceStateUnexplainedAbsence';
      }
      get_attendanceStateClosure_cr4gsc_k$() {
        return 'attendanceStateClosure';
      }
      get_attendanceStateNotScheduled_obpiih_k$() {
        return 'attendanceStateNotScheduled';
      }
      get_attendanceStateNotPlaced_4v4cr3_k$() {
        return 'attendanceStateNotPlaced';
      }
      get_attendanceStateNeedsEntry_c829o4_k$() {
        return 'attendanceStateNeedsEntry';
      }
      get_formulaTesterHeading_uddkg6_k$() {
        return 'formulaTesterHeading';
      }
      formulaResultLine_w5wyal_k$(result) {
        return 'formulaResultLine(' + result + ')';
      }
      get_locationNameLabel_iz62q3_k$() {
        return 'locationNameLabel';
      }
      get_locationAddressSectionTitle_ooy4vd_k$() {
        return 'locationAddressSectionTitle';
      }
      get_locationStreetAddressLabel_1akgf5_k$() {
        return 'locationStreetAddressLabel';
      }
      get_locationAptSuiteLabel_qtfjst_k$() {
        return 'locationAptSuiteLabel';
      }
      get_locationCityLabel_jq20et_k$() {
        return 'locationCityLabel';
      }
      get_locationStateLabel_vycy69_k$() {
        return 'locationStateLabel';
      }
      get_locationZipcodeLabel_ph92sc_k$() {
        return 'locationZipcodeLabel';
      }
      get_locationContactSectionTitle_jjah7v_k$() {
        return 'locationContactSectionTitle';
      }
      get_locationContactNameLabel_3ysqd5_k$() {
        return 'locationContactNameLabel';
      }
      get_locationContactEmailLabel_efzqw6_k$() {
        return 'locationContactEmailLabel';
      }
      get_locationContactPhoneLabel_4m2zrc_k$() {
        return 'locationContactPhoneLabel';
      }
      get_locationAddDialogTitle_cinmfn_k$() {
        return 'locationAddDialogTitle';
      }
      get_locationAddButton_95bquj_k$() {
        return 'locationAddButton';
      }
      get_locationAddedToast_8hz6sl_k$() {
        return 'locationAddedToast';
      }
      get_locationAddClosureButton_djcbau_k$() {
        return 'locationAddClosureButton';
      }
      get_locationDetailsSectionTitle_d2wrk9_k$() {
        return 'locationDetailsSectionTitle';
      }
      get_locationEditButton_aysohy_k$() {
        return 'locationEditButton';
      }
      get_locationProviderLabel_b4amqt_k$() {
        return 'locationProviderLabel';
      }
      get_locationActivePlacementsSectionTitle_nw2pyz_k$() {
        return 'locationActivePlacementsSectionTitle';
      }
      get_locationChildColumnLabel_8ikusg_k$() {
        return 'locationChildColumnLabel';
      }
      get_locationRateColumnLabel_aaazvk_k$() {
        return 'locationRateColumnLabel';
      }
      get_locationActiveDatesColumnLabel_f4guo3_k$() {
        return 'locationActiveDatesColumnLabel';
      }
      get_locationAgreementStatusColumnLabel_dddsdc_k$() {
        return 'locationAgreementStatusColumnLabel';
      }
      get_locationUnknownRateLabel_ltp6qw_k$() {
        return 'locationUnknownRateLabel';
      }
      get_locationNoEndDateLabel_1tfruy_k$() {
        return 'locationNoEndDateLabel';
      }
      locationDateRange_w0af9i_k$(start, end) {
        return 'locationDateRange(' + start + ', ' + end + ')';
      }
      get_locationSaveButton_pcmeoj_k$() {
        return 'locationSaveButton';
      }
      get_locationSavedToast_9rc1s2_k$() {
        return 'locationSavedToast';
      }
      get_locationsPageTitle_w1kct0_k$() {
        return 'locationsPageTitle';
      }
      locationDetailTitle_rl62c8_k$(name) {
        return 'locationDetailTitle(' + name + ')';
      }
      get_locationContactColumnLabel_7u4hlo_k$() {
        return 'locationContactColumnLabel';
      }
      get_locationPhoneColumnLabel_xybcky_k$() {
        return 'locationPhoneColumnLabel';
      }
      get_locationRatesHeading_uw7hbn_k$() {
        return 'locationRatesHeading';
      }
      get_locationAddRateButton_ve9lbf_k$() {
        return 'locationAddRateButton';
      }
      get_locationPrototypeColumnLabel_7abp2e_k$() {
        return 'locationPrototypeColumnLabel';
      }
      get_locationPlanLabel_xccdpp_k$() {
        return 'locationPlanLabel';
      }
      get_locationUnknownPlanLabel_i0kgn5_k$() {
        return 'locationUnknownPlanLabel';
      }
      get_locationAttendanceHeading_qbmfph_k$() {
        return 'locationAttendanceHeading';
      }
      get_locationAddAttendancePeriodButton_2ztszj_k$() {
        return 'locationAddAttendancePeriodButton';
      }
      get_locationPeriodNotSubmittedStatus_xdso1l_k$() {
        return 'locationPeriodNotSubmittedStatus';
      }
      get_locationPeriodNeedsApprovalStatus_1q9c99_k$() {
        return 'locationPeriodNeedsApprovalStatus';
      }
      get_locationClosureDateLabel_yxq7hz_k$() {
        return 'locationClosureDateLabel';
      }
      get_locationClosureKindColumnLabel_l2ckur_k$() {
        return 'locationClosureKindColumnLabel';
      }
      locationChooseMonthSubtext_17dav3_k$(locationName) {
        return 'locationChooseMonthSubtext(' + locationName + ')';
      }
      get_locationNoEligibleMonthsMessage_5awsde_k$() {
        return 'locationNoEligibleMonthsMessage';
      }
      get_locationClosureUmbrellaWarning_b148pn_k$() {
        return 'locationClosureUmbrellaWarning';
      }
      get_locationClosureSpecificLocationHint_htzknp_k$() {
        return 'locationClosureSpecificLocationHint';
      }
      get_locationClosureReasonLabel_jr4c1f_k$() {
        return 'locationClosureReasonLabel';
      }
      get_locationAddClosuresButton_8pcv03_k$() {
        return 'locationAddClosuresButton';
      }
      get_locationClosureAddedToast_kquvus_k$() {
        return 'locationClosureAddedToast';
      }
      get_locationPrototypeNameLabel_o3rt51_k$() {
        return 'locationPrototypeNameLabel';
      }
      get_locationSelectPlanPlaceholder_e7rncg_k$() {
        return 'locationSelectPlanPlaceholder';
      }
      get_locationRateAddedToast_4hcq1n_k$() {
        return 'locationRateAddedToast';
      }
      get_rateInForceFromLabel_hamky5_k$() {
        return 'rateInForceFromLabel';
      }
      get_rateLocationLabel_u8i4x6_k$() {
        return 'rateLocationLabel';
      }
      get_ratePlanLabel_6i1kny_k$() {
        return 'ratePlanLabel';
      }
      get_rateChangeButton_dchwaz_k$() {
        return 'rateChangeButton';
      }
      rateChangePlanTitle_kxriyt_k$(rateName) {
        return 'rateChangePlanTitle(' + rateName + ')';
      }
      get_rateStartingAtDateLabel_5za9na_k$() {
        return 'rateStartingAtDateLabel';
      }
      get_rateToRateLabel_vgzx2o_k$() {
        return 'rateToRateLabel';
      }
      rateChangeConfirmation_752i51_k$(targetName) {
        return 'rateChangeConfirmation(' + targetName + ')';
      }
      get_rateOnThisPlanSinceLabel_vdwh5j_k$() {
        return 'rateOnThisPlanSinceLabel';
      }
      get_rateCurrentRateHeading_hraq4y_k$() {
        return 'rateCurrentRateHeading';
      }
      get_rateLocationCurrentRateSubtext_i30vi_k$() {
        return 'rateLocationCurrentRateSubtext';
      }
      get_ratePlanCurrentRateSubtext_41xbk6_k$() {
        return 'ratePlanCurrentRateSubtext';
      }
      get_rateCurrentChip_ej3r0k_k$() {
        return 'rateCurrentChip';
      }
      rateInForceSince_kfs6_k$(range) {
        return 'rateInForceSince(' + range + ')';
      }
      get_rateHistoryHeading_245zkn_k$() {
        return 'rateHistoryHeading';
      }
      get_rateHistorySubtext_t3uw1u_k$() {
        return 'rateHistorySubtext';
      }
      get_rateInForceColumnLabel_elll5r_k$() {
        return 'rateInForceColumnLabel';
      }
      get_rateDailyRateColumnLabel_3eflwu_k$() {
        return 'rateDailyRateColumnLabel';
      }
      get_rateTemplatesPageTitle_qntbdl_k$() {
        return 'rateTemplatesPageTitle';
      }
      get_rateTemplatesHeading_o6frgy_k$() {
        return 'rateTemplatesHeading';
      }
      get_rateAddTemplateButton_h149ic_k$() {
        return 'rateAddTemplateButton';
      }
      get_rateNameColumnLabel_44vut2_k$() {
        return 'rateNameColumnLabel';
      }
      get_rateAddVersionButton_8qx842_k$() {
        return 'rateAddVersionButton';
      }
      get_rateVersionHistoryHeading_go8cgt_k$() {
        return 'rateVersionHistoryHeading';
      }
      get_rateVersionHistorySubtext_rd6t14_k$() {
        return 'rateVersionHistorySubtext';
      }
      get_rateNewVersionPageTitle_nfj0tk_k$() {
        return 'rateNewVersionPageTitle';
      }
      rateAddVersionHeading_xp6sun_k$(templateName) {
        return 'rateAddVersionHeading(' + templateName + ')';
      }
      get_rateTemplateNameHeading_spoi4s_k$() {
        return 'rateTemplateNameHeading';
      }
      get_rateNewVersionFormHeading_o52csj_k$() {
        return 'rateNewVersionFormHeading';
      }
      get_rateAddTemplateSubmitButton_psnajo_k$() {
        return 'rateAddTemplateSubmitButton';
      }
      get_rateVersionAddedToast_45ku6u_k$() {
        return 'rateVersionAddedToast';
      }
      get_rateNewTemplatePageTitle_o1z2rc_k$() {
        return 'rateNewTemplatePageTitle';
      }
      get_rateNewTemplateHeading_sdjtlb_k$() {
        return 'rateNewTemplateHeading';
      }
      get_rateNameLabel_kv7vnk_k$() {
        return 'rateNameLabel';
      }
      get_rateShortNameLabel_odyqae_k$() {
        return 'rateShortNameLabel';
      }
      get_rateAgeStartLabel_lia3xk_k$() {
        return 'rateAgeStartLabel';
      }
      get_rateAgeEndLabel_j1qosv_k$() {
        return 'rateAgeEndLabel';
      }
      get_rateTransportOneWayLabel_hbgejv_k$() {
        return 'rateTransportOneWayLabel';
      }
      get_rateTransportTwoWayLabel_x99pbj_k$() {
        return 'rateTransportTwoWayLabel';
      }
      get_rateCareTimeLabel_lijrzh_k$() {
        return 'rateCareTimeLabel';
      }
      get_rateAvailableAsIntermittentLabel_h1v0mn_k$() {
        return 'rateAvailableAsIntermittentLabel';
      }
      get_rateFirstVersionFormHeading_9520p9_k$() {
        return 'rateFirstVersionFormHeading';
      }
      get_rateTemplateAddedToast_3485d6_k$() {
        return 'rateTemplateAddedToast';
      }
      get_providerNameLabel_yl378x_k$() {
        return 'providerNameLabel';
      }
      get_providerContactLabel_6n76gi_k$() {
        return 'providerContactLabel';
      }
      get_providerContactNameLabel_l558ot_k$() {
        return 'providerContactNameLabel';
      }
      get_providerContactEmailLabel_lc4wv2_k$() {
        return 'providerContactEmailLabel';
      }
      get_providerContactPhoneLabel_umwegk_k$() {
        return 'providerContactPhoneLabel';
      }
      get_providerOffersTransportationLabel_8w5t13_k$() {
        return 'providerOffersTransportationLabel';
      }
      get_providerAddDialogHeading_873vsd_k$() {
        return 'providerAddDialogHeading';
      }
      get_providerAddButtonLabel_34jbj9_k$() {
        return 'providerAddButtonLabel';
      }
      get_providerAddedToast_i8f4wv_k$() {
        return 'providerAddedToast';
      }
      get_providerDetailsHeading_vbtsje_k$() {
        return 'providerDetailsHeading';
      }
      get_providerEditButtonDescription_6z204a_k$() {
        return 'providerEditButtonDescription';
      }
      get_providerYesLabel_su34fb_k$() {
        return 'providerYesLabel';
      }
      get_providerNoLabel_wn67vr_k$() {
        return 'providerNoLabel';
      }
      get_providerLocationsHeading_kilnxe_k$() {
        return 'providerLocationsHeading';
      }
      get_providerAddLocationButtonLabel_ny6cyi_k$() {
        return 'providerAddLocationButtonLabel';
      }
      get_providerCityLabel_2978ep_k$() {
        return 'providerCityLabel';
      }
      get_providerSaveButtonLabel_8m3k6t_k$() {
        return 'providerSaveButtonLabel';
      }
      get_providerSavedToast_yjdohm_k$() {
        return 'providerSavedToast';
      }
      get_providersPageTitle_5b613k_k$() {
        return 'providersPageTitle';
      }
      get_providerEmailLabel_uskhea_k$() {
        return 'providerEmailLabel';
      }
      get_providerPhoneLabel_l6gtxc_k$() {
        return 'providerPhoneLabel';
      }
      get_providerVendorNumberLabel_cg5mi1_k$() {
        return 'providerVendorNumberLabel';
      }
      get_providerVendorNumberNotSet_vxdl2y_k$() {
        return 'providerVendorNumberNotSet';
      }
      get_childAddDialogTitle_h9rjhe_k$() {
        return 'childAddDialogTitle';
      }
      get_childAddButton_woryww_k$() {
        return 'childAddButton';
      }
      get_childAddedToast_qv5dui_k$() {
        return 'childAddedToast';
      }
      get_childFirstNameLabel_nfb0t0_k$() {
        return 'childFirstNameLabel';
      }
      get_childLastNameLabel_9cmbcw_k$() {
        return 'childLastNameLabel';
      }
      get_childBirthDateLabel_57yy4m_k$() {
        return 'childBirthDateLabel';
      }
      get_childRaceEthnicityLabel_1rbvt3_k$() {
        return 'childRaceEthnicityLabel';
      }
      get_childNotesLabel_i49wca_k$() {
        return 'childNotesLabel';
      }
      get_childDetailsHeading_m3xz5f_k$() {
        return 'childDetailsHeading';
      }
      childFamilyNameSuffix_vnbngi_k$(familyName) {
        return 'childFamilyNameSuffix(' + familyName + ')';
      }
      get_childUnknownLabel_wvpdgd_k$() {
        return 'childUnknownLabel';
      }
      childBirthdateWithAge_961sp2_k$(birthDate, ageInMonths) {
        return 'childBirthdateWithAge(' + birthDate + ', ' + ageInMonths + ')';
      }
      get_childPlacementsHeading_tdetof_k$() {
        return 'childPlacementsHeading';
      }
      get_childTableHeaderLocation_z6m8z_k$() {
        return 'childTableHeaderLocation';
      }
      get_childTableHeaderRate_xtg0lk_k$() {
        return 'childTableHeaderRate';
      }
      get_childTableHeaderActiveDates_jvbf9l_k$() {
        return 'childTableHeaderActiveDates';
      }
      get_childTableHeaderAgreementStatus_cdpz04_k$() {
        return 'childTableHeaderAgreementStatus';
      }
      get_childUnknownLocationLabel_r43uzs_k$() {
        return 'childUnknownLocationLabel';
      }
      get_childUnknownProviderLabel_fsgzro_k$() {
        return 'childUnknownProviderLabel';
      }
      get_childUnknownRateLabel_o241ct_k$() {
        return 'childUnknownRateLabel';
      }
      get_childNoEndDateLabel_vluxrz_k$() {
        return 'childNoEndDateLabel';
      }
      get_childSaveButton_6zg7mm_k$() {
        return 'childSaveButton';
      }
      get_childSavedToast_8lu59v_k$() {
        return 'childSavedToast';
      }
      childPlacementDetailTitle_5imj30_k$(childName) {
        return 'childPlacementDetailTitle(' + childName + ')';
      }
      get_childPlacementDetailsHeading_q87f7y_k$() {
        return 'childPlacementDetailsHeading';
      }
      signatureStatusLabel_agp5cg_k$(status) {
        return 'signatureStatusLabel(' + toString(status) + ')';
      }
      get_childScheduleHeading_ybonig_k$() {
        return 'childScheduleHeading';
      }
      get_childScheduleTableHeaderDay_gbtbl7_k$() {
        return 'childScheduleTableHeaderDay';
      }
      get_childScheduleTableHeaderTime_8yqyxq_k$() {
        return 'childScheduleTableHeaderTime';
      }
      get_childScheduleTableHeaderIntermittent_1zk9ks_k$() {
        return 'childScheduleTableHeaderIntermittent';
      }
      get_childScheduleTableHeaderTransport_xh3sc8_k$() {
        return 'childScheduleTableHeaderTransport';
      }
      get_childNoLabel_jgme2o_k$() {
        return 'childNoLabel';
      }
      childTransportDescription_9po3ip_k$(transportFrom, transportTo) {
        return 'childTransportDescription(' + transportFrom + ', ' + transportTo + ')';
      }
      get_childrenListTitle_3nn3hu_k$() {
        return 'childrenListTitle';
      }
      get_childrenTableHeaderName_oazrcu_k$() {
        return 'childrenTableHeaderName';
      }
      get_childrenTableHeaderFamily_fhtlt5_k$() {
        return 'childrenTableHeaderFamily';
      }
      get_childrenTableHeaderBirthdate_iu407u_k$() {
        return 'childrenTableHeaderBirthdate';
      }
      get_placementNewTitle_31boj8_k$() {
        return 'placementNewTitle';
      }
      placementAddForChildTitle_tfmgtt_k$(childName) {
        return 'placementAddForChildTitle(' + childName + ')';
      }
      get_placementDetailsHeading_3qgx4s_k$() {
        return 'placementDetailsHeading';
      }
      get_placementCareLocationLabel_w1cbma_k$() {
        return 'placementCareLocationLabel';
      }
      get_placementSearchIconDescription_uuv8wx_k$() {
        return 'placementSearchIconDescription';
      }
      placementLocationWithProvider_dft4wy_k$(locationName, providerName) {
        return 'placementLocationWithProvider(' + locationName + ', ' + providerName + ')';
      }
      get_placementSelectCareLocationPlaceholder_zi5v79_k$() {
        return 'placementSelectCareLocationPlaceholder';
      }
      get_placementChooseCareLocationTitle_7rzjtt_k$() {
        return 'placementChooseCareLocationTitle';
      }
      get_placementNoCareLocationsMatch_lqc8l_k$() {
        return 'placementNoCareLocationsMatch';
      }
      get_placementStartDateLabel_lvccn4_k$() {
        return 'placementStartDateLabel';
      }
      get_placementEndDateLabel_oohsnt_k$() {
        return 'placementEndDateLabel';
      }
      get_placementFundingHeading_tzzalb_k$() {
        return 'placementFundingHeading';
      }
      get_placementPaidByGrantsLabel_y96mde_k$() {
        return 'placementPaidByGrantsLabel';
      }
      get_placementChooseGrantsTitle_w90u32_k$() {
        return 'placementChooseGrantsTitle';
      }
      get_placementSendForSignatureTitle_fzt0kl_k$() {
        return 'placementSendForSignatureTitle';
      }
      get_placementSendForSignatureBody_ualg6t_k$() {
        return 'placementSendForSignatureBody';
      }
      get_placementSaveAndSendButton_qp8w94_k$() {
        return 'placementSaveAndSendButton';
      }
      get_placementAddedToast_9n8dct_k$() {
        return 'placementAddedToast';
      }
      get_placementNoneSelectedLabel_ryp2xn_k$() {
        return 'placementNoneSelectedLabel';
      }
      get_placementNoOptionsFoundLabel_67d80d_k$() {
        return 'placementNoOptionsFoundLabel';
      }
      get_placementDoneButton_4je2q8_k$() {
        return 'placementDoneButton';
      }
      get_childEditButton_7edijz_k$() {
        return 'childEditButton';
      }
      get_childFamilyLabel_zden0d_k$() {
        return 'childFamilyLabel';
      }
      get_childBirthdateLabel_wo149m_k$() {
        return 'childBirthdateLabel';
      }
      get_childAddPlacementButton_ol20h5_k$() {
        return 'childAddPlacementButton';
      }
      get_childPlacementChildLabel_g8ybd6_k$() {
        return 'childPlacementChildLabel';
      }
      get_childPlacementProviderLabel_a3mqvj_k$() {
        return 'childPlacementProviderLabel';
      }
      get_childPlacementGrantsLabel_lannsl_k$() {
        return 'childPlacementGrantsLabel';
      }
      get_placementSearchLocationHint_kl76yo_k$() {
        return 'placementSearchLocationHint';
      }
      get_placementTransportFromLabel_xf7eqr_k$() {
        return 'placementTransportFromLabel';
      }
      get_placementTransportToLabel_ai59v0_k$() {
        return 'placementTransportToLabel';
      }
      get_placementSearchHint_64804r_k$() {
        return 'placementSearchHint';
      }
      get_childCopyPlacementButton_2566k1_k$() {
        return 'childCopyPlacementButton';
      }
      get_placementChangeEndButton_9y5npd_k$() {
        return 'placementChangeEndButton';
      }
      get_placementEndReasonLabel_2y0sr5_k$() {
        return 'placementEndReasonLabel';
      }
      get_placementEndReasonPlaceholder_rzs88g_k$() {
        return 'placementEndReasonPlaceholder';
      }
      get_placementEndReasonNotesLabel_6gz5fa_k$() {
        return 'placementEndReasonNotesLabel';
      }
      get_childPlacementAgreementLabel_a4ki58_k$() {
        return 'childPlacementAgreementLabel';
      }
      get_childPlacementAgreementNoneSet_y46u4u_k$() {
        return 'childPlacementAgreementNoneSet';
      }
      get_childNotScheduledLabel_mg5553_k$() {
        return 'childNotScheduledLabel';
      }
      get_placementWhenSchoolIsOutLabel_som316_k$() {
        return 'placementWhenSchoolIsOutLabel';
      }
      get_placementNotIntermittentLabel_4hk03a_k$() {
        return 'placementNotIntermittentLabel';
      }
      placementPreviousEndChangeMessage_u9z0qq_k$(previousEnd, cutoff, newStart) {
        return 'placementPreviousEndChangeMessage(' + previousEnd + ', ' + cutoff + ', ' + newStart + ')';
      }
      get_familyFirstNameLabel_j5nup2_k$() {
        return 'familyFirstNameLabel';
      }
      get_familyLastNameLabel_slk1mi_k$() {
        return 'familyLastNameLabel';
      }
      get_familyPhoneNumberLabel_28h2zu_k$() {
        return 'familyPhoneNumberLabel';
      }
      get_familyAlternatePhoneLabel_sqbdsj_k$() {
        return 'familyAlternatePhoneLabel';
      }
      get_familyEmailLabel_ow4s1n_k$() {
        return 'familyEmailLabel';
      }
      get_familyPreferredLanguageLabel_sqcw94_k$() {
        return 'familyPreferredLanguageLabel';
      }
      get_familyRaceEthnicityLabel_z00d2r_k$() {
        return 'familyRaceEthnicityLabel';
      }
      get_familyAddSecondParentLabel_6zuz7m_k$() {
        return 'familyAddSecondParentLabel';
      }
      get_familyAddressLabel_jhvmgd_k$() {
        return 'familyAddressLabel';
      }
      get_familyStreetAddressLabel_hc5wvk_k$() {
        return 'familyStreetAddressLabel';
      }
      get_familyAptSuiteLabel_c6ev78_k$() {
        return 'familyAptSuiteLabel';
      }
      get_familyCityLabel_9p20yk_k$() {
        return 'familyCityLabel';
      }
      get_familyStateLabel_kkdf00_k$() {
        return 'familyStateLabel';
      }
      get_familyZipcodeLabel_v3fgfh_k$() {
        return 'familyZipcodeLabel';
      }
      get_familyAnnualIncomeLabel_nsky2p_k$() {
        return 'familyAnnualIncomeLabel';
      }
      get_familySizeLabel_ytosca_k$() {
        return 'familySizeLabel';
      }
      get_familyPreferNotToSayLabel_t7jcq_k$() {
        return 'familyPreferNotToSayLabel';
      }
      familyDetailTitle_gwlhpl_k$(familyName) {
        return 'familyDetailTitle(' + familyName + ')';
      }
      get_familyDetailsSectionTitle_mepryw_k$() {
        return 'familyDetailsSectionTitle';
      }
      get_familyEditIconDescription_ebeqi4_k$() {
        return 'familyEditIconDescription';
      }
      get_familyPrimaryParentLabel_xb85ed_k$() {
        return 'familyPrimaryParentLabel';
      }
      get_familyPrimaryEmailLabel_sxbo19_k$() {
        return 'familyPrimaryEmailLabel';
      }
      get_familyPrimaryPhoneLabel_n1pnad_k$() {
        return 'familyPrimaryPhoneLabel';
      }
      get_familyPrimaryAlternatePhoneLabel_l533dh_k$() {
        return 'familyPrimaryAlternatePhoneLabel';
      }
      get_familySecondaryParentLabel_xd744d_k$() {
        return 'familySecondaryParentLabel';
      }
      get_familySecondaryEmailLabel_1kj0yn_k$() {
        return 'familySecondaryEmailLabel';
      }
      get_familySecondaryPhoneLabel_kmlrm5_k$() {
        return 'familySecondaryPhoneLabel';
      }
      get_familySecondaryAlternatePhoneLabel_rncxqf_k$() {
        return 'familySecondaryAlternatePhoneLabel';
      }
      get_familyInformationVerifiedLabel_5tuhwz_k$() {
        return 'familyInformationVerifiedLabel';
      }
      get_familyNotVerifiedLabel_31381m_k$() {
        return 'familyNotVerifiedLabel';
      }
      get_familyChildrenSectionTitle_2sss81_k$() {
        return 'familyChildrenSectionTitle';
      }
      get_familyAddChildButton_udkhcq_k$() {
        return 'familyAddChildButton';
      }
      get_familyNameColumnLabel_yh58ca_k$() {
        return 'familyNameColumnLabel';
      }
      get_familyBirthdateAgeColumnLabel_djfnz5_k$() {
        return 'familyBirthdateAgeColumnLabel';
      }
      get_familyActivePlacementColumnLabel_repll8_k$() {
        return 'familyActivePlacementColumnLabel';
      }
      familyPlacementSummary_u4ho0l_k$(provider, location, status) {
        return 'familyPlacementSummary(' + provider + ', ' + location + ', ' + status + ')';
      }
      get_familySaveFamilyButton_40ppb4_k$() {
        return 'familySaveFamilyButton';
      }
      get_familySavedToast_l5bkyb_k$() {
        return 'familySavedToast';
      }
      get_familyListTitle_7vfhpp_k$() {
        return 'familyListTitle';
      }
      get_familyAddFamilyButton_qgzmly_k$() {
        return 'familyAddFamilyButton';
      }
      get_familyColumnLabel_vxra7j_k$() {
        return 'familyColumnLabel';
      }
      get_familyCityColumnLabel_bqfeje_k$() {
        return 'familyCityColumnLabel';
      }
      get_familyNewFamilyTitle_u18ivz_k$() {
        return 'familyNewFamilyTitle';
      }
      get_familyAddPageTitle_rl7n91_k$() {
        return 'familyAddPageTitle';
      }
      get_familyAddedToast_2w0cdo_k$() {
        return 'familyAddedToast';
      }
      get_familyApplicationListTitle_c6ygp5_k$() {
        return 'familyApplicationListTitle';
      }
      get_familyApplicationColumnSentTo_7zvbzg_k$() {
        return 'familyApplicationColumnSentTo';
      }
      get_familyApplicationColumnEmployer_c2b99w_k$() {
        return 'familyApplicationColumnEmployer';
      }
      get_familyApplicationColumnStatus_87vyuj_k$() {
        return 'familyApplicationColumnStatus';
      }
      get_familyApplicationColumnInvitedAt_esy33p_k$() {
        return 'familyApplicationColumnInvitedAt';
      }
      familyApplicationDetailTitle_7az5kv_k$(sentTo) {
        return 'familyApplicationDetailTitle(' + sentTo + ')';
      }
      get_familyApplicationSentToLabel_u2by72_k$() {
        return 'familyApplicationSentToLabel';
      }
      get_familyApplicationEmployerLabel_w3sr2u_k$() {
        return 'familyApplicationEmployerLabel';
      }
      get_familyApplicationStatusLabel_3spxtr_k$() {
        return 'familyApplicationStatusLabel';
      }
      get_familyApplicationNotSubmittedLabel_1cvz7t_k$() {
        return 'familyApplicationNotSubmittedLabel';
      }
      get_familyApplicationApproveButton_w2gak_k$() {
        return 'familyApplicationApproveButton';
      }
      get_familyApplicationApproveConfirmHeading_oqxjis_k$() {
        return 'familyApplicationApproveConfirmHeading';
      }
      get_familyApplicationApproveConfirmBody_j98ydk_k$() {
        return 'familyApplicationApproveConfirmBody';
      }
      get_familyApplicationApprovedToast_ghct71_k$() {
        return 'familyApplicationApprovedToast';
      }
      get_familyApplicationRejectedToast_5xw86e_k$() {
        return 'familyApplicationRejectedToast';
      }
      get_providerApplicationListTitle_52jvb0_k$() {
        return 'providerApplicationListTitle';
      }
      get_providerApplicationColumnSentTo_l9kj27_k$() {
        return 'providerApplicationColumnSentTo';
      }
      get_providerApplicationColumnInvitedAt_xa4eri_k$() {
        return 'providerApplicationColumnInvitedAt';
      }
      get_providerApplicationColumnStatus_lhl5xa_k$() {
        return 'providerApplicationColumnStatus';
      }
      providerApplicationDetailTitle_7oej8u_k$(sentTo) {
        return 'providerApplicationDetailTitle(' + sentTo + ')';
      }
      get_providerApplicationSentToLabel_fc0az9_k$() {
        return 'providerApplicationSentToLabel';
      }
      get_providerApplicationStatusLabel_tfhqmk_k$() {
        return 'providerApplicationStatusLabel';
      }
      get_providerApplicationNotSubmittedLabel_wjkrfa_k$() {
        return 'providerApplicationNotSubmittedLabel';
      }
      get_providerApplicationApproveButton_dxws6v_k$() {
        return 'providerApplicationApproveButton';
      }
      get_providerApplicationApproveConfirmHeading_ifddmh_k$() {
        return 'providerApplicationApproveConfirmHeading';
      }
      get_providerApplicationApproveConfirmBody_o3mmdn_k$() {
        return 'providerApplicationApproveConfirmBody';
      }
      get_providerApplicationApprovedToast_1ndkpm_k$() {
        return 'providerApplicationApprovedToast';
      }
      get_providerApplicationRejectedToast_8w30b1_k$() {
        return 'providerApplicationRejectedToast';
      }
      get_employerNameLabel_rr9lvp_k$() {
        return 'employerNameLabel';
      }
      get_employerContactLabel_f0mfyw_k$() {
        return 'employerContactLabel';
      }
      get_employerContactNameLabel_h6hpwz_k$() {
        return 'employerContactNameLabel';
      }
      get_employerContactEmailLabel_245yvo_k$() {
        return 'employerContactEmailLabel';
      }
      get_employerContactPhoneLabel_l68pj6_k$() {
        return 'employerContactPhoneLabel';
      }
      get_employerEmailColumnLabel_siw8re_k$() {
        return 'employerEmailColumnLabel';
      }
      get_employerPhoneColumnLabel_nv3puc_k$() {
        return 'employerPhoneColumnLabel';
      }
      get_employerBillingAddressLabel_ppg2x_k$() {
        return 'employerBillingAddressLabel';
      }
      get_employerAddBillingAddressLabel_f9xuim_k$() {
        return 'employerAddBillingAddressLabel';
      }
      get_employerBillingContactLabel_g1s2i3_k$() {
        return 'employerBillingContactLabel';
      }
      get_employerBillingContactNameLabel_2furfk_k$() {
        return 'employerBillingContactNameLabel';
      }
      get_employerStreetAddressLabel_hfp9k7_k$() {
        return 'employerStreetAddressLabel';
      }
      get_employerAptSuiteLabel_72k85f_k$() {
        return 'employerAptSuiteLabel';
      }
      get_employerCityLabel_axyh97_k$() {
        return 'employerCityLabel';
      }
      get_employerStateLabel_k0y83r_k$() {
        return 'employerStateLabel';
      }
      get_employerZipcodeLabel_ioxwh6_k$() {
        return 'employerZipcodeLabel';
      }
      get_employerAddDialogHeading_48gd0j_k$() {
        return 'employerAddDialogHeading';
      }
      get_employerAddButton_d87ox_k$() {
        return 'employerAddButton';
      }
      get_employerAddedToast_3ffj9x_k$() {
        return 'employerAddedToast';
      }
      get_employerDetailsHeading_ytinek_k$() {
        return 'employerDetailsHeading';
      }
      get_employerEditButtonDescription_ojdqak_k$() {
        return 'employerEditButtonDescription';
      }
      get_employerActiveLabel_isbluy_k$() {
        return 'employerActiveLabel';
      }
      get_employerYesLabel_5tbbwv_k$() {
        return 'employerYesLabel';
      }
      get_employerNoLabel_ue8l8v_k$() {
        return 'employerNoLabel';
      }
      get_employerBalanceLabel_le7jmk_k$() {
        return 'employerBalanceLabel';
      }
      get_employerBalanceNotSynced_t35ga3_k$() {
        return 'employerBalanceNotSynced';
      }
      get_employerRatesHeading_d9zhxv_k$() {
        return 'employerRatesHeading';
      }
      get_employerRatesSubtext_urfnk2_k$() {
        return 'employerRatesSubtext';
      }
      get_employerAddNewRateButton_3qdhmd_k$() {
        return 'employerAddNewRateButton';
      }
      get_employerShareOfDayLabel_l9g9iu_k$() {
        return 'employerShareOfDayLabel';
      }
      get_employerShareColumnLabel_p5bseb_k$() {
        return 'employerShareColumnLabel';
      }
      get_employerAdministrationColumnLabel_s4ljqc_k$() {
        return 'employerAdministrationColumnLabel';
      }
      get_employerSaveButton_xr2x83_k$() {
        return 'employerSaveButton';
      }
      get_employerSavedToast_loqruk_k$() {
        return 'employerSavedToast';
      }
      get_employerNewRatePageTitle_lgm6tv_k$() {
        return 'employerNewRatePageTitle';
      }
      employerAddRateHeading_yj9ltq_k$(employerName) {
        return 'employerAddRateHeading(' + employerName + ')';
      }
      get_employerAddRateButton_bne9o1_k$() {
        return 'employerAddRateButton';
      }
      get_employerRateAddedToast_vme6ol_k$() {
        return 'employerRateAddedToast';
      }
      get_userNameLabel_jnppqj_k$() {
        return 'userNameLabel';
      }
      get_userEmailLabel_3oltlg_k$() {
        return 'userEmailLabel';
      }
      get_userPhoneLabel_fdgx22_k$() {
        return 'userPhoneLabel';
      }
      get_userRoleLabel_yi9o5y_k$() {
        return 'userRoleLabel';
      }
      get_userDetailsSectionTitle_o8ze3l_k$() {
        return 'userDetailsSectionTitle';
      }
      get_userEditIconDescription_a205ej_k$() {
        return 'userEditIconDescription';
      }
      get_grantNameLabel_7luufe_k$() {
        return 'grantNameLabel';
      }
      get_grantFunderLabel_2sx24x_k$() {
        return 'grantFunderLabel';
      }
      get_grantAwardPeriodLabel_m5ymnd_k$() {
        return 'grantAwardPeriodLabel';
      }
      get_grantStartDateLabel_la3b0p_k$() {
        return 'grantStartDateLabel';
      }
      get_grantAddEndDateLabel_xwlt5z_k$() {
        return 'grantAddEndDateLabel';
      }
      get_grantEndDateLabel_vuktgi_k$() {
        return 'grantEndDateLabel';
      }
      get_grantAddDialogHeading_vr5wfo_k$() {
        return 'grantAddDialogHeading';
      }
      get_grantAddButton_zardz4_k$() {
        return 'grantAddButton';
      }
      get_grantAddedToast_y9kr6u_k$() {
        return 'grantAddedToast';
      }
      get_grantDetailsHeading_4bpyr7_k$() {
        return 'grantDetailsHeading';
      }
      get_grantEditButtonDescription_abff03_k$() {
        return 'grantEditButtonDescription';
      }
      get_grantBalanceLabel_6ku5mz_k$() {
        return 'grantBalanceLabel';
      }
      get_grantBalanceNotSynced_ef929w_k$() {
        return 'grantBalanceNotSynced';
      }
      get_grantRatesHeading_1jdw1q_k$() {
        return 'grantRatesHeading';
      }
      get_grantRatesSubtext_pgb0fh_k$() {
        return 'grantRatesSubtext';
      }
      get_grantAddNewRateButton_nsc1ss_k$() {
        return 'grantAddNewRateButton';
      }
      get_grantShareOfDayLabel_f9y45h_k$() {
        return 'grantShareOfDayLabel';
      }
      get_grantShareColumnLabel_2ddr0u_k$() {
        return 'grantShareColumnLabel';
      }
      get_grantSaveButton_2wxpb6_k$() {
        return 'grantSaveButton';
      }
      get_grantSavedToast_ii827n_k$() {
        return 'grantSavedToast';
      }
      get_grantNewRatePageTitle_m1sbq4_k$() {
        return 'grantNewRatePageTitle';
      }
      grantAddRateHeading_rhf7ur_k$(grantName) {
        return 'grantAddRateHeading(' + grantName + ')';
      }
      get_grantAddRateButton_q9v2io_k$() {
        return 'grantAddRateButton';
      }
      get_grantRateAddedToast_7iufh6_k$() {
        return 'grantRateAddedToast';
      }
      get_remittancesPageTitle_yno01p_k$() {
        return 'remittancesPageTitle';
      }
      get_remittancesPreviousMonthDescription_c46s75_k$() {
        return 'remittancesPreviousMonthDescription';
      }
      get_remittancesNextMonthDescription_472mkb_k$() {
        return 'remittancesNextMonthDescription';
      }
      get_remittancesProviderColumn_b68mq5_k$() {
        return 'remittancesProviderColumn';
      }
      get_remittancesStatusColumn_9ruzm4_k$() {
        return 'remittancesStatusColumn';
      }
      get_closeOutAttendanceIncomplete_qvityy_k$() {
        return 'closeOutAttendanceIncomplete';
      }
      get_closeOutAttendanceReviewNeeded_5v2tud_k$() {
        return 'closeOutAttendanceReviewNeeded';
      }
      get_closeOutReadyForRemittance_zhgfk3_k$() {
        return 'closeOutReadyForRemittance';
      }
      get_closeOutComplete_hpmhjs_k$() {
        return 'closeOutComplete';
      }
      get_remittancesAmountColumn_vm5mg6_k$() {
        return 'remittancesAmountColumn';
      }
      get_closeOutPageTitle_igqf2i_k$() {
        return 'closeOutPageTitle';
      }
      get_remittancesDatesColumn_sy3n9t_k$() {
        return 'remittancesDatesColumn';
      }
      get_remittanceVoided_7coapm_k$() {
        return 'remittanceVoided';
      }
      get_remittanceReviewPageTitle_w5gryu_k$() {
        return 'remittanceReviewPageTitle';
      }
      remittanceReviewHeading_bk4mmq_k$(providerName) {
        return 'remittanceReviewHeading(' + providerName + ')';
      }
      remittanceProblemsHeading_lc0nvc_k$(count) {
        return 'remittanceProblemsHeading(' + count + ')';
      }
      remittanceIssueButton_tu58r7_k$(amount) {
        return 'remittanceIssueButton(' + amount + ')';
      }
      get_remittanceIssueConfirmHeading_bxfsjw_k$() {
        return 'remittanceIssueConfirmHeading';
      }
      get_remittanceIssueConfirmBody_1w6k7k_k$() {
        return 'remittanceIssueConfirmBody';
      }
      get_remittanceIssueConfirmButton_qtcw1s_k$() {
        return 'remittanceIssueConfirmButton';
      }
      get_remittanceDetailPageTitle_pimg0h_k$() {
        return 'remittanceDetailPageTitle';
      }
      get_remittanceStatusLabel_ozb6h1_k$() {
        return 'remittanceStatusLabel';
      }
      get_remittanceIssuedAtLabel_sk6ikx_k$() {
        return 'remittanceIssuedAtLabel';
      }
      get_remittanceAmountLabel_u9neaz_k$() {
        return 'remittanceAmountLabel';
      }
      get_remittanceChildrenLabel_g31cj6_k$() {
        return 'remittanceChildrenLabel';
      }
      get_remittanceDaysBilledLabel_iaro0g_k$() {
        return 'remittanceDaysBilledLabel';
      }
      get_remittanceCostOfCareLabel_pxj9qw_k$() {
        return 'remittanceCostOfCareLabel';
      }
      get_remittanceEmployerSharesLabel_p173b2_k$() {
        return 'remittanceEmployerSharesLabel';
      }
      get_remittanceGrantSharesLabel_3d2smj_k$() {
        return 'remittanceGrantSharesLabel';
      }
      get_remittanceFamilyPaysLabel_f1jlxa_k$() {
        return 'remittanceFamilyPaysLabel';
      }
      get_remittanceTcgPaysLabel_z6hcxk_k$() {
        return 'remittanceTcgPaysLabel';
      }
      get_remittanceAdministrationLabel_spr4f_k$() {
        return 'remittanceAdministrationLabel';
      }
      get_remittanceDayAttendanceLabel_y52ora_k$() {
        return 'remittanceDayAttendanceLabel';
      }
      get_remittanceDayProgramLabel_7icdid_k$() {
        return 'remittanceDayProgramLabel';
      }
      get_surveyTakeSubmitButton_gkww0k_k$() {
        return 'surveyTakeSubmitButton';
      }
      get_surveyTakeNeedAnswerToast_561g7r_k$() {
        return 'surveyTakeNeedAnswerToast';
      }
      get_surveyTakeThanksToast_6r9hqk_k$() {
        return 'surveyTakeThanksToast';
      }
      get_surveyTakeSavedToast_evm8s6_k$() {
        return 'surveyTakeSavedToast';
      }
      get_surveyOptionalLabel_i973rl_k$() {
        return 'surveyOptionalLabel';
      }
      get_surveyCompletedText_anx46t_k$() {
        return 'surveyCompletedText';
      }
      get_surveyTakeAgainButton_c6h420_k$() {
        return 'surveyTakeAgainButton';
      }
      get_surveyAnsweringForLabel_wb231w_k$() {
        return 'surveyAnsweringForLabel';
      }
      get_surveyLeadershipQuestion_pd6bg2_k$() {
        return 'surveyLeadershipQuestion';
      }
      get_surveyLeadershipManagesNoOne_4fq5q9_k$() {
        return 'surveyLeadershipManagesNoOne';
      }
      get_surveyLeadershipManagesEmployees_jcz2fz_k$() {
        return 'surveyLeadershipManagesEmployees';
      }
      get_surveyLeadershipManagesManagers_3jp6do_k$() {
        return 'surveyLeadershipManagesManagers';
      }
      get_surveyLeadershipSeniorLeader_he8vsv_k$() {
        return 'surveyLeadershipSeniorLeader';
      }
      get_surveyIncomeQuestion_em6voy_k$() {
        return 'surveyIncomeQuestion';
      }
      get_surveyContinueButton_w6kl50_k$() {
        return 'surveyContinueButton';
      }
      get_surveyLanguageLabel_fcb89_k$() {
        return 'surveyLanguageLabel';
      }
      get_remittanceAbsencesLabel_s31xd5_k$() {
        return 'remittanceAbsencesLabel';
      }
      remittanceAbsencesValue_hrzn9f_k$(explained, unexplained) {
        return 'remittanceAbsencesValue(' + explained + ', ' + unexplained + ')';
      }
      get_remittanceChildTotalsHeading_ish2aq_k$() {
        return 'remittanceChildTotalsHeading';
      }
      get_remittanceChildTotalsHint_sqdm97_k$() {
        return 'remittanceChildTotalsHint';
      }
      get_remittanceChildColumn_w7inzf_k$() {
        return 'remittanceChildColumn';
      }
      get_remittanceDaysColumn_y81ogk_k$() {
        return 'remittanceDaysColumn';
      }
      remittanceIntermittentColumn_diw8ct_k$(careTime) {
        return 'remittanceIntermittentColumn(' + careTime + ')';
      }
      get_remittanceTransportOneWayColumn_7s8g1t_k$() {
        return 'remittanceTransportOneWayColumn';
      }
      get_remittanceTransportTwoWayColumn_2m8bh7_k$() {
        return 'remittanceTransportTwoWayColumn';
      }
      get_remittanceExplainedAbsencesColumn_949z39_k$() {
        return 'remittanceExplainedAbsencesColumn';
      }
      get_remittanceUnexplainedAbsencesColumn_7oks0u_k$() {
        return 'remittanceUnexplainedAbsencesColumn';
      }
      get_remittanceFamilyPaysColumn_yxf9kk_k$() {
        return 'remittanceFamilyPaysColumn';
      }
      get_remittanceTcgPaysColumn_l2qjv6_k$() {
        return 'remittanceTcgPaysColumn';
      }
      get_remittanceGrandTotal_q37hep_k$() {
        return 'remittanceGrandTotal';
      }
      get_remittanceOpenPlacementButton_cb7i92_k$() {
        return 'remittanceOpenPlacementButton';
      }
    }
    initMetadataForClass($, 'Code');
    StringsForLanguage$CodeClass = $;
  }
  return StringsForLanguage$CodeClass;
}
var StringsForLanguage_Code_instance;
var StringsForLanguage$SpanishClass;
function StringsForLanguage$Spanish() {
  if (StringsForLanguage$SpanishClass === VOID) {
    class $ extends StringsForLanguage() {
      constructor() {
        super('Spanish', 2);
        StringsForLanguage_Spanish_instance = this;
      }
      get_navDashboardTitle_9up0g2_k$() {
        return 'Inicio';
      }
      get_navFormulaLabTitle_ewi7uf_k$() {
        return 'Laboratorio de f\xF3rmulas';
      }
      get_navSignOutTitle_jmnskh_k$() {
        return 'Cerrar sesi\xF3n';
      }
      get_navSwitchLanguageTitle_6fj9xq_k$() {
        return 'Cambiar idioma';
      }
      get_navProvidersTitle_oa0ysw_k$() {
        return 'Proveedores (UMB)';
      }
      get_navCareLocationsTitle_2k6n4r_k$() {
        return 'Centros de cuidado';
      }
      get_navEmployersTitle_5ougl6_k$() {
        return 'Empleadores';
      }
      get_navGrantsTitle_6gc2p3_k$() {
        return 'Subvenciones';
      }
      get_navRemittancesTitle_qthgnx_k$() {
        return 'Remesas';
      }
      get_navCloseOutTitle_69wx5k_k$() {
        return 'Cerrar mes';
      }
      get_navUsersTitle_3xs496_k$() {
        return 'Usuarios';
      }
      get_notificationsPromptTitle_6gox63_k$() {
        return '\xBFEnviar notificaciones?';
      }
      get_notificationsPromptBody_22ny2t_k$() {
        return 'La Herramienta de Datos de Vales de Cuidado Infantil de TCG desea enviarte notificaciones.';
      }
      get_notificationsPromptAllow_6r39bu_k$() {
        return 'Permitir';
      }
      get_crudGroupProgramTitle_ph6e0k_k$() {
        return 'Programa';
      }
      get_crudGroupNetworkTitle_o69yjm_k$() {
        return 'Red';
      }
      get_crudGroupFundingTitle_rkjttf_k$() {
        return 'Financiamiento';
      }
      get_crudCancelButton_yk4tir_k$() {
        return 'Cancelar';
      }
      get_crudSaveButton_lsaoza_k$() {
        return 'Guardar';
      }
      get_crudSavedToast_xnj03d_k$() {
        return 'Guardado';
      }
      get_appTagline_r1snd6_k$() {
        return 'Herramienta de Datos de Vales de Cuidado Infantil de TCG';
      }
      get_closurePaidLabel_brac2y_k$() {
        return 'Pagado';
      }
      get_closureUnpaidLabel_5pnjh9_k$() {
        return 'No pagado';
      }
      dateRangeOnwards_e67e9b_k$(start) {
        return start + ' en adelante';
      }
      get_exportCsvButton_84ycf9_k$() {
        return 'Exportar CSV';
      }
      get_goBackDescription_2wlgbo_k$() {
        return 'Volver';
      }
      get_emptyRowText_pvodpf_k$() {
        return 'Nada que mostrar';
      }
      get_searchIconDescription_c0d0b6_k$() {
        return 'Buscar';
      }
      get_validationInvalidPhoneMessage_cvge1e_k$() {
        return 'No es un n\xFAmero de tel\xE9fono v\xE1lido';
      }
      get_validationInvalidEmailMessage_1bjpq8_k$() {
        return 'No es un correo electr\xF3nico v\xE1lido';
      }
      get_landingPageTitle_9rfr0l_k$() {
        return 'Cargando';
      }
      get_loginPageTitle_1ofql3_k$() {
        return 'Iniciar sesi\xF3n';
      }
      get_loginPrompt_y6r4qs_k$() {
        return 'Inicia sesi\xF3n para comenzar';
      }
      get_loginServerFieldLabel_24y76r_k$() {
        return 'Servidor';
      }
      get_homePageTitle_o7pge7_k$() {
        return 'Inicio';
      }
      get_homeEmptyStateMessage_lc9n17_k$() {
        return 'No hay nada aqu\xED por ahora. Vuelve a consultar m\xE1s tarde.';
      }
      get_homeApplicationsHeading_6tsmjb_k$() {
        return 'Tus Solicitudes';
      }
      get_homeApplicationsIntro_9aamv3_k$() {
        return 'Ha sido invitado a solicitar asistencia de cuidado infantil. Complete su solicitud a continuaci\xF3n para comenzar.';
      }
      get_homeApplicationCardTitle_1x2b5s_k$() {
        return 'Solicitud de Asistencia de Cuidado Infantil';
      }
      get_homeProviderApplicationCardTitle_6vkqdt_k$() {
        return 'Solicitud de Proveedor de Cuidado';
      }
      homeApplicationInvitedOn_fh8p3l_k$(date) {
        return 'Invitado el ' + date;
      }
      get_homeApplicationStatusActionNeeded_pm6rp_k$() {
        return 'Acci\xF3n requerida';
      }
      get_homeApplicationStatusSubmitted_7i53pd_k$() {
        return 'Enviada';
      }
      get_homeApplicationStatusApproved_5joi6n_k$() {
        return 'Aprobada';
      }
      get_homeApplicationStatusRejected_z7mlvs_k$() {
        return 'No aprobada';
      }
      get_homeApplicationStartButton_tv1v5g_k$() {
        return 'Comenzar solicitud';
      }
      get_homeApplicationContinueButton_kfmgbj_k$() {
        return 'Ver solicitud';
      }
      get_checkVersionTitle_5bcopt_k$() {
        return 'Nueva versi\xF3n disponible';
      }
      checkVersionRequiredBody_la1fe1_k$(version) {
        return 'Hemos publicado la versi\xF3n ' + version + ' con actualizaciones importantes necesarias para seguir usando la aplicaci\xF3n. Actualiza ahora para disfrutar de las \xFAltimas funciones, mejoras y refuerzos de seguridad.';
      }
      checkVersionOptionalBody_2r7vzs_k$(version) {
        return '\xA1Buenas noticias! La versi\xF3n ' + version + ' ya est\xE1 disponible con nuevas funciones y mejoras. Te recomendamos actualizar pronto para obtener la mejor experiencia, pero por ahora puedes seguir usando la versi\xF3n actual.';
      }
      get_checkVersionOkButton_hri5kp_k$() {
        return 'Aceptar';
      }
      attendanceNeedsEntryMessage_grklld_k$(count) {
        switch (count) {
          case 0:
            return 'Toda la asistencia de este per\xEDodo ha sido registrada.';
          case 1:
            return 'Todav\xEDa falta registrar 1 d\xEDa programado antes de poder enviar este mes.';
          default:
            return 'Todav\xEDa faltan registrar ' + count + ' d\xEDas programados antes de poder enviar este mes.';
        }
      }
      get_submitAttendance_kcxskq_k$() {
        return 'Enviar asistencia';
      }
      get_attendanceChildScheduleColumnLabel_gdvgn7_k$() {
        return 'Ni\xF1o y horario';
      }
      attendancePeriodPageTitle_p6ycjf_k$(period) {
        return 'Asistencia de ' + period;
      }
      attendanceLocationLabel_w7cjz0_k$(name) {
        return 'Ubicaci\xF3n: ' + name;
      }
      attendanceProviderLabel_uwtfq8_k$(name) {
        return 'Proveedor: ' + name;
      }
      get_attendancePeriodLabel_4v4nxb_k$() {
        return 'Per\xEDodo';
      }
      get_attendanceChildrenScheduledLabel_ceetoo_k$() {
        return 'Ni\xF1os programados';
      }
      get_attendanceStatusLabel_3q3usw_k$() {
        return 'Estado';
      }
      get_attendanceStatusSubmitted_swmv6f_k$() {
        return 'Enviado';
      }
      get_attendanceStatusOpen_y91qpa_k$() {
        return 'Abierto';
      }
      get_attendancePeriodsPageTitle_1e29ef_k$() {
        return 'Per\xEDodos de asistencia';
      }
      attendancePeriodRange_42l3v7_k$(start, end) {
        return start + ' a ' + end;
      }
      get_attendanceClosuresHeading_1l8eiw_k$() {
        return 'Cierres en este per\xEDodo';
      }
      get_attendanceLocationColumnLabel_dz9caf_k$() {
        return 'Ubicaci\xF3n';
      }
      get_attendanceUnknownLocationLabel_l7955l_k$() {
        return 'Ubicaci\xF3n desconocida';
      }
      get_attendanceSubmittedColumnLabel_fx9tt7_k$() {
        return 'Enviado';
      }
      get_attendanceApprovedColumnLabel_lbrr5h_k$() {
        return 'Aprobado';
      }
      get_attendanceStatusApproved_oxievv_k$() {
        return 'Aprobado';
      }
      get_attendanceStatusPending_wf20oj_k$() {
        return 'Pendiente';
      }
      get_attendanceNotBegunMessage_a7k34b_k$() {
        return 'El per\xEDodo de asistencia a\xFAn no ha comenzado.';
      }
      get_attendanceFilledToast_roztnx_k$() {
        return '\xA1Asistencia completada!';
      }
      get_attendanceTransportProvidedLabel_ghqywq_k$() {
        return 'Transporte proporcionado';
      }
      get_attendanceTransportToCareLabel_ssvsgh_k$() {
        return 'Hacia el centro';
      }
      get_attendanceTransportFromCareLabel_elz7b2_k$() {
        return 'Desde el centro';
      }
      get_attendanceStateAttended_v3hons_k$() {
        return 'Asisti\xF3';
      }
      get_attendanceStateExplainedAbsence_9yyv4q_k$() {
        return 'Ausencia justificada';
      }
      get_attendanceStateUnexplainedAbsence_uqoym9_k$() {
        return 'Ausencia injustificada';
      }
      get_attendanceStateClosure_cr4gsc_k$() {
        return 'Cierre';
      }
      get_attendanceStateNotScheduled_obpiih_k$() {
        return 'No programado';
      }
      get_attendanceStateNotPlaced_4v4cr3_k$() {
        return 'Sin colocaci\xF3n';
      }
      get_attendanceStateNeedsEntry_c829o4_k$() {
        return 'Falta registrar';
      }
      get_formulaTesterHeading_uddkg6_k$() {
        return 'Prueba de f\xF3rmulas';
      }
      formulaResultLine_w5wyal_k$(result) {
        return 'Resultado: ' + result;
      }
      get_locationNameLabel_iz62q3_k$() {
        return 'Nombre';
      }
      get_locationAddressSectionTitle_ooy4vd_k$() {
        return 'Direcci\xF3n';
      }
      get_locationStreetAddressLabel_1akgf5_k$() {
        return 'Domicilio';
      }
      get_locationAptSuiteLabel_qtfjst_k$() {
        return 'Apto, suite, etc. (opcional)';
      }
      get_locationCityLabel_jq20et_k$() {
        return 'Ciudad';
      }
      get_locationStateLabel_vycy69_k$() {
        return 'Estado';
      }
      get_locationZipcodeLabel_ph92sc_k$() {
        return 'C\xF3digo postal';
      }
      get_locationContactSectionTitle_jjah7v_k$() {
        return 'Contacto';
      }
      get_locationContactNameLabel_3ysqd5_k$() {
        return 'Nombre de contacto';
      }
      get_locationContactEmailLabel_efzqw6_k$() {
        return 'Correo electr\xF3nico de contacto';
      }
      get_locationContactPhoneLabel_4m2zrc_k$() {
        return 'Tel\xE9fono de contacto';
      }
      get_locationAddDialogTitle_cinmfn_k$() {
        return 'Agregar una ubicaci\xF3n';
      }
      get_locationAddButton_95bquj_k$() {
        return 'Agregar ubicaci\xF3n';
      }
      get_locationAddedToast_8hz6sl_k$() {
        return '\xA1Ubicaci\xF3n agregada!';
      }
      get_locationAddClosureButton_djcbau_k$() {
        return 'Agregar cierre';
      }
      get_locationDetailsSectionTitle_d2wrk9_k$() {
        return 'Detalles de la ubicaci\xF3n';
      }
      get_locationEditButton_aysohy_k$() {
        return 'Editar ubicaci\xF3n';
      }
      get_locationProviderLabel_b4amqt_k$() {
        return 'Proveedor';
      }
      get_locationActivePlacementsSectionTitle_nw2pyz_k$() {
        return 'Colocaciones activas';
      }
      get_locationChildColumnLabel_8ikusg_k$() {
        return 'Ni\xF1o';
      }
      get_locationRateColumnLabel_aaazvk_k$() {
        return 'Tarifa';
      }
      get_locationActiveDatesColumnLabel_f4guo3_k$() {
        return 'Fechas activas';
      }
      get_locationAgreementStatusColumnLabel_dddsdc_k$() {
        return 'Estado del acuerdo';
      }
      get_locationUnknownRateLabel_ltp6qw_k$() {
        return 'Tarifa desconocida';
      }
      get_locationNoEndDateLabel_1tfruy_k$() {
        return 'sin fecha de fin';
      }
      locationDateRange_w0af9i_k$(start, end) {
        return start + ' \u2013 ' + end;
      }
      get_locationSaveButton_pcmeoj_k$() {
        return 'Guardar ubicaci\xF3n';
      }
      get_locationSavedToast_9rc1s2_k$() {
        return '\xA1Ubicaci\xF3n guardada!';
      }
      get_locationsPageTitle_w1kct0_k$() {
        return 'Ubicaciones';
      }
      locationDetailTitle_rl62c8_k$(name) {
        return 'Ubicaci\xF3n ' + name;
      }
      get_locationContactColumnLabel_7u4hlo_k$() {
        return 'Contacto';
      }
      get_locationPhoneColumnLabel_xybcky_k$() {
        return 'Tel\xE9fono';
      }
      get_locationRatesHeading_uw7hbn_k$() {
        return 'Tarifas';
      }
      get_locationAddRateButton_ve9lbf_k$() {
        return 'Agregar tarifa';
      }
      get_locationPrototypeColumnLabel_7abp2e_k$() {
        return 'Modalidad';
      }
      get_locationPlanLabel_xccdpp_k$() {
        return 'Plantilla';
      }
      get_locationUnknownPlanLabel_i0kgn5_k$() {
        return 'Plan desconocido';
      }
      get_locationAttendanceHeading_qbmfph_k$() {
        return 'Asistencia';
      }
      get_locationAddAttendancePeriodButton_2ztszj_k$() {
        return 'Agregar per\xEDodo de asistencia';
      }
      get_locationPeriodNotSubmittedStatus_xdso1l_k$() {
        return 'No enviado';
      }
      get_locationPeriodNeedsApprovalStatus_1q9c99_k$() {
        return 'Enviado, requiere aprobaci\xF3n';
      }
      get_locationClosureDateLabel_yxq7hz_k$() {
        return 'Fecha';
      }
      get_locationClosureKindColumnLabel_l2ckur_k$() {
        return 'Tipo';
      }
      locationChooseMonthSubtext_17dav3_k$(locationName) {
        return locationName + ' \u2014 elige un mes que a\xFAn no tenga uno.';
      }
      get_locationNoEligibleMonthsMessage_5awsde_k$() {
        return 'Todos los meses con colocaciones en esta ubicaci\xF3n ya tienen un per\xEDodo.';
      }
      get_locationClosureUmbrellaWarning_b148pn_k$() {
        return 'Se aplicar\xE1 a todas las ubicaciones de este proveedor.';
      }
      get_locationClosureSpecificLocationHint_htzknp_k$() {
        return 'Para crear un cierre para una ubicaci\xF3n espec\xEDfica, visita la p\xE1gina de detalles de esa ubicaci\xF3n.';
      }
      get_locationClosureReasonLabel_jr4c1f_k$() {
        return 'Motivo';
      }
      get_locationAddClosuresButton_8pcv03_k$() {
        return 'Agregar cierres';
      }
      get_locationClosureAddedToast_kquvus_k$() {
        return '\xA1Cierre agregado!';
      }
      get_locationPrototypeNameLabel_o3rt51_k$() {
        return 'Nombre de la modalidad';
      }
      get_locationSelectPlanPlaceholder_e7rncg_k$() {
        return 'Selecciona un plan...';
      }
      get_locationRateAddedToast_4hcq1n_k$() {
        return '\xA1Tarifa agregada!';
      }
      get_rateInForceFromLabel_hamky5_k$() {
        return 'Vigente desde';
      }
      get_rateLocationLabel_u8i4x6_k$() {
        return 'Ubicaci\xF3n';
      }
      get_ratePlanLabel_6i1kny_k$() {
        return 'Plan';
      }
      get_rateChangeButton_dchwaz_k$() {
        return 'Cambiar';
      }
      rateChangePlanTitle_kxriyt_k$(rateName) {
        return "Cambiar la definici\xF3n de '" + rateName + "' para que use otra plantilla";
      }
      get_rateStartingAtDateLabel_5za9na_k$() {
        return 'A partir de la fecha';
      }
      get_rateToRateLabel_vgzx2o_k$() {
        return 'Nueva tarifa';
      }
      rateChangeConfirmation_752i51_k$(targetName) {
        return 'ESTOY SEGURO de que quiero cambiar a ' + targetName + '. \xA1Esto es dif\xEDcil de deshacer!';
      }
      get_rateOnThisPlanSinceLabel_vdwh5j_k$() {
        return 'En este plan desde';
      }
      get_rateCurrentRateHeading_hraq4y_k$() {
        return 'Tarifa actual';
      }
      get_rateLocationCurrentRateSubtext_i30vi_k$() {
        return 'Lo que paga esta modalidad hoy.';
      }
      get_ratePlanCurrentRateSubtext_41xbk6_k$() {
        return 'Lo que paga este plan hoy.';
      }
      get_rateCurrentChip_ej3r0k_k$() {
        return 'ACTUAL';
      }
      rateInForceSince_kfs6_k$(range) {
        return 'Vigente desde ' + range;
      }
      get_rateHistoryHeading_245zkn_k$() {
        return 'Historial de tarifas';
      }
      get_rateHistorySubtext_t3uw1u_k$() {
        return 'Generado a partir de las revisiones del propio plan; no se puede editar aqu\xED.';
      }
      get_rateInForceColumnLabel_elll5r_k$() {
        return 'Vigencia';
      }
      get_rateDailyRateColumnLabel_3eflwu_k$() {
        return 'Tarifa diaria';
      }
      get_rateTemplatesPageTitle_qntbdl_k$() {
        return 'Plantillas de tarifas';
      }
      get_rateTemplatesHeading_o6frgy_k$() {
        return 'Plantillas de tarifas de cuidado';
      }
      get_rateAddTemplateButton_h149ic_k$() {
        return 'Agregar plantilla de tarifa';
      }
      get_rateNameColumnLabel_44vut2_k$() {
        return 'Nombre';
      }
      get_rateAddVersionButton_8qx842_k$() {
        return 'Agregar versi\xF3n';
      }
      get_rateVersionHistoryHeading_go8cgt_k$() {
        return 'Historial de versiones';
      }
      get_rateVersionHistorySubtext_rd6t14_k$() {
        return 'Todas las versiones que ha tenido esta plantilla. Una versi\xF3n no se puede editar una vez creada. Para cambiar una tarifa, agrega una nueva versi\xF3n.';
      }
      get_rateNewVersionPageTitle_nfj0tk_k$() {
        return 'Nueva versi\xF3n de plantilla de tarifa';
      }
      rateAddVersionHeading_xp6sun_k$(templateName) {
        return 'Agregar una nueva versi\xF3n a ' + templateName;
      }
      get_rateTemplateNameHeading_spoi4s_k$() {
        return 'Nombre de la plantilla';
      }
      get_rateNewVersionFormHeading_o52csj_k$() {
        return 'Nueva versi\xF3n';
      }
      get_rateAddTemplateSubmitButton_psnajo_k$() {
        return 'Agregar plantilla';
      }
      get_rateVersionAddedToast_45ku6u_k$() {
        return '\xA1Versi\xF3n agregada!';
      }
      get_rateNewTemplatePageTitle_o1z2rc_k$() {
        return 'Nueva plantilla de tarifa de cuidado';
      }
      get_rateNewTemplateHeading_sdjtlb_k$() {
        return 'Agregar una nueva plantilla de tarifa de cuidado';
      }
      get_rateNameLabel_kv7vnk_k$() {
        return 'Nombre';
      }
      get_rateShortNameLabel_odyqae_k$() {
        return 'Nombre corto (como lo llaman las ubicaciones)';
      }
      get_rateAgeStartLabel_lia3xk_k$() {
        return 'Edad m\xEDnima, en meses';
      }
      get_rateAgeEndLabel_j1qosv_k$() {
        return 'Deja de calificar a los, en meses';
      }
      get_rateTransportOneWayLabel_hbgejv_k$() {
        return 'Transporte, un sentido';
      }
      get_rateTransportTwoWayLabel_x99pbj_k$() {
        return 'Transporte, ida y vuelta';
      }
      get_rateCareTimeLabel_lijrzh_k$() {
        return 'Horario de cuidado';
      }
      get_rateAvailableAsIntermittentLabel_h1v0mn_k$() {
        return 'Se puede usar cuando no hay escuela';
      }
      get_rateFirstVersionFormHeading_9520p9_k$() {
        return 'Primera versi\xF3n';
      }
      get_rateTemplateAddedToast_3485d6_k$() {
        return '\xA1Plantilla agregada!';
      }
      get_providerNameLabel_yl378x_k$() {
        return 'Nombre';
      }
      get_providerContactLabel_6n76gi_k$() {
        return 'Contacto';
      }
      get_providerContactNameLabel_l558ot_k$() {
        return 'Nombre de contacto';
      }
      get_providerContactEmailLabel_lc4wv2_k$() {
        return 'Correo electr\xF3nico de contacto';
      }
      get_providerContactPhoneLabel_umwegk_k$() {
        return 'Tel\xE9fono de contacto';
      }
      get_providerOffersTransportationLabel_8w5t13_k$() {
        return 'Ofrece transporte';
      }
      get_providerAddDialogHeading_873vsd_k$() {
        return 'Agregar un proveedor';
      }
      get_providerAddButtonLabel_34jbj9_k$() {
        return 'Agregar proveedor';
      }
      get_providerAddedToast_i8f4wv_k$() {
        return '\xA1Proveedor agregado!';
      }
      get_providerDetailsHeading_vbtsje_k$() {
        return 'Detalles del proveedor';
      }
      get_providerEditButtonDescription_6z204a_k$() {
        return 'Editar proveedor';
      }
      get_providerYesLabel_su34fb_k$() {
        return 'S\xED';
      }
      get_providerNoLabel_wn67vr_k$() {
        return 'No';
      }
      get_providerLocationsHeading_kilnxe_k$() {
        return 'Ubicaciones';
      }
      get_providerAddLocationButtonLabel_ny6cyi_k$() {
        return 'Agregar ubicaci\xF3n';
      }
      get_providerCityLabel_2978ep_k$() {
        return 'Ciudad';
      }
      get_providerSaveButtonLabel_8m3k6t_k$() {
        return 'Guardar proveedor';
      }
      get_providerSavedToast_yjdohm_k$() {
        return '\xA1Proveedor guardado!';
      }
      get_providersPageTitle_5b613k_k$() {
        return 'Proveedores';
      }
      get_providerEmailLabel_uskhea_k$() {
        return 'Correo electr\xF3nico';
      }
      get_providerPhoneLabel_l6gtxc_k$() {
        return 'Tel\xE9fono';
      }
      get_providerVendorNumberLabel_cg5mi1_k$() {
        return 'N.\xBA de proveedor';
      }
      get_providerVendorNumberNotSet_vxdl2y_k$() {
        return '[sin definir]';
      }
      get_childAddDialogTitle_h9rjhe_k$() {
        return 'Agregar un ni\xF1o';
      }
      get_childAddButton_woryww_k$() {
        return 'Agregar ni\xF1o';
      }
      get_childAddedToast_qv5dui_k$() {
        return '\xA1Ni\xF1o agregado!';
      }
      get_childFirstNameLabel_nfb0t0_k$() {
        return 'Nombre';
      }
      get_childLastNameLabel_9cmbcw_k$() {
        return 'Apellido';
      }
      get_childBirthDateLabel_57yy4m_k$() {
        return 'Fecha de nacimiento';
      }
      get_childRaceEthnicityLabel_1rbvt3_k$() {
        return 'Raza/Etnia (selecciona todas las que correspondan)';
      }
      get_childNotesLabel_i49wca_k$() {
        return 'Notas';
      }
      get_childDetailsHeading_m3xz5f_k$() {
        return 'Detalles del ni\xF1o';
      }
      childFamilyNameSuffix_vnbngi_k$(familyName) {
        return 'Familia ' + familyName;
      }
      get_childUnknownLabel_wvpdgd_k$() {
        return 'Desconocido';
      }
      childBirthdateWithAge_961sp2_k$(birthDate, ageInMonths) {
        return birthDate + ' (' + ageInMonths + ' meses)';
      }
      get_childPlacementsHeading_tdetof_k$() {
        return 'Colocaciones';
      }
      get_childTableHeaderLocation_z6m8z_k$() {
        return 'Ubicaci\xF3n';
      }
      get_childTableHeaderRate_xtg0lk_k$() {
        return 'Tarifa';
      }
      get_childTableHeaderActiveDates_jvbf9l_k$() {
        return 'Fechas activas';
      }
      get_childTableHeaderAgreementStatus_cdpz04_k$() {
        return 'Estado del acuerdo';
      }
      get_childUnknownLocationLabel_r43uzs_k$() {
        return 'Ubicaci\xF3n desconocida';
      }
      get_childUnknownProviderLabel_fsgzro_k$() {
        return 'Proveedor desconocido';
      }
      get_childUnknownRateLabel_o241ct_k$() {
        return 'Tarifa desconocida';
      }
      get_childNoEndDateLabel_vluxrz_k$() {
        return 'sin fecha de fin';
      }
      get_childSaveButton_6zg7mm_k$() {
        return 'Guardar ni\xF1o';
      }
      get_childSavedToast_8lu59v_k$() {
        return '\xA1Ni\xF1o guardado!';
      }
      childPlacementDetailTitle_5imj30_k$(childName) {
        return 'Colocaci\xF3n de ' + childName;
      }
      get_childPlacementDetailsHeading_q87f7y_k$() {
        return 'Detalles de la colocaci\xF3n';
      }
      signatureStatusLabel_agp5cg_k$(status) {
        var tmp;
        switch (status == null ? -1 : status.ordinal_1) {
          case -1:
          case 0:
            tmp = 'Enviando para firma';
            break;
          case 1:
          case 2:
            tmp = 'Enviado para firma';
            break;
          case 3:
            tmp = 'Firmado';
            break;
          case 4:
            tmp = 'Firma rechazada';
            break;
          case 5:
            tmp = 'Documento anulado';
            break;
          case 6:
            tmp = 'Documento vencido';
            break;
          case 7:
            tmp = 'Estado desconocido';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
      get_childScheduleHeading_ybonig_k$() {
        return 'Horario';
      }
      get_childScheduleTableHeaderDay_gbtbl7_k$() {
        return 'D\xEDa';
      }
      get_childScheduleTableHeaderTime_8yqyxq_k$() {
        return 'Hora';
      }
      get_childScheduleTableHeaderIntermittent_1zk9ks_k$() {
        return 'Intermitente';
      }
      get_childScheduleTableHeaderTransport_xh3sc8_k$() {
        return 'Transporte';
      }
      get_childNoLabel_jgme2o_k$() {
        return 'No';
      }
      childTransportDescription_9po3ip_k$(transportFrom, transportTo) {
        return transportFrom && transportTo ? 'Ida y vuelta' : transportFrom ? 'Desde' : transportTo ? 'Hacia' : 'Ninguno';
      }
      get_childrenListTitle_3nn3hu_k$() {
        return 'Ni\xF1os';
      }
      get_childrenTableHeaderName_oazrcu_k$() {
        return 'Nombre';
      }
      get_childrenTableHeaderFamily_fhtlt5_k$() {
        return 'Familia';
      }
      get_childrenTableHeaderBirthdate_iu407u_k$() {
        return 'Fecha de nacimiento';
      }
      get_placementNewTitle_31boj8_k$() {
        return 'Nueva colocaci\xF3n';
      }
      placementAddForChildTitle_tfmgtt_k$(childName) {
        return 'Agregar una colocaci\xF3n para ' + childName;
      }
      get_placementDetailsHeading_3qgx4s_k$() {
        return 'Detalles';
      }
      get_placementCareLocationLabel_w1cbma_k$() {
        return 'Centro de cuidado';
      }
      get_placementSearchIconDescription_uuv8wx_k$() {
        return 'Buscar';
      }
      placementLocationWithProvider_dft4wy_k$(locationName, providerName) {
        var tmp;
        if (providerName == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = ' \xB7 ' + providerName;
        }
        var tmp1_elvis_lhs = tmp;
        return locationName + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
      }
      get_placementSelectCareLocationPlaceholder_zi5v79_k$() {
        return 'Selecciona un centro de cuidado...';
      }
      get_placementChooseCareLocationTitle_7rzjtt_k$() {
        return 'Elige un centro de cuidado';
      }
      get_placementNoCareLocationsMatch_lqc8l_k$() {
        return 'No hay centros de cuidado que coincidan.';
      }
      get_placementStartDateLabel_lvccn4_k$() {
        return 'Fecha de inicio';
      }
      get_placementEndDateLabel_oohsnt_k$() {
        return 'Fecha de fin';
      }
      get_placementFundingHeading_tzzalb_k$() {
        return 'Financiamiento';
      }
      get_placementPaidByGrantsLabel_y96mde_k$() {
        return 'Pagado por (subvenciones)';
      }
      get_placementChooseGrantsTitle_w90u32_k$() {
        return 'Elige subvenciones';
      }
      get_placementSendForSignatureTitle_fzt0kl_k$() {
        return '\xBFEnviar para firma?';
      }
      get_placementSendForSignatureBody_ualg6t_k$() {
        return 'Los documentos se enviar\xE1n para su firma. Si es necesario hacer cambios, se debe crear una nueva colocaci\xF3n y finalizar esta.';
      }
      get_placementSaveAndSendButton_qp8w94_k$() {
        return 'Guardar y enviar para firma';
      }
      get_placementAddedToast_9n8dct_k$() {
        return '\xA1Colocaci\xF3n agregada!';
      }
      get_placementNoneSelectedLabel_ryp2xn_k$() {
        return 'Ninguno seleccionado';
      }
      get_placementNoOptionsFoundLabel_67d80d_k$() {
        return 'No se encontraron opciones.';
      }
      get_placementDoneButton_4je2q8_k$() {
        return 'Hecho';
      }
      get_childEditButton_7edijz_k$() {
        return 'Editar ni\xF1o';
      }
      get_childFamilyLabel_zden0d_k$() {
        return 'Familia';
      }
      get_childBirthdateLabel_wo149m_k$() {
        return 'Fecha de nacimiento';
      }
      get_childAddPlacementButton_ol20h5_k$() {
        return 'Agregar colocaci\xF3n';
      }
      get_childPlacementChildLabel_g8ybd6_k$() {
        return 'Ni\xF1o';
      }
      get_childPlacementProviderLabel_a3mqvj_k$() {
        return 'Proveedor';
      }
      get_childPlacementGrantsLabel_lannsl_k$() {
        return 'Subvenciones';
      }
      get_placementSearchLocationHint_kl76yo_k$() {
        return 'Buscar nombre de ubicaci\xF3n';
      }
      get_placementTransportFromLabel_xf7eqr_k$() {
        return 'Transporte desde';
      }
      get_placementTransportToLabel_ai59v0_k$() {
        return 'Transporte hacia';
      }
      get_placementSearchHint_64804r_k$() {
        return 'Buscar';
      }
      get_childCopyPlacementButton_2566k1_k$() {
        return 'Copiar colocaci\xF3n';
      }
      get_placementChangeEndButton_9y5npd_k$() {
        return 'Cambiar fecha de fin';
      }
      get_placementEndReasonLabel_2y0sr5_k$() {
        return 'Motivo de finalizaci\xF3n';
      }
      get_placementEndReasonPlaceholder_rzs88g_k$() {
        return 'Seleccione un motivo';
      }
      get_placementEndReasonNotesLabel_6gz5fa_k$() {
        return 'Detalles del motivo';
      }
      get_childPlacementAgreementLabel_a4ki58_k$() {
        return 'Acuerdo de colocaci\xF3n';
      }
      get_childPlacementAgreementNoneSet_y46u4u_k$() {
        return 'Sin definir';
      }
      get_childNotScheduledLabel_mg5553_k$() {
        return 'No programado';
      }
      get_placementWhenSchoolIsOutLabel_som316_k$() {
        return 'Cuando no hay clases';
      }
      get_placementNotIntermittentLabel_4hk03a_k$() {
        return 'No intermitente';
      }
      placementPreviousEndChangeMessage_u9z0qq_k$(previousEnd, cutoff, newStart) {
        return 'La colocaci\xF3n anterior termina actualmente el ' + previousEnd + '. En su lugar, terminar\xE1 el ' + cutoff + ', el d\xEDa antes de que esta colocaci\xF3n comience el ' + newStart + '.';
      }
      get_familyFirstNameLabel_j5nup2_k$() {
        return 'Nombre';
      }
      get_familyLastNameLabel_slk1mi_k$() {
        return 'Apellido';
      }
      get_familyPhoneNumberLabel_28h2zu_k$() {
        return 'N\xFAmero de tel\xE9fono';
      }
      get_familyAlternatePhoneLabel_sqbdsj_k$() {
        return 'N\xFAmero de tel\xE9fono adicional (opcional)';
      }
      get_familyEmailLabel_ow4s1n_k$() {
        return 'Correo electr\xF3nico';
      }
      get_familyPreferredLanguageLabel_sqcw94_k$() {
        return 'Idioma preferido';
      }
      get_familyRaceEthnicityLabel_z00d2r_k$() {
        return 'Raza/Etnia (selecciona todas las que correspondan)';
      }
      get_familyAddSecondParentLabel_6zuz7m_k$() {
        return 'Agregar segundo padre/madre';
      }
      get_familyAddressLabel_jhvmgd_k$() {
        return 'Direcci\xF3n';
      }
      get_familyStreetAddressLabel_hc5wvk_k$() {
        return 'Domicilio';
      }
      get_familyAptSuiteLabel_c6ev78_k$() {
        return 'Apto, suite, etc. (opcional)';
      }
      get_familyCityLabel_9p20yk_k$() {
        return 'Ciudad';
      }
      get_familyStateLabel_kkdf00_k$() {
        return 'Estado';
      }
      get_familyZipcodeLabel_v3fgfh_k$() {
        return 'C\xF3digo postal';
      }
      get_familyAnnualIncomeLabel_nsky2p_k$() {
        return 'Ingreso anual';
      }
      get_familySizeLabel_ytosca_k$() {
        return 'Tama\xF1o de la familia';
      }
      get_familyPreferNotToSayLabel_t7jcq_k$() {
        return 'Prefiero no decir';
      }
      familyDetailTitle_gwlhpl_k$(familyName) {
        return 'Familia ' + familyName;
      }
      get_familyDetailsSectionTitle_mepryw_k$() {
        return 'Detalles de la familia';
      }
      get_familyEditIconDescription_ebeqi4_k$() {
        return 'Editar familia';
      }
      get_familyPrimaryParentLabel_xb85ed_k$() {
        return 'Padre/madre principal';
      }
      get_familyPrimaryEmailLabel_sxbo19_k$() {
        return 'Correo electr\xF3nico principal';
      }
      get_familyPrimaryPhoneLabel_n1pnad_k$() {
        return 'Tel\xE9fono principal';
      }
      get_familyPrimaryAlternatePhoneLabel_l533dh_k$() {
        return 'Tel\xE9fono alternativo principal';
      }
      get_familySecondaryParentLabel_xd744d_k$() {
        return 'Padre/madre secundario';
      }
      get_familySecondaryEmailLabel_1kj0yn_k$() {
        return 'Correo electr\xF3nico secundario';
      }
      get_familySecondaryPhoneLabel_kmlrm5_k$() {
        return 'Tel\xE9fono secundario';
      }
      get_familySecondaryAlternatePhoneLabel_rncxqf_k$() {
        return 'Tel\xE9fono alternativo secundario';
      }
      get_familyInformationVerifiedLabel_5tuhwz_k$() {
        return 'Informaci\xF3n verificada';
      }
      get_familyNotVerifiedLabel_31381m_k$() {
        return 'No verificada';
      }
      get_familyChildrenSectionTitle_2sss81_k$() {
        return 'Ni\xF1os';
      }
      get_familyAddChildButton_udkhcq_k$() {
        return 'Agregar ni\xF1o';
      }
      get_familyNameColumnLabel_yh58ca_k$() {
        return 'Nombre';
      }
      get_familyBirthdateAgeColumnLabel_djfnz5_k$() {
        return 'Fecha de nacimiento/Edad';
      }
      get_familyActivePlacementColumnLabel_repll8_k$() {
        return 'Colocaci\xF3n activa';
      }
      familyPlacementSummary_u4ho0l_k$(provider, location, status) {
        return provider + ' \xB7 ' + location + ' \xB7 ' + status;
      }
      get_familySaveFamilyButton_40ppb4_k$() {
        return 'Guardar familia';
      }
      get_familySavedToast_l5bkyb_k$() {
        return '\xA1Familia guardada!';
      }
      get_familyListTitle_7vfhpp_k$() {
        return 'Familias';
      }
      get_familyAddFamilyButton_qgzmly_k$() {
        return 'Agregar familia';
      }
      get_familyColumnLabel_vxra7j_k$() {
        return 'Familia';
      }
      get_familyCityColumnLabel_bqfeje_k$() {
        return 'Ciudad';
      }
      get_familyNewFamilyTitle_u18ivz_k$() {
        return 'Nueva familia';
      }
      get_familyAddPageTitle_rl7n91_k$() {
        return 'Agregar una familia';
      }
      get_familyAddedToast_2w0cdo_k$() {
        return '\xA1Familia agregada!';
      }
      get_familyApplicationListTitle_c6ygp5_k$() {
        return 'Solicitudes de Familias';
      }
      get_familyApplicationColumnSentTo_7zvbzg_k$() {
        return 'Enviado A';
      }
      get_familyApplicationColumnEmployer_c2b99w_k$() {
        return 'Empleador';
      }
      get_familyApplicationColumnStatus_87vyuj_k$() {
        return 'Estado';
      }
      get_familyApplicationColumnInvitedAt_esy33p_k$() {
        return 'Invitado';
      }
      familyApplicationDetailTitle_7az5kv_k$(sentTo) {
        return 'Solicitud - ' + sentTo;
      }
      get_familyApplicationSentToLabel_u2by72_k$() {
        return 'Enviado A';
      }
      get_familyApplicationEmployerLabel_w3sr2u_k$() {
        return 'Empleador';
      }
      get_familyApplicationStatusLabel_3spxtr_k$() {
        return 'Estado';
      }
      get_familyApplicationNotSubmittedLabel_1cvz7t_k$() {
        return 'A\xFAn no enviado';
      }
      get_familyApplicationApproveButton_w2gak_k$() {
        return 'Aprobar';
      }
      get_familyApplicationApproveConfirmHeading_oqxjis_k$() {
        return '\xBFAprobar esta solicitud?';
      }
      get_familyApplicationApproveConfirmBody_j98ydk_k$() {
        return 'Esto crear\xE1 el registro de la familia (y los hijos) a partir de la informaci\xF3n enviada.';
      }
      get_familyApplicationApprovedToast_ghct71_k$() {
        return 'Solicitud aprobada';
      }
      get_familyApplicationRejectedToast_5xw86e_k$() {
        return 'Solicitud rechazada';
      }
      get_providerApplicationListTitle_52jvb0_k$() {
        return 'Solicitudes de Proveedores';
      }
      get_providerApplicationColumnSentTo_l9kj27_k$() {
        return 'Enviado A';
      }
      get_providerApplicationColumnInvitedAt_xa4eri_k$() {
        return 'Invitado';
      }
      get_providerApplicationColumnStatus_lhl5xa_k$() {
        return 'Estado';
      }
      providerApplicationDetailTitle_7oej8u_k$(sentTo) {
        return 'Solicitud - ' + sentTo;
      }
      get_providerApplicationSentToLabel_fc0az9_k$() {
        return 'Enviado A';
      }
      get_providerApplicationStatusLabel_tfhqmk_k$() {
        return 'Estado';
      }
      get_providerApplicationNotSubmittedLabel_wjkrfa_k$() {
        return 'A\xFAn no enviado';
      }
      get_providerApplicationApproveButton_dxws6v_k$() {
        return 'Aprobar';
      }
      get_providerApplicationApproveConfirmHeading_ifddmh_k$() {
        return '\xBFAprobar esta solicitud?';
      }
      get_providerApplicationApproveConfirmBody_o3mmdn_k$() {
        return 'Esto crear\xE1 el registro del proveedor de cuidado a partir de la informaci\xF3n enviada.';
      }
      get_providerApplicationApprovedToast_1ndkpm_k$() {
        return 'Solicitud aprobada';
      }
      get_providerApplicationRejectedToast_8w30b1_k$() {
        return 'Solicitud rechazada';
      }
      get_employerNameLabel_rr9lvp_k$() {
        return 'Nombre';
      }
      get_employerContactLabel_f0mfyw_k$() {
        return 'Contacto';
      }
      get_employerContactNameLabel_h6hpwz_k$() {
        return 'Nombre de contacto';
      }
      get_employerContactEmailLabel_245yvo_k$() {
        return 'Correo electr\xF3nico de contacto';
      }
      get_employerContactPhoneLabel_l68pj6_k$() {
        return 'Tel\xE9fono de contacto';
      }
      get_employerEmailColumnLabel_siw8re_k$() {
        return 'Correo electr\xF3nico';
      }
      get_employerPhoneColumnLabel_nv3puc_k$() {
        return 'Tel\xE9fono';
      }
      get_employerBillingAddressLabel_ppg2x_k$() {
        return 'Direcci\xF3n de facturaci\xF3n';
      }
      get_employerAddBillingAddressLabel_f9xuim_k$() {
        return 'Agregar direcci\xF3n de facturaci\xF3n';
      }
      get_employerBillingContactLabel_g1s2i3_k$() {
        return 'Contacto de facturaci\xF3n';
      }
      get_employerBillingContactNameLabel_2furfk_k$() {
        return 'Nombre del contacto de facturaci\xF3n';
      }
      get_employerStreetAddressLabel_hfp9k7_k$() {
        return 'Domicilio';
      }
      get_employerAptSuiteLabel_72k85f_k$() {
        return 'Apto, suite, etc. (opcional)';
      }
      get_employerCityLabel_axyh97_k$() {
        return 'Ciudad';
      }
      get_employerStateLabel_k0y83r_k$() {
        return 'Estado';
      }
      get_employerZipcodeLabel_ioxwh6_k$() {
        return 'C\xF3digo postal';
      }
      get_employerAddDialogHeading_48gd0j_k$() {
        return 'Agregar un empleador';
      }
      get_employerAddButton_d87ox_k$() {
        return 'Agregar empleador';
      }
      get_employerAddedToast_3ffj9x_k$() {
        return '\xA1Empleador agregado!';
      }
      get_employerDetailsHeading_ytinek_k$() {
        return 'Detalles del empleador';
      }
      get_employerEditButtonDescription_ojdqak_k$() {
        return 'Editar empleador';
      }
      get_employerActiveLabel_isbluy_k$() {
        return 'Activo';
      }
      get_employerYesLabel_5tbbwv_k$() {
        return 'S\xED';
      }
      get_employerNoLabel_ue8l8v_k$() {
        return 'No';
      }
      get_employerBalanceLabel_le7jmk_k$() {
        return 'Saldo';
      }
      get_employerBalanceNotSynced_t35ga3_k$() {
        return 'Sin sincronizar';
      }
      get_employerRatesHeading_d9zhxv_k$() {
        return 'Tarifas';
      }
      get_employerRatesSubtext_urfnk2_k$() {
        return 'Lo que paga este empleador por d\xEDa de cuidado.';
      }
      get_employerAddNewRateButton_3qdhmd_k$() {
        return 'Agregar nueva tarifa';
      }
      get_employerShareOfDayLabel_l9g9iu_k$() {
        return 'Parte del empleador por un d\xEDa';
      }
      get_employerShareColumnLabel_p5bseb_k$() {
        return 'Parte del empleador';
      }
      get_employerAdministrationColumnLabel_s4ljqc_k$() {
        return 'Administraci\xF3n';
      }
      get_employerSaveButton_xr2x83_k$() {
        return 'Guardar empleador';
      }
      get_employerSavedToast_loqruk_k$() {
        return '\xA1Empleador guardado!';
      }
      get_employerNewRatePageTitle_lgm6tv_k$() {
        return 'Nueva tarifa de empleador';
      }
      employerAddRateHeading_yj9ltq_k$(employerName) {
        return 'Agregar una tarifa para ' + employerName;
      }
      get_employerAddRateButton_bne9o1_k$() {
        return 'Agregar tarifa';
      }
      get_employerRateAddedToast_vme6ol_k$() {
        return '\xA1Tarifa agregada!';
      }
      get_userNameLabel_jnppqj_k$() {
        return 'Nombre';
      }
      get_userEmailLabel_3oltlg_k$() {
        return 'Correo electr\xF3nico';
      }
      get_userPhoneLabel_fdgx22_k$() {
        return 'Tel\xE9fono';
      }
      get_userRoleLabel_yi9o5y_k$() {
        return 'Rol';
      }
      get_userDetailsSectionTitle_o8ze3l_k$() {
        return 'Detalles del usuario';
      }
      get_userEditIconDescription_a205ej_k$() {
        return 'Editar usuario';
      }
      get_grantNameLabel_7luufe_k$() {
        return 'Nombre';
      }
      get_grantFunderLabel_2sx24x_k$() {
        return 'Financiador';
      }
      get_grantAwardPeriodLabel_m5ymnd_k$() {
        return 'Per\xEDodo de la subvenci\xF3n';
      }
      get_grantStartDateLabel_la3b0p_k$() {
        return 'Fecha de inicio';
      }
      get_grantAddEndDateLabel_xwlt5z_k$() {
        return 'Agregar fecha de fin';
      }
      get_grantEndDateLabel_vuktgi_k$() {
        return 'Fecha de fin';
      }
      get_grantAddDialogHeading_vr5wfo_k$() {
        return 'Agregar una subvenci\xF3n';
      }
      get_grantAddButton_zardz4_k$() {
        return 'Agregar subvenci\xF3n';
      }
      get_grantAddedToast_y9kr6u_k$() {
        return '\xA1Subvenci\xF3n agregada!';
      }
      get_grantDetailsHeading_4bpyr7_k$() {
        return 'Detalles de la subvenci\xF3n';
      }
      get_grantEditButtonDescription_abff03_k$() {
        return 'Editar subvenci\xF3n';
      }
      get_grantBalanceLabel_6ku5mz_k$() {
        return 'Saldo';
      }
      get_grantBalanceNotSynced_ef929w_k$() {
        return 'Sin sincronizar';
      }
      get_grantRatesHeading_1jdw1q_k$() {
        return 'Tarifas';
      }
      get_grantRatesSubtext_pgb0fh_k$() {
        return 'C\xF3mo esta subvenci\xF3n iguala un d\xEDa de cuidado.';
      }
      get_grantAddNewRateButton_nsc1ss_k$() {
        return 'Agregar nueva tarifa';
      }
      get_grantShareOfDayLabel_f9y45h_k$() {
        return 'Aporte de la subvenci\xF3n por un d\xEDa';
      }
      get_grantShareColumnLabel_2ddr0u_k$() {
        return 'Aporte de la subvenci\xF3n';
      }
      get_grantSaveButton_2wxpb6_k$() {
        return 'Guardar subvenci\xF3n';
      }
      get_grantSavedToast_ii827n_k$() {
        return '\xA1Subvenci\xF3n guardada!';
      }
      get_grantNewRatePageTitle_m1sbq4_k$() {
        return 'Nueva tarifa de subvenci\xF3n';
      }
      grantAddRateHeading_rhf7ur_k$(grantName) {
        return 'Agregar una tarifa para ' + grantName;
      }
      get_grantAddRateButton_q9v2io_k$() {
        return 'Agregar tarifa';
      }
      get_grantRateAddedToast_7iufh6_k$() {
        return '\xA1Tarifa agregada!';
      }
      get_remittancesPageTitle_yno01p_k$() {
        return 'Remesas';
      }
      get_remittancesPreviousMonthDescription_c46s75_k$() {
        return 'Mes anterior';
      }
      get_remittancesNextMonthDescription_472mkb_k$() {
        return 'Mes siguiente';
      }
      get_remittancesProviderColumn_b68mq5_k$() {
        return 'Proveedor';
      }
      get_remittancesStatusColumn_9ruzm4_k$() {
        return 'Estado';
      }
      get_closeOutAttendanceIncomplete_qvityy_k$() {
        return 'Asistencia incompleta';
      }
      get_closeOutAttendanceReviewNeeded_5v2tud_k$() {
        return 'Revisi\xF3n de asistencia pendiente';
      }
      get_closeOutReadyForRemittance_zhgfk3_k$() {
        return 'Listo para remesa';
      }
      get_closeOutComplete_hpmhjs_k$() {
        return 'Completo';
      }
      get_remittancesAmountColumn_vm5mg6_k$() {
        return 'Monto';
      }
      get_closeOutPageTitle_igqf2i_k$() {
        return 'Cerrar mes';
      }
      get_remittancesDatesColumn_sy3n9t_k$() {
        return 'Fechas';
      }
      get_remittanceVoided_7coapm_k$() {
        return 'Anulada';
      }
      get_remittanceReviewPageTitle_w5gryu_k$() {
        return 'Revisar remesa';
      }
      remittanceReviewHeading_bk4mmq_k$(providerName) {
        return 'Revisar remesa: ' + providerName;
      }
      remittanceProblemsHeading_lc0nvc_k$(count) {
        return count === 1 ? '1 colocaci\xF3n no se puede tarifar' : '' + count + ' colocaciones no se pueden tarifar';
      }
      remittanceIssueButton_tu58r7_k$(amount) {
        return 'Emitir ' + amount;
      }
      get_remittanceIssueConfirmHeading_bxfsjw_k$() {
        return '\xBFEmitir esta remesa?';
      }
      get_remittanceIssueConfirmBody_1w6k7k_k$() {
        return 'Una vez emitido, el monto queda registrado como lo que se le debe a este proveedor por el per\xEDodo y no cambiar\xE1.';
      }
      get_remittanceIssueConfirmButton_qtcw1s_k$() {
        return 'Emitir';
      }
      get_remittanceDetailPageTitle_pimg0h_k$() {
        return 'Remesa';
      }
      get_remittanceStatusLabel_ozb6h1_k$() {
        return 'Estado';
      }
      get_remittanceIssuedAtLabel_sk6ikx_k$() {
        return 'Emitido';
      }
      get_remittanceAmountLabel_u9neaz_k$() {
        return 'Monto';
      }
      get_remittanceChildrenLabel_g31cj6_k$() {
        return 'Ni\xF1os';
      }
      get_remittanceDaysBilledLabel_iaro0g_k$() {
        return 'D\xEDas facturados';
      }
      get_remittanceCostOfCareLabel_pxj9qw_k$() {
        return 'Costo del cuidado';
      }
      get_remittanceEmployerSharesLabel_p173b2_k$() {
        return 'Partes de los empleadores';
      }
      get_remittanceGrantSharesLabel_3d2smj_k$() {
        return 'Partes de las subvenciones';
      }
      get_remittanceFamilyPaysLabel_f1jlxa_k$() {
        return 'La familia le paga a la ubicaci\xF3n';
      }
      get_remittanceTcgPaysLabel_z6hcxk_k$() {
        return 'TCG le paga al proveedor';
      }
      get_remittanceAdministrationLabel_spr4f_k$() {
        return 'Cargos de administraci\xF3n';
      }
      get_remittanceDayAttendanceLabel_y52ora_k$() {
        return 'Asistencia';
      }
      get_remittanceDayProgramLabel_7icdid_k$() {
        return 'Programa';
      }
      get_surveyTakeSubmitButton_gkww0k_k$() {
        return 'Enviar respuestas';
      }
      get_surveyTakeNeedAnswerToast_561g7r_k$() {
        return 'Responda al menos una pregunta primero.';
      }
      get_surveyTakeThanksToast_6r9hqk_k$() {
        return '\xA1Gracias! Sus respuestas han sido registradas.';
      }
      get_surveyTakeSavedToast_evm8s6_k$() {
        return 'Respuestas guardadas. Puede terminar el resto m\xE1s tarde.';
      }
      get_surveyOptionalLabel_i973rl_k$() {
        return '(opcional)';
      }
      get_surveyCompletedText_anx46t_k$() {
        return 'Ha completado esta encuesta. \xA1Gracias!';
      }
      get_surveyTakeAgainButton_c6h420_k$() {
        return 'Responder de nuevo';
      }
      get_surveyAnsweringForLabel_wb231w_k$() {
        return 'Respondiendo por';
      }
      get_surveyLeadershipQuestion_pd6bg2_k$() {
        return '\xBFCu\xE1l de las siguientes opciones describe mejor sus responsabilidades de liderazgo actuales en [company]?';
      }
      get_surveyLeadershipManagesNoOne_4fq5q9_k$() {
        return 'No superviso a nadie';
      }
      get_surveyLeadershipManagesEmployees_jcz2fz_k$() {
        return 'Superviso a empleados';
      }
      get_surveyLeadershipManagesManagers_3jp6do_k$() {
        return 'Superviso a empleados que supervisan a otros empleados';
      }
      get_surveyLeadershipSeniorLeader_he8vsv_k$() {
        return 'Soy un l\xEDder de alto nivel en mi organizaci\xF3n';
      }
      get_surveyIncomeQuestion_em6voy_k$() {
        return '\xBFCu\xE1l es su ingreso anual aproximado en [company]?';
      }
      get_surveyContinueButton_w6kl50_k$() {
        return 'Continuar';
      }
      get_surveyLanguageLabel_fcb89_k$() {
        return 'Idioma';
      }
      get_remittanceAbsencesLabel_s31xd5_k$() {
        return 'Ausencias';
      }
      remittanceAbsencesValue_hrzn9f_k$(explained, unexplained) {
        return '' + (explained + unexplained | 0) + ' (' + explained + ' justificadas, ' + unexplained + ' injustificadas)';
      }
      get_remittanceChildTotalsHeading_ish2aq_k$() {
        return 'D\xEDas por ni\xF1o';
      }
      get_remittanceChildTotalsHint_sqdm97_k$() {
        return 'Seleccione un ni\xF1o para ver su mes.';
      }
      get_remittanceChildColumn_w7inzf_k$() {
        return 'Ni\xF1o';
      }
      get_remittanceDaysColumn_y81ogk_k$() {
        return 'D\xEDas';
      }
      remittanceIntermittentColumn_diw8ct_k$(careTime) {
        return careTime + ' intermitente';
      }
      get_remittanceTransportOneWayColumn_7s8g1t_k$() {
        return 'Transporte de ida';
      }
      get_remittanceTransportTwoWayColumn_2m8bh7_k$() {
        return 'Transporte ida y vuelta';
      }
      get_remittanceExplainedAbsencesColumn_949z39_k$() {
        return 'Ausencias justificadas';
      }
      get_remittanceUnexplainedAbsencesColumn_7oks0u_k$() {
        return 'Ausencias injustificadas';
      }
      get_remittanceFamilyPaysColumn_yxf9kk_k$() {
        return 'Paga la familia';
      }
      get_remittanceTcgPaysColumn_l2qjv6_k$() {
        return 'Paga TCG';
      }
      get_remittanceGrandTotal_q37hep_k$() {
        return 'Total general';
      }
      get_remittanceOpenPlacementButton_cb7i92_k$() {
        return 'Abrir colocaci\xF3n';
      }
    }
    initMetadataForClass($, 'Spanish');
    StringsForLanguage$SpanishClass = $;
  }
  return StringsForLanguage$SpanishClass;
}
var StringsForLanguage_Spanish_instance;
var StringsForLanguage$PortugueseClass;
function StringsForLanguage$Portuguese() {
  if (StringsForLanguage$PortugueseClass === VOID) {
    class $ extends StringsForLanguage() {
      constructor() {
        super('Portuguese', 3);
        StringsForLanguage_Portuguese_instance = this;
      }
      get_navDashboardTitle_9up0g2_k$() {
        return 'In\xEDcio';
      }
      get_navFormulaLabTitle_ewi7uf_k$() {
        return 'Laborat\xF3rio de f\xF3rmulas';
      }
      get_navSignOutTitle_jmnskh_k$() {
        return 'Sair';
      }
      get_navSwitchLanguageTitle_6fj9xq_k$() {
        return 'Mudar idioma';
      }
      get_navProvidersTitle_oa0ysw_k$() {
        return 'Prestadores (UMB)';
      }
      get_navCareLocationsTitle_2k6n4r_k$() {
        return 'Unidades de cuidado';
      }
      get_navEmployersTitle_5ougl6_k$() {
        return 'Empregadores';
      }
      get_navGrantsTitle_6gc2p3_k$() {
        return 'Subs\xEDdios';
      }
      get_navRemittancesTitle_qthgnx_k$() {
        return 'Repasses';
      }
      get_navCloseOutTitle_69wx5k_k$() {
        return 'Fechar m\xEAs';
      }
      get_navUsersTitle_3xs496_k$() {
        return 'Usu\xE1rios';
      }
      get_notificationsPromptTitle_6gox63_k$() {
        return 'Enviar notifica\xE7\xF5es?';
      }
      get_notificationsPromptBody_22ny2t_k$() {
        return 'A Ferramenta de Dados de Vale de Cuidado Infantil da TCG gostaria de enviar notifica\xE7\xF5es a voc\xEA.';
      }
      get_notificationsPromptAllow_6r39bu_k$() {
        return 'Permitir';
      }
      get_crudGroupProgramTitle_ph6e0k_k$() {
        return 'Programa';
      }
      get_crudGroupNetworkTitle_o69yjm_k$() {
        return 'Rede';
      }
      get_crudGroupFundingTitle_rkjttf_k$() {
        return 'Financiamento';
      }
      get_crudCancelButton_yk4tir_k$() {
        return 'Cancelar';
      }
      get_crudSaveButton_lsaoza_k$() {
        return 'Salvar';
      }
      get_crudSavedToast_xnj03d_k$() {
        return 'Salvo';
      }
      get_appTagline_r1snd6_k$() {
        return 'Ferramenta de Dados de Vale de Cuidado Infantil da TCG';
      }
      get_closurePaidLabel_brac2y_k$() {
        return 'Pago';
      }
      get_closureUnpaidLabel_5pnjh9_k$() {
        return 'N\xE3o pago';
      }
      dateRangeOnwards_e67e9b_k$(start) {
        return start + ' em diante';
      }
      get_exportCsvButton_84ycf9_k$() {
        return 'Exportar CSV';
      }
      get_goBackDescription_2wlgbo_k$() {
        return 'Voltar';
      }
      get_emptyRowText_pvodpf_k$() {
        return 'Nada para mostrar';
      }
      get_searchIconDescription_c0d0b6_k$() {
        return 'Buscar';
      }
      get_validationInvalidPhoneMessage_cvge1e_k$() {
        return 'N\xFAmero de telefone inv\xE1lido';
      }
      get_validationInvalidEmailMessage_1bjpq8_k$() {
        return 'Endere\xE7o de e-mail inv\xE1lido';
      }
      get_landingPageTitle_9rfr0l_k$() {
        return 'Carregando';
      }
      get_loginPageTitle_1ofql3_k$() {
        return 'Entrar';
      }
      get_loginPrompt_y6r4qs_k$() {
        return 'Entre para come\xE7ar';
      }
      get_loginServerFieldLabel_24y76r_k$() {
        return 'Servidor';
      }
      get_homePageTitle_o7pge7_k$() {
        return 'In\xEDcio';
      }
      get_homeEmptyStateMessage_lc9n17_k$() {
        return 'N\xE3o h\xE1 nada aqui por enquanto. Volte mais tarde.';
      }
      get_homeApplicationsHeading_6tsmjb_k$() {
        return 'Suas Solicita\xE7\xF5es';
      }
      get_homeApplicationsIntro_9aamv3_k$() {
        return 'Voc\xEA foi convidado a solicitar assist\xEAncia de cuidado infantil. Complete sua solicita\xE7\xE3o abaixo para come\xE7ar.';
      }
      get_homeApplicationCardTitle_1x2b5s_k$() {
        return 'Solicita\xE7\xE3o de Assist\xEAncia de Cuidado Infantil';
      }
      get_homeProviderApplicationCardTitle_6vkqdt_k$() {
        return 'Solicita\xE7\xE3o de Provedor de Cuidado';
      }
      homeApplicationInvitedOn_fh8p3l_k$(date) {
        return 'Convidado em ' + date;
      }
      get_homeApplicationStatusActionNeeded_pm6rp_k$() {
        return 'A\xE7\xE3o necess\xE1ria';
      }
      get_homeApplicationStatusSubmitted_7i53pd_k$() {
        return 'Enviada';
      }
      get_homeApplicationStatusApproved_5joi6n_k$() {
        return 'Aprovada';
      }
      get_homeApplicationStatusRejected_z7mlvs_k$() {
        return 'N\xE3o aprovada';
      }
      get_homeApplicationStartButton_tv1v5g_k$() {
        return 'Iniciar solicita\xE7\xE3o';
      }
      get_homeApplicationContinueButton_kfmgbj_k$() {
        return 'Ver solicita\xE7\xE3o';
      }
      get_checkVersionTitle_5bcopt_k$() {
        return 'Nova vers\xE3o dispon\xEDvel';
      }
      checkVersionRequiredBody_la1fe1_k$(version) {
        return 'Lan\xE7amos a vers\xE3o ' + version + ' com atualiza\xE7\xF5es importantes necess\xE1rias para continuar usando o aplicativo. Atualize agora para aproveitar os recursos, melhorias e refor\xE7os de seguran\xE7a mais recentes.';
      }
      checkVersionOptionalBody_2r7vzs_k$(version) {
        return 'Boas not\xEDcias! A vers\xE3o ' + version + ' j\xE1 est\xE1 dispon\xEDvel com novos recursos e melhorias. Recomendamos atualizar em breve para obter a melhor experi\xEAncia, mas por enquanto voc\xEA pode continuar usando a vers\xE3o atual.';
      }
      get_checkVersionOkButton_hri5kp_k$() {
        return 'OK';
      }
      attendanceNeedsEntryMessage_grklld_k$(count) {
        switch (count) {
          case 0:
            return 'Toda a frequ\xEAncia deste per\xEDodo foi registrada.';
          case 1:
            return 'Ainda falta registrar 1 dia programado antes que este m\xEAs possa ser enviado.';
          default:
            return 'Ainda faltam registrar ' + count + ' dias programados antes que este m\xEAs possa ser enviado.';
        }
      }
      get_submitAttendance_kcxskq_k$() {
        return 'Enviar frequ\xEAncia';
      }
      get_attendanceChildScheduleColumnLabel_gdvgn7_k$() {
        return 'Crian\xE7a e hor\xE1rio';
      }
      attendancePeriodPageTitle_p6ycjf_k$(period) {
        return 'Frequ\xEAncia de ' + period;
      }
      attendanceLocationLabel_w7cjz0_k$(name) {
        return 'Unidade: ' + name;
      }
      attendanceProviderLabel_uwtfq8_k$(name) {
        return 'Prestador: ' + name;
      }
      get_attendancePeriodLabel_4v4nxb_k$() {
        return 'Per\xEDodo';
      }
      get_attendanceChildrenScheduledLabel_ceetoo_k$() {
        return 'Crian\xE7as programadas';
      }
      get_attendanceStatusLabel_3q3usw_k$() {
        return 'Status';
      }
      get_attendanceStatusSubmitted_swmv6f_k$() {
        return 'Enviado';
      }
      get_attendanceStatusOpen_y91qpa_k$() {
        return 'Aberto';
      }
      get_attendancePeriodsPageTitle_1e29ef_k$() {
        return 'Per\xEDodos de Frequ\xEAncia';
      }
      attendancePeriodRange_42l3v7_k$(start, end) {
        return start + ' a ' + end;
      }
      get_attendanceClosuresHeading_1l8eiw_k$() {
        return 'Fechamentos neste per\xEDodo';
      }
      get_attendanceLocationColumnLabel_dz9caf_k$() {
        return 'Unidade';
      }
      get_attendanceUnknownLocationLabel_l7955l_k$() {
        return 'Unidade desconhecida';
      }
      get_attendanceSubmittedColumnLabel_fx9tt7_k$() {
        return 'Enviado';
      }
      get_attendanceApprovedColumnLabel_lbrr5h_k$() {
        return 'Aprovado';
      }
      get_attendanceStatusApproved_oxievv_k$() {
        return 'Aprovado';
      }
      get_attendanceStatusPending_wf20oj_k$() {
        return 'Pendente';
      }
      get_attendanceNotBegunMessage_a7k34b_k$() {
        return 'O per\xEDodo de frequ\xEAncia ainda n\xE3o come\xE7ou.';
      }
      get_attendanceFilledToast_roztnx_k$() {
        return 'Frequ\xEAncia preenchida!';
      }
      get_attendanceTransportProvidedLabel_ghqywq_k$() {
        return 'Transporte fornecido';
      }
      get_attendanceTransportToCareLabel_ssvsgh_k$() {
        return 'Para a unidade';
      }
      get_attendanceTransportFromCareLabel_elz7b2_k$() {
        return 'Da unidade';
      }
      get_attendanceStateAttended_v3hons_k$() {
        return 'Presente';
      }
      get_attendanceStateExplainedAbsence_9yyv4q_k$() {
        return 'Falta justificada';
      }
      get_attendanceStateUnexplainedAbsence_uqoym9_k$() {
        return 'Falta injustificada';
      }
      get_attendanceStateClosure_cr4gsc_k$() {
        return 'Fechamento';
      }
      get_attendanceStateNotScheduled_obpiih_k$() {
        return 'N\xE3o programado';
      }
      get_attendanceStateNotPlaced_4v4cr3_k$() {
        return 'Sem coloca\xE7\xE3o';
      }
      get_attendanceStateNeedsEntry_c829o4_k$() {
        return 'Falta registrar';
      }
      get_formulaTesterHeading_uddkg6_k$() {
        return 'Teste de f\xF3rmulas';
      }
      formulaResultLine_w5wyal_k$(result) {
        return 'Resultado: ' + result;
      }
      get_locationNameLabel_iz62q3_k$() {
        return 'Nome';
      }
      get_locationAddressSectionTitle_ooy4vd_k$() {
        return 'Endere\xE7o';
      }
      get_locationStreetAddressLabel_1akgf5_k$() {
        return 'Logradouro';
      }
      get_locationAptSuiteLabel_qtfjst_k$() {
        return 'Apto, sala, etc. (opcional)';
      }
      get_locationCityLabel_jq20et_k$() {
        return 'Cidade';
      }
      get_locationStateLabel_vycy69_k$() {
        return 'Estado';
      }
      get_locationZipcodeLabel_ph92sc_k$() {
        return 'CEP';
      }
      get_locationContactSectionTitle_jjah7v_k$() {
        return 'Contato';
      }
      get_locationContactNameLabel_3ysqd5_k$() {
        return 'Nome do contato';
      }
      get_locationContactEmailLabel_efzqw6_k$() {
        return 'E-mail do contato';
      }
      get_locationContactPhoneLabel_4m2zrc_k$() {
        return 'Telefone do contato';
      }
      get_locationAddDialogTitle_cinmfn_k$() {
        return 'Adicionar uma unidade';
      }
      get_locationAddButton_95bquj_k$() {
        return 'Adicionar unidade';
      }
      get_locationAddedToast_8hz6sl_k$() {
        return 'Unidade adicionada!';
      }
      get_locationAddClosureButton_djcbau_k$() {
        return 'Adicionar fechamento';
      }
      get_locationDetailsSectionTitle_d2wrk9_k$() {
        return 'Detalhes da Unidade';
      }
      get_locationEditButton_aysohy_k$() {
        return 'Editar unidade';
      }
      get_locationProviderLabel_b4amqt_k$() {
        return 'Prestador';
      }
      get_locationActivePlacementsSectionTitle_nw2pyz_k$() {
        return 'Coloca\xE7\xF5es Ativas';
      }
      get_locationChildColumnLabel_8ikusg_k$() {
        return 'Crian\xE7a';
      }
      get_locationRateColumnLabel_aaazvk_k$() {
        return 'Tarifa';
      }
      get_locationActiveDatesColumnLabel_f4guo3_k$() {
        return 'Datas ativas';
      }
      get_locationAgreementStatusColumnLabel_dddsdc_k$() {
        return 'Status do acordo';
      }
      get_locationUnknownRateLabel_ltp6qw_k$() {
        return 'Tarifa desconhecida';
      }
      get_locationNoEndDateLabel_1tfruy_k$() {
        return 'sem data de t\xE9rmino';
      }
      locationDateRange_w0af9i_k$(start, end) {
        return start + ' \u2013 ' + end;
      }
      get_locationSaveButton_pcmeoj_k$() {
        return 'Salvar unidade';
      }
      get_locationSavedToast_9rc1s2_k$() {
        return 'Unidade salva!';
      }
      get_locationsPageTitle_w1kct0_k$() {
        return 'Unidades';
      }
      locationDetailTitle_rl62c8_k$(name) {
        return 'Unidade ' + name;
      }
      get_locationContactColumnLabel_7u4hlo_k$() {
        return 'Contato';
      }
      get_locationPhoneColumnLabel_xybcky_k$() {
        return 'Telefone';
      }
      get_locationRatesHeading_uw7hbn_k$() {
        return 'Tarifas';
      }
      get_locationAddRateButton_ve9lbf_k$() {
        return 'Adicionar tarifa';
      }
      get_locationPrototypeColumnLabel_7abp2e_k$() {
        return 'Modalidade';
      }
      get_locationPlanLabel_xccdpp_k$() {
        return 'Modelo';
      }
      get_locationUnknownPlanLabel_i0kgn5_k$() {
        return 'Plano desconhecido';
      }
      get_locationAttendanceHeading_qbmfph_k$() {
        return 'Frequ\xEAncia';
      }
      get_locationAddAttendancePeriodButton_2ztszj_k$() {
        return 'Adicionar per\xEDodo de frequ\xEAncia';
      }
      get_locationPeriodNotSubmittedStatus_xdso1l_k$() {
        return 'N\xE3o enviado';
      }
      get_locationPeriodNeedsApprovalStatus_1q9c99_k$() {
        return 'Enviado, aguardando aprova\xE7\xE3o';
      }
      get_locationClosureDateLabel_yxq7hz_k$() {
        return 'Data';
      }
      get_locationClosureKindColumnLabel_l2ckur_k$() {
        return 'Tipo';
      }
      locationChooseMonthSubtext_17dav3_k$(locationName) {
        return locationName + ' \u2014 escolha um m\xEAs que ainda n\xE3o tenha um.';
      }
      get_locationNoEligibleMonthsMessage_5awsde_k$() {
        return 'Todos os meses com coloca\xE7\xF5es nesta unidade j\xE1 t\xEAm um per\xEDodo.';
      }
      get_locationClosureUmbrellaWarning_b148pn_k$() {
        return 'Ser\xE1 aplicado a todas as unidades deste prestador.';
      }
      get_locationClosureSpecificLocationHint_htzknp_k$() {
        return 'Para criar um fechamento para uma unidade espec\xEDfica, acesse a p\xE1gina de detalhes dessa unidade.';
      }
      get_locationClosureReasonLabel_jr4c1f_k$() {
        return 'Motivo';
      }
      get_locationAddClosuresButton_8pcv03_k$() {
        return 'Adicionar fechamentos';
      }
      get_locationClosureAddedToast_kquvus_k$() {
        return 'Fechamento adicionado!';
      }
      get_locationPrototypeNameLabel_o3rt51_k$() {
        return 'Nome da modalidade';
      }
      get_locationSelectPlanPlaceholder_e7rncg_k$() {
        return 'Selecione um plano...';
      }
      get_locationRateAddedToast_4hcq1n_k$() {
        return 'Tarifa adicionada!';
      }
      get_rateInForceFromLabel_hamky5_k$() {
        return 'Em vigor a partir de';
      }
      get_rateLocationLabel_u8i4x6_k$() {
        return 'Unidade';
      }
      get_ratePlanLabel_6i1kny_k$() {
        return 'Plano';
      }
      get_rateChangeButton_dchwaz_k$() {
        return 'Alterar';
      }
      rateChangePlanTitle_kxriyt_k$(rateName) {
        return "Alterar a defini\xE7\xE3o de '" + rateName + "' para usar outro modelo";
      }
      get_rateStartingAtDateLabel_5za9na_k$() {
        return 'A partir da data';
      }
      get_rateToRateLabel_vgzx2o_k$() {
        return 'Nova tarifa';
      }
      rateChangeConfirmation_752i51_k$(targetName) {
        return 'Tenho CERTEZA de que quero mudar para ' + targetName + '. Isso \xE9 dif\xEDcil de desfazer!';
      }
      get_rateOnThisPlanSinceLabel_vdwh5j_k$() {
        return 'Neste plano desde';
      }
      get_rateCurrentRateHeading_hraq4y_k$() {
        return 'Tarifa atual';
      }
      get_rateLocationCurrentRateSubtext_i30vi_k$() {
        return 'O que esta modalidade paga hoje.';
      }
      get_ratePlanCurrentRateSubtext_41xbk6_k$() {
        return 'O que este plano paga hoje.';
      }
      get_rateCurrentChip_ej3r0k_k$() {
        return 'ATUAL';
      }
      rateInForceSince_kfs6_k$(range) {
        return 'Em vigor desde ' + range;
      }
      get_rateHistoryHeading_245zkn_k$() {
        return 'Hist\xF3rico de tarifas';
      }
      get_rateHistorySubtext_t3uw1u_k$() {
        return 'Gerado a partir das revis\xF5es do pr\xF3prio plano \u2014 n\xE3o edit\xE1vel aqui.';
      }
      get_rateInForceColumnLabel_elll5r_k$() {
        return 'Vig\xEAncia';
      }
      get_rateDailyRateColumnLabel_3eflwu_k$() {
        return 'Tarifa di\xE1ria';
      }
      get_rateTemplatesPageTitle_qntbdl_k$() {
        return 'Modelos de tarifas';
      }
      get_rateTemplatesHeading_o6frgy_k$() {
        return 'Modelos de tarifas de cuidado';
      }
      get_rateAddTemplateButton_h149ic_k$() {
        return 'Adicionar modelo de tarifa';
      }
      get_rateNameColumnLabel_44vut2_k$() {
        return 'Nome';
      }
      get_rateAddVersionButton_8qx842_k$() {
        return 'Adicionar vers\xE3o';
      }
      get_rateVersionHistoryHeading_go8cgt_k$() {
        return 'Hist\xF3rico de vers\xF5es';
      }
      get_rateVersionHistorySubtext_rd6t14_k$() {
        return 'Todas as vers\xF5es que este modelo j\xE1 teve. Uma vers\xE3o n\xE3o pode ser editada depois de criada. Para alterar uma tarifa, adicione uma nova vers\xE3o.';
      }
      get_rateNewVersionPageTitle_nfj0tk_k$() {
        return 'Nova vers\xE3o do modelo de tarifa';
      }
      rateAddVersionHeading_xp6sun_k$(templateName) {
        return 'Adicionar uma nova vers\xE3o a ' + templateName;
      }
      get_rateTemplateNameHeading_spoi4s_k$() {
        return 'Nome do modelo';
      }
      get_rateNewVersionFormHeading_o52csj_k$() {
        return 'Nova vers\xE3o';
      }
      get_rateAddTemplateSubmitButton_psnajo_k$() {
        return 'Adicionar modelo';
      }
      get_rateVersionAddedToast_45ku6u_k$() {
        return 'Vers\xE3o adicionada!';
      }
      get_rateNewTemplatePageTitle_o1z2rc_k$() {
        return 'Novo modelo de tarifa de cuidado';
      }
      get_rateNewTemplateHeading_sdjtlb_k$() {
        return 'Adicionar um novo modelo de tarifa de cuidado';
      }
      get_rateNameLabel_kv7vnk_k$() {
        return 'Nome';
      }
      get_rateShortNameLabel_odyqae_k$() {
        return 'Nome curto (como os locais o chamam)';
      }
      get_rateAgeStartLabel_lia3xk_k$() {
        return 'Idade m\xEDnima, em meses';
      }
      get_rateAgeEndLabel_j1qosv_k$() {
        return 'Deixa de se qualificar aos, em meses';
      }
      get_rateTransportOneWayLabel_hbgejv_k$() {
        return 'Transporte, um sentido';
      }
      get_rateTransportTwoWayLabel_x99pbj_k$() {
        return 'Transporte, ida e volta';
      }
      get_rateCareTimeLabel_lijrzh_k$() {
        return 'Hor\xE1rio de cuidado';
      }
      get_rateAvailableAsIntermittentLabel_h1v0mn_k$() {
        return 'Pode ser usado quando n\xE3o h\xE1 aula';
      }
      get_rateFirstVersionFormHeading_9520p9_k$() {
        return 'Primeira vers\xE3o';
      }
      get_rateTemplateAddedToast_3485d6_k$() {
        return 'Modelo adicionado!';
      }
      get_providerNameLabel_yl378x_k$() {
        return 'Nome';
      }
      get_providerContactLabel_6n76gi_k$() {
        return 'Contato';
      }
      get_providerContactNameLabel_l558ot_k$() {
        return 'Nome do contato';
      }
      get_providerContactEmailLabel_lc4wv2_k$() {
        return 'E-mail do contato';
      }
      get_providerContactPhoneLabel_umwegk_k$() {
        return 'Telefone do contato';
      }
      get_providerOffersTransportationLabel_8w5t13_k$() {
        return 'Oferece transporte';
      }
      get_providerAddDialogHeading_873vsd_k$() {
        return 'Adicionar um prestador';
      }
      get_providerAddButtonLabel_34jbj9_k$() {
        return 'Adicionar prestador';
      }
      get_providerAddedToast_i8f4wv_k$() {
        return 'Prestador adicionado!';
      }
      get_providerDetailsHeading_vbtsje_k$() {
        return 'Detalhes do Prestador';
      }
      get_providerEditButtonDescription_6z204a_k$() {
        return 'Editar prestador';
      }
      get_providerYesLabel_su34fb_k$() {
        return 'Sim';
      }
      get_providerNoLabel_wn67vr_k$() {
        return 'N\xE3o';
      }
      get_providerLocationsHeading_kilnxe_k$() {
        return 'Unidades';
      }
      get_providerAddLocationButtonLabel_ny6cyi_k$() {
        return 'Adicionar unidade';
      }
      get_providerCityLabel_2978ep_k$() {
        return 'Cidade';
      }
      get_providerSaveButtonLabel_8m3k6t_k$() {
        return 'Salvar prestador';
      }
      get_providerSavedToast_yjdohm_k$() {
        return 'Prestador salvo!';
      }
      get_providersPageTitle_5b613k_k$() {
        return 'Prestadores';
      }
      get_providerEmailLabel_uskhea_k$() {
        return 'E-mail';
      }
      get_providerPhoneLabel_l6gtxc_k$() {
        return 'Telefone';
      }
      get_providerVendorNumberLabel_cg5mi1_k$() {
        return 'N\xBA do fornecedor';
      }
      get_providerVendorNumberNotSet_vxdl2y_k$() {
        return '[n\xE3o definido]';
      }
      get_childAddDialogTitle_h9rjhe_k$() {
        return 'Adicionar uma crian\xE7a';
      }
      get_childAddButton_woryww_k$() {
        return 'Adicionar crian\xE7a';
      }
      get_childAddedToast_qv5dui_k$() {
        return 'Crian\xE7a adicionada!';
      }
      get_childFirstNameLabel_nfb0t0_k$() {
        return 'Nome';
      }
      get_childLastNameLabel_9cmbcw_k$() {
        return 'Sobrenome';
      }
      get_childBirthDateLabel_57yy4m_k$() {
        return 'Data de nascimento';
      }
      get_childRaceEthnicityLabel_1rbvt3_k$() {
        return 'Ra\xE7a/Etnia (selecione todas as que se aplicam)';
      }
      get_childNotesLabel_i49wca_k$() {
        return 'Observa\xE7\xF5es';
      }
      get_childDetailsHeading_m3xz5f_k$() {
        return 'Detalhes da Crian\xE7a';
      }
      childFamilyNameSuffix_vnbngi_k$(familyName) {
        return 'Fam\xEDlia ' + familyName;
      }
      get_childUnknownLabel_wvpdgd_k$() {
        return 'Desconhecido';
      }
      childBirthdateWithAge_961sp2_k$(birthDate, ageInMonths) {
        return birthDate + ' (' + ageInMonths + ' meses)';
      }
      get_childPlacementsHeading_tdetof_k$() {
        return 'Coloca\xE7\xF5es';
      }
      get_childTableHeaderLocation_z6m8z_k$() {
        return 'Unidade';
      }
      get_childTableHeaderRate_xtg0lk_k$() {
        return 'Tarifa';
      }
      get_childTableHeaderActiveDates_jvbf9l_k$() {
        return 'Datas ativas';
      }
      get_childTableHeaderAgreementStatus_cdpz04_k$() {
        return 'Status do acordo';
      }
      get_childUnknownLocationLabel_r43uzs_k$() {
        return 'Unidade desconhecida';
      }
      get_childUnknownProviderLabel_fsgzro_k$() {
        return 'Prestador desconhecido';
      }
      get_childUnknownRateLabel_o241ct_k$() {
        return 'Tarifa desconhecida';
      }
      get_childNoEndDateLabel_vluxrz_k$() {
        return 'sem data de t\xE9rmino';
      }
      get_childSaveButton_6zg7mm_k$() {
        return 'Salvar crian\xE7a';
      }
      get_childSavedToast_8lu59v_k$() {
        return 'Crian\xE7a salva!';
      }
      childPlacementDetailTitle_5imj30_k$(childName) {
        return 'Coloca\xE7\xE3o de ' + childName;
      }
      get_childPlacementDetailsHeading_q87f7y_k$() {
        return 'Detalhes da Coloca\xE7\xE3o';
      }
      signatureStatusLabel_agp5cg_k$(status) {
        var tmp;
        switch (status == null ? -1 : status.ordinal_1) {
          case -1:
          case 0:
            tmp = 'Enviando para assinatura';
            break;
          case 1:
          case 2:
            tmp = 'Enviado para assinatura';
            break;
          case 3:
            tmp = 'Assinado';
            break;
          case 4:
            tmp = 'Assinatura recusada';
            break;
          case 5:
            tmp = 'Documento anulado';
            break;
          case 6:
            tmp = 'Documento expirado';
            break;
          case 7:
            tmp = 'Status desconhecido';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
      get_childScheduleHeading_ybonig_k$() {
        return 'Hor\xE1rio';
      }
      get_childScheduleTableHeaderDay_gbtbl7_k$() {
        return 'Dia';
      }
      get_childScheduleTableHeaderTime_8yqyxq_k$() {
        return 'Hora';
      }
      get_childScheduleTableHeaderIntermittent_1zk9ks_k$() {
        return 'Intermitente';
      }
      get_childScheduleTableHeaderTransport_xh3sc8_k$() {
        return 'Transporte';
      }
      get_childNoLabel_jgme2o_k$() {
        return 'N\xE3o';
      }
      childTransportDescription_9po3ip_k$(transportFrom, transportTo) {
        return transportFrom && transportTo ? 'Ida e volta' : transportFrom ? 'De' : transportTo ? 'Para' : 'Nenhum';
      }
      get_childrenListTitle_3nn3hu_k$() {
        return 'Crian\xE7as';
      }
      get_childrenTableHeaderName_oazrcu_k$() {
        return 'Nome';
      }
      get_childrenTableHeaderFamily_fhtlt5_k$() {
        return 'Fam\xEDlia';
      }
      get_childrenTableHeaderBirthdate_iu407u_k$() {
        return 'Data de nascimento';
      }
      get_placementNewTitle_31boj8_k$() {
        return 'Nova Coloca\xE7\xE3o';
      }
      placementAddForChildTitle_tfmgtt_k$(childName) {
        return 'Adicionar uma coloca\xE7\xE3o para ' + childName;
      }
      get_placementDetailsHeading_3qgx4s_k$() {
        return 'Detalhes';
      }
      get_placementCareLocationLabel_w1cbma_k$() {
        return 'Unidade de cuidado';
      }
      get_placementSearchIconDescription_uuv8wx_k$() {
        return 'Buscar';
      }
      placementLocationWithProvider_dft4wy_k$(locationName, providerName) {
        var tmp;
        if (providerName == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = ' \xB7 ' + providerName;
        }
        var tmp1_elvis_lhs = tmp;
        return locationName + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
      }
      get_placementSelectCareLocationPlaceholder_zi5v79_k$() {
        return 'Selecione uma unidade de cuidado...';
      }
      get_placementChooseCareLocationTitle_7rzjtt_k$() {
        return 'Escolha uma unidade de cuidado';
      }
      get_placementNoCareLocationsMatch_lqc8l_k$() {
        return 'Nenhuma unidade de cuidado corresponde.';
      }
      get_placementStartDateLabel_lvccn4_k$() {
        return 'Data de in\xEDcio';
      }
      get_placementEndDateLabel_oohsnt_k$() {
        return 'Data de t\xE9rmino';
      }
      get_placementFundingHeading_tzzalb_k$() {
        return 'Financiamento';
      }
      get_placementPaidByGrantsLabel_y96mde_k$() {
        return 'Pago por (subs\xEDdios)';
      }
      get_placementChooseGrantsTitle_w90u32_k$() {
        return 'Escolha subs\xEDdios';
      }
      get_placementSendForSignatureTitle_fzt0kl_k$() {
        return 'Enviar para assinatura?';
      }
      get_placementSendForSignatureBody_ualg6t_k$() {
        return 'Os documentos ser\xE3o enviados para assinatura. Se forem necess\xE1rias altera\xE7\xF5es, uma nova coloca\xE7\xE3o deve ser criada e esta encerrada.';
      }
      get_placementSaveAndSendButton_qp8w94_k$() {
        return 'Salvar e enviar para assinatura';
      }
      get_placementAddedToast_9n8dct_k$() {
        return 'Coloca\xE7\xE3o adicionada!';
      }
      get_placementNoneSelectedLabel_ryp2xn_k$() {
        return 'Nenhum selecionado';
      }
      get_placementNoOptionsFoundLabel_67d80d_k$() {
        return 'Nenhuma op\xE7\xE3o encontrada.';
      }
      get_placementDoneButton_4je2q8_k$() {
        return 'Conclu\xEDdo';
      }
      get_childEditButton_7edijz_k$() {
        return 'Editar crian\xE7a';
      }
      get_childFamilyLabel_zden0d_k$() {
        return 'Fam\xEDlia';
      }
      get_childBirthdateLabel_wo149m_k$() {
        return 'Data de nascimento';
      }
      get_childAddPlacementButton_ol20h5_k$() {
        return 'Adicionar coloca\xE7\xE3o';
      }
      get_childPlacementChildLabel_g8ybd6_k$() {
        return 'Crian\xE7a';
      }
      get_childPlacementProviderLabel_a3mqvj_k$() {
        return 'Prestador';
      }
      get_childPlacementGrantsLabel_lannsl_k$() {
        return 'Subs\xEDdios';
      }
      get_placementSearchLocationHint_kl76yo_k$() {
        return 'Buscar nome da unidade';
      }
      get_placementTransportFromLabel_xf7eqr_k$() {
        return 'Transporte de';
      }
      get_placementTransportToLabel_ai59v0_k$() {
        return 'Transporte para';
      }
      get_placementSearchHint_64804r_k$() {
        return 'Buscar';
      }
      get_childCopyPlacementButton_2566k1_k$() {
        return 'Copiar coloca\xE7\xE3o';
      }
      get_placementChangeEndButton_9y5npd_k$() {
        return 'Alterar data de t\xE9rmino';
      }
      get_placementEndReasonLabel_2y0sr5_k$() {
        return 'Motivo do t\xE9rmino';
      }
      get_placementEndReasonPlaceholder_rzs88g_k$() {
        return 'Selecione um motivo';
      }
      get_placementEndReasonNotesLabel_6gz5fa_k$() {
        return 'Detalhes do motivo';
      }
      get_childPlacementAgreementLabel_a4ki58_k$() {
        return 'Acordo de coloca\xE7\xE3o';
      }
      get_childPlacementAgreementNoneSet_y46u4u_k$() {
        return 'N\xE3o definido';
      }
      get_childNotScheduledLabel_mg5553_k$() {
        return 'N\xE3o programado';
      }
      get_placementWhenSchoolIsOutLabel_som316_k$() {
        return 'Quando n\xE3o h\xE1 aula';
      }
      get_placementNotIntermittentLabel_4hk03a_k$() {
        return 'N\xE3o intermitente';
      }
      placementPreviousEndChangeMessage_u9z0qq_k$(previousEnd, cutoff, newStart) {
        return 'A coloca\xE7\xE3o anterior atualmente termina em ' + previousEnd + '. Em vez disso, ela ser\xE1 encerrada em ' + cutoff + ', o dia anterior ao in\xEDcio desta coloca\xE7\xE3o em ' + newStart + '.';
      }
      get_familyFirstNameLabel_j5nup2_k$() {
        return 'Nome';
      }
      get_familyLastNameLabel_slk1mi_k$() {
        return 'Sobrenome';
      }
      get_familyPhoneNumberLabel_28h2zu_k$() {
        return 'N\xFAmero de telefone';
      }
      get_familyAlternatePhoneLabel_sqbdsj_k$() {
        return 'N\xFAmero de telefone adicional (opcional)';
      }
      get_familyEmailLabel_ow4s1n_k$() {
        return 'E-mail';
      }
      get_familyPreferredLanguageLabel_sqcw94_k$() {
        return 'Idioma preferido';
      }
      get_familyRaceEthnicityLabel_z00d2r_k$() {
        return 'Ra\xE7a/Etnia (selecione todas as que se aplicam)';
      }
      get_familyAddSecondParentLabel_6zuz7m_k$() {
        return 'Adicionar segundo respons\xE1vel';
      }
      get_familyAddressLabel_jhvmgd_k$() {
        return 'Endere\xE7o';
      }
      get_familyStreetAddressLabel_hc5wvk_k$() {
        return 'Logradouro';
      }
      get_familyAptSuiteLabel_c6ev78_k$() {
        return 'Apto, sala, etc. (opcional)';
      }
      get_familyCityLabel_9p20yk_k$() {
        return 'Cidade';
      }
      get_familyStateLabel_kkdf00_k$() {
        return 'Estado';
      }
      get_familyZipcodeLabel_v3fgfh_k$() {
        return 'CEP';
      }
      get_familyAnnualIncomeLabel_nsky2p_k$() {
        return 'Renda Anual';
      }
      get_familySizeLabel_ytosca_k$() {
        return 'Tamanho da Fam\xEDlia';
      }
      get_familyPreferNotToSayLabel_t7jcq_k$() {
        return 'Prefiro n\xE3o dizer';
      }
      familyDetailTitle_gwlhpl_k$(familyName) {
        return 'Fam\xEDlia ' + familyName;
      }
      get_familyDetailsSectionTitle_mepryw_k$() {
        return 'Detalhes da Fam\xEDlia';
      }
      get_familyEditIconDescription_ebeqi4_k$() {
        return 'Editar fam\xEDlia';
      }
      get_familyPrimaryParentLabel_xb85ed_k$() {
        return 'Respons\xE1vel principal';
      }
      get_familyPrimaryEmailLabel_sxbo19_k$() {
        return 'E-mail principal';
      }
      get_familyPrimaryPhoneLabel_n1pnad_k$() {
        return 'Telefone principal';
      }
      get_familyPrimaryAlternatePhoneLabel_l533dh_k$() {
        return 'Telefone alternativo principal';
      }
      get_familySecondaryParentLabel_xd744d_k$() {
        return 'Respons\xE1vel secund\xE1rio';
      }
      get_familySecondaryEmailLabel_1kj0yn_k$() {
        return 'E-mail secund\xE1rio';
      }
      get_familySecondaryPhoneLabel_kmlrm5_k$() {
        return 'Telefone secund\xE1rio';
      }
      get_familySecondaryAlternatePhoneLabel_rncxqf_k$() {
        return 'Telefone alternativo secund\xE1rio';
      }
      get_familyInformationVerifiedLabel_5tuhwz_k$() {
        return 'Informa\xE7\xF5es verificadas';
      }
      get_familyNotVerifiedLabel_31381m_k$() {
        return 'N\xE3o verificada';
      }
      get_familyChildrenSectionTitle_2sss81_k$() {
        return 'Crian\xE7as';
      }
      get_familyAddChildButton_udkhcq_k$() {
        return 'Adicionar crian\xE7a';
      }
      get_familyNameColumnLabel_yh58ca_k$() {
        return 'Nome';
      }
      get_familyBirthdateAgeColumnLabel_djfnz5_k$() {
        return 'Data de nascimento/Idade';
      }
      get_familyActivePlacementColumnLabel_repll8_k$() {
        return 'Coloca\xE7\xE3o Ativa';
      }
      familyPlacementSummary_u4ho0l_k$(provider, location, status) {
        return provider + ' \xB7 ' + location + ' \xB7 ' + status;
      }
      get_familySaveFamilyButton_40ppb4_k$() {
        return 'Salvar fam\xEDlia';
      }
      get_familySavedToast_l5bkyb_k$() {
        return 'Fam\xEDlia salva!';
      }
      get_familyListTitle_7vfhpp_k$() {
        return 'Fam\xEDlias';
      }
      get_familyAddFamilyButton_qgzmly_k$() {
        return 'Adicionar fam\xEDlia';
      }
      get_familyColumnLabel_vxra7j_k$() {
        return 'Fam\xEDlia';
      }
      get_familyCityColumnLabel_bqfeje_k$() {
        return 'Cidade';
      }
      get_familyNewFamilyTitle_u18ivz_k$() {
        return 'Nova Fam\xEDlia';
      }
      get_familyAddPageTitle_rl7n91_k$() {
        return 'Adicionar uma fam\xEDlia';
      }
      get_familyAddedToast_2w0cdo_k$() {
        return 'Fam\xEDlia adicionada!';
      }
      get_familyApplicationListTitle_c6ygp5_k$() {
        return 'Solicita\xE7\xF5es de Fam\xEDlias';
      }
      get_familyApplicationColumnSentTo_7zvbzg_k$() {
        return 'Enviado Para';
      }
      get_familyApplicationColumnEmployer_c2b99w_k$() {
        return 'Empregador';
      }
      get_familyApplicationColumnStatus_87vyuj_k$() {
        return 'Status';
      }
      get_familyApplicationColumnInvitedAt_esy33p_k$() {
        return 'Convidado';
      }
      familyApplicationDetailTitle_7az5kv_k$(sentTo) {
        return 'Solicita\xE7\xE3o - ' + sentTo;
      }
      get_familyApplicationSentToLabel_u2by72_k$() {
        return 'Enviado Para';
      }
      get_familyApplicationEmployerLabel_w3sr2u_k$() {
        return 'Empregador';
      }
      get_familyApplicationStatusLabel_3spxtr_k$() {
        return 'Status';
      }
      get_familyApplicationNotSubmittedLabel_1cvz7t_k$() {
        return 'Ainda n\xE3o enviado';
      }
      get_familyApplicationApproveButton_w2gak_k$() {
        return 'Aprovar';
      }
      get_familyApplicationApproveConfirmHeading_oqxjis_k$() {
        return 'Aprovar esta solicita\xE7\xE3o?';
      }
      get_familyApplicationApproveConfirmBody_j98ydk_k$() {
        return 'Isso criar\xE1 o registro da fam\xEDlia (e dos filhos) a partir das informa\xE7\xF5es enviadas.';
      }
      get_familyApplicationApprovedToast_ghct71_k$() {
        return 'Solicita\xE7\xE3o aprovada';
      }
      get_familyApplicationRejectedToast_5xw86e_k$() {
        return 'Solicita\xE7\xE3o rejeitada';
      }
      get_providerApplicationListTitle_52jvb0_k$() {
        return 'Solicita\xE7\xF5es de Provedores';
      }
      get_providerApplicationColumnSentTo_l9kj27_k$() {
        return 'Enviado Para';
      }
      get_providerApplicationColumnInvitedAt_xa4eri_k$() {
        return 'Convidado';
      }
      get_providerApplicationColumnStatus_lhl5xa_k$() {
        return 'Status';
      }
      providerApplicationDetailTitle_7oej8u_k$(sentTo) {
        return 'Solicita\xE7\xE3o - ' + sentTo;
      }
      get_providerApplicationSentToLabel_fc0az9_k$() {
        return 'Enviado Para';
      }
      get_providerApplicationStatusLabel_tfhqmk_k$() {
        return 'Status';
      }
      get_providerApplicationNotSubmittedLabel_wjkrfa_k$() {
        return 'Ainda n\xE3o enviado';
      }
      get_providerApplicationApproveButton_dxws6v_k$() {
        return 'Aprovar';
      }
      get_providerApplicationApproveConfirmHeading_ifddmh_k$() {
        return 'Aprovar esta solicita\xE7\xE3o?';
      }
      get_providerApplicationApproveConfirmBody_o3mmdn_k$() {
        return 'Isso criar\xE1 o registro do provedor de cuidado a partir das informa\xE7\xF5es enviadas.';
      }
      get_providerApplicationApprovedToast_1ndkpm_k$() {
        return 'Solicita\xE7\xE3o aprovada';
      }
      get_providerApplicationRejectedToast_8w30b1_k$() {
        return 'Solicita\xE7\xE3o rejeitada';
      }
      get_employerNameLabel_rr9lvp_k$() {
        return 'Nome';
      }
      get_employerContactLabel_f0mfyw_k$() {
        return 'Contato';
      }
      get_employerContactNameLabel_h6hpwz_k$() {
        return 'Nome do contato';
      }
      get_employerContactEmailLabel_245yvo_k$() {
        return 'E-mail do contato';
      }
      get_employerContactPhoneLabel_l68pj6_k$() {
        return 'Telefone do contato';
      }
      get_employerEmailColumnLabel_siw8re_k$() {
        return 'E-mail';
      }
      get_employerPhoneColumnLabel_nv3puc_k$() {
        return 'Telefone';
      }
      get_employerBillingAddressLabel_ppg2x_k$() {
        return 'Endere\xE7o de cobran\xE7a';
      }
      get_employerAddBillingAddressLabel_f9xuim_k$() {
        return 'Adicionar endere\xE7o de cobran\xE7a';
      }
      get_employerBillingContactLabel_g1s2i3_k$() {
        return 'Contato de cobran\xE7a';
      }
      get_employerBillingContactNameLabel_2furfk_k$() {
        return 'Nome do contato de cobran\xE7a';
      }
      get_employerStreetAddressLabel_hfp9k7_k$() {
        return 'Logradouro';
      }
      get_employerAptSuiteLabel_72k85f_k$() {
        return 'Apto, sala, etc. (opcional)';
      }
      get_employerCityLabel_axyh97_k$() {
        return 'Cidade';
      }
      get_employerStateLabel_k0y83r_k$() {
        return 'Estado';
      }
      get_employerZipcodeLabel_ioxwh6_k$() {
        return 'CEP';
      }
      get_employerAddDialogHeading_48gd0j_k$() {
        return 'Adicionar um empregador';
      }
      get_employerAddButton_d87ox_k$() {
        return 'Adicionar empregador';
      }
      get_employerAddedToast_3ffj9x_k$() {
        return 'Empregador adicionado!';
      }
      get_employerDetailsHeading_ytinek_k$() {
        return 'Detalhes do empregador';
      }
      get_employerEditButtonDescription_ojdqak_k$() {
        return 'Editar empregador';
      }
      get_employerActiveLabel_isbluy_k$() {
        return 'Ativo';
      }
      get_employerYesLabel_5tbbwv_k$() {
        return 'Sim';
      }
      get_employerNoLabel_ue8l8v_k$() {
        return 'N\xE3o';
      }
      get_employerBalanceLabel_le7jmk_k$() {
        return 'Saldo';
      }
      get_employerBalanceNotSynced_t35ga3_k$() {
        return 'N\xE3o sincronizado';
      }
      get_employerRatesHeading_d9zhxv_k$() {
        return 'Tarifas';
      }
      get_employerRatesSubtext_urfnk2_k$() {
        return 'O que este empregador paga por dia de cuidado.';
      }
      get_employerAddNewRateButton_3qdhmd_k$() {
        return 'Adicionar nova tarifa';
      }
      get_employerShareOfDayLabel_l9g9iu_k$() {
        return 'Parcela do empregador por um dia';
      }
      get_employerShareColumnLabel_p5bseb_k$() {
        return 'Parcela do empregador';
      }
      get_employerAdministrationColumnLabel_s4ljqc_k$() {
        return 'Administra\xE7\xE3o';
      }
      get_employerSaveButton_xr2x83_k$() {
        return 'Salvar empregador';
      }
      get_employerSavedToast_loqruk_k$() {
        return 'Empregador salvo!';
      }
      get_employerNewRatePageTitle_lgm6tv_k$() {
        return 'Nova tarifa de empregador';
      }
      employerAddRateHeading_yj9ltq_k$(employerName) {
        return 'Adicionar uma tarifa para ' + employerName;
      }
      get_employerAddRateButton_bne9o1_k$() {
        return 'Adicionar tarifa';
      }
      get_employerRateAddedToast_vme6ol_k$() {
        return 'Tarifa adicionada!';
      }
      get_userNameLabel_jnppqj_k$() {
        return 'Nome';
      }
      get_userEmailLabel_3oltlg_k$() {
        return 'E-mail';
      }
      get_userPhoneLabel_fdgx22_k$() {
        return 'Telefone';
      }
      get_userRoleLabel_yi9o5y_k$() {
        return 'Fun\xE7\xE3o';
      }
      get_userDetailsSectionTitle_o8ze3l_k$() {
        return 'Detalhes do usu\xE1rio';
      }
      get_userEditIconDescription_a205ej_k$() {
        return 'Editar usu\xE1rio';
      }
      get_grantNameLabel_7luufe_k$() {
        return 'Nome';
      }
      get_grantFunderLabel_2sx24x_k$() {
        return 'Financiador';
      }
      get_grantAwardPeriodLabel_m5ymnd_k$() {
        return 'Per\xEDodo do subs\xEDdio';
      }
      get_grantStartDateLabel_la3b0p_k$() {
        return 'Data de in\xEDcio';
      }
      get_grantAddEndDateLabel_xwlt5z_k$() {
        return 'Adicionar data de t\xE9rmino';
      }
      get_grantEndDateLabel_vuktgi_k$() {
        return 'Data de t\xE9rmino';
      }
      get_grantAddDialogHeading_vr5wfo_k$() {
        return 'Adicionar um subs\xEDdio';
      }
      get_grantAddButton_zardz4_k$() {
        return 'Adicionar subs\xEDdio';
      }
      get_grantAddedToast_y9kr6u_k$() {
        return 'Subs\xEDdio adicionado!';
      }
      get_grantDetailsHeading_4bpyr7_k$() {
        return 'Detalhes do subs\xEDdio';
      }
      get_grantEditButtonDescription_abff03_k$() {
        return 'Editar subs\xEDdio';
      }
      get_grantBalanceLabel_6ku5mz_k$() {
        return 'Saldo';
      }
      get_grantBalanceNotSynced_ef929w_k$() {
        return 'N\xE3o sincronizado';
      }
      get_grantRatesHeading_1jdw1q_k$() {
        return 'Tarifas';
      }
      get_grantRatesSubtext_pgb0fh_k$() {
        return 'Como este subs\xEDdio combina com um dia de cuidado.';
      }
      get_grantAddNewRateButton_nsc1ss_k$() {
        return 'Adicionar nova tarifa';
      }
      get_grantShareOfDayLabel_f9y45h_k$() {
        return 'Contrapartida do subs\xEDdio por um dia';
      }
      get_grantShareColumnLabel_2ddr0u_k$() {
        return 'Contrapartida do subs\xEDdio';
      }
      get_grantSaveButton_2wxpb6_k$() {
        return 'Salvar subs\xEDdio';
      }
      get_grantSavedToast_ii827n_k$() {
        return 'Subs\xEDdio salvo!';
      }
      get_grantNewRatePageTitle_m1sbq4_k$() {
        return 'Nova tarifa de subs\xEDdio';
      }
      grantAddRateHeading_rhf7ur_k$(grantName) {
        return 'Adicionar uma tarifa para ' + grantName;
      }
      get_grantAddRateButton_q9v2io_k$() {
        return 'Adicionar tarifa';
      }
      get_grantRateAddedToast_7iufh6_k$() {
        return 'Tarifa adicionada!';
      }
      get_remittancesPageTitle_yno01p_k$() {
        return 'Repasses';
      }
      get_remittancesPreviousMonthDescription_c46s75_k$() {
        return 'M\xEAs anterior';
      }
      get_remittancesNextMonthDescription_472mkb_k$() {
        return 'Pr\xF3ximo m\xEAs';
      }
      get_remittancesProviderColumn_b68mq5_k$() {
        return 'Prestador';
      }
      get_remittancesStatusColumn_9ruzm4_k$() {
        return 'Status';
      }
      get_closeOutAttendanceIncomplete_qvityy_k$() {
        return 'Frequ\xEAncia incompleta';
      }
      get_closeOutAttendanceReviewNeeded_5v2tud_k$() {
        return 'Revis\xE3o de frequ\xEAncia pendente';
      }
      get_closeOutReadyForRemittance_zhgfk3_k$() {
        return 'Pronto para repasse';
      }
      get_closeOutComplete_hpmhjs_k$() {
        return 'Conclu\xEDdo';
      }
      get_remittancesAmountColumn_vm5mg6_k$() {
        return 'Valor';
      }
      get_closeOutPageTitle_igqf2i_k$() {
        return 'Fechar m\xEAs';
      }
      get_remittancesDatesColumn_sy3n9t_k$() {
        return 'Datas';
      }
      get_remittanceVoided_7coapm_k$() {
        return 'Anulado';
      }
      get_remittanceReviewPageTitle_w5gryu_k$() {
        return 'Revisar repasse';
      }
      remittanceReviewHeading_bk4mmq_k$(providerName) {
        return 'Revisar repasse: ' + providerName;
      }
      remittanceProblemsHeading_lc0nvc_k$(count) {
        return count === 1 ? '1 coloca\xE7\xE3o n\xE3o pode ser tarifada' : '' + count + ' coloca\xE7\xF5es n\xE3o podem ser tarifadas';
      }
      remittanceIssueButton_tu58r7_k$(amount) {
        return 'Emitir ' + amount;
      }
      get_remittanceIssueConfirmHeading_bxfsjw_k$() {
        return 'Emitir este repasse?';
      }
      get_remittanceIssueConfirmBody_1w6k7k_k$() {
        return 'Uma vez emitido, o valor \xE9 registrado como o que \xE9 devido a este prestador pelo per\xEDodo e n\xE3o mudar\xE1.';
      }
      get_remittanceIssueConfirmButton_qtcw1s_k$() {
        return 'Emitir';
      }
      get_remittanceDetailPageTitle_pimg0h_k$() {
        return 'Repasse';
      }
      get_remittanceStatusLabel_ozb6h1_k$() {
        return 'Status';
      }
      get_remittanceIssuedAtLabel_sk6ikx_k$() {
        return 'Emitido';
      }
      get_remittanceAmountLabel_u9neaz_k$() {
        return 'Valor';
      }
      get_remittanceChildrenLabel_g31cj6_k$() {
        return 'Crian\xE7as';
      }
      get_remittanceDaysBilledLabel_iaro0g_k$() {
        return 'Dias faturados';
      }
      get_remittanceCostOfCareLabel_pxj9qw_k$() {
        return 'Custo do cuidado';
      }
      get_remittanceEmployerSharesLabel_p173b2_k$() {
        return 'Parcelas dos empregadores';
      }
      get_remittanceGrantSharesLabel_3d2smj_k$() {
        return 'Parcelas dos subs\xEDdios';
      }
      get_remittanceFamilyPaysLabel_f1jlxa_k$() {
        return 'A fam\xEDlia paga \xE0 unidade';
      }
      get_remittanceTcgPaysLabel_z6hcxk_k$() {
        return 'A TCG paga ao prestador';
      }
      get_remittanceAdministrationLabel_spr4f_k$() {
        return 'Cobran\xE7as de administra\xE7\xE3o';
      }
      get_remittanceDayAttendanceLabel_y52ora_k$() {
        return 'Frequ\xEAncia';
      }
      get_remittanceDayProgramLabel_7icdid_k$() {
        return 'Programa';
      }
      get_surveyTakeSubmitButton_gkww0k_k$() {
        return 'Enviar respostas';
      }
      get_surveyTakeNeedAnswerToast_561g7r_k$() {
        return 'Responda pelo menos uma pergunta primeiro.';
      }
      get_surveyTakeThanksToast_6r9hqk_k$() {
        return 'Obrigado! Suas respostas foram registradas.';
      }
      get_surveyTakeSavedToast_evm8s6_k$() {
        return 'Respostas salvas. Voc\xEA pode terminar o restante mais tarde.';
      }
      get_surveyOptionalLabel_i973rl_k$() {
        return '(opcional)';
      }
      get_surveyCompletedText_anx46t_k$() {
        return 'Voc\xEA concluiu esta pesquisa. Obrigado!';
      }
      get_surveyTakeAgainButton_c6h420_k$() {
        return 'Responder novamente';
      }
      get_surveyAnsweringForLabel_wb231w_k$() {
        return 'Respondendo por';
      }
      get_surveyLeadershipQuestion_pd6bg2_k$() {
        return 'Qual das op\xE7\xF5es a seguir melhor descreve suas responsabilidades de lideran\xE7a atuais na [company]?';
      }
      get_surveyLeadershipManagesNoOne_4fq5q9_k$() {
        return 'N\xE3o gerencio ningu\xE9m';
      }
      get_surveyLeadershipManagesEmployees_jcz2fz_k$() {
        return 'Gerencio funcion\xE1rios';
      }
      get_surveyLeadershipManagesManagers_3jp6do_k$() {
        return 'Gerencio funcion\xE1rios que gerenciam outros funcion\xE1rios';
      }
      get_surveyLeadershipSeniorLeader_he8vsv_k$() {
        return 'Sou um l\xEDder s\xEAnior na minha organiza\xE7\xE3o';
      }
      get_surveyIncomeQuestion_em6voy_k$() {
        return 'Qual \xE9 a sua renda anual aproximada na [company]?';
      }
      get_surveyContinueButton_w6kl50_k$() {
        return 'Continuar';
      }
      get_surveyLanguageLabel_fcb89_k$() {
        return 'Idioma';
      }
      get_remittanceAbsencesLabel_s31xd5_k$() {
        return 'Faltas';
      }
      remittanceAbsencesValue_hrzn9f_k$(explained, unexplained) {
        return '' + (explained + unexplained | 0) + ' (' + explained + ' justificadas, ' + unexplained + ' n\xE3o justificadas)';
      }
      get_remittanceChildTotalsHeading_ish2aq_k$() {
        return 'Dias por crian\xE7a';
      }
      get_remittanceChildTotalsHint_sqdm97_k$() {
        return 'Selecione uma crian\xE7a para ver o m\xEAs dela.';
      }
      get_remittanceChildColumn_w7inzf_k$() {
        return 'Crian\xE7a';
      }
      get_remittanceDaysColumn_y81ogk_k$() {
        return 'Dias';
      }
      remittanceIntermittentColumn_diw8ct_k$(careTime) {
        return careTime + ' intermitente';
      }
      get_remittanceTransportOneWayColumn_7s8g1t_k$() {
        return 'Transporte s\xF3 ida';
      }
      get_remittanceTransportTwoWayColumn_2m8bh7_k$() {
        return 'Transporte ida e volta';
      }
      get_remittanceExplainedAbsencesColumn_949z39_k$() {
        return 'Faltas justificadas';
      }
      get_remittanceUnexplainedAbsencesColumn_7oks0u_k$() {
        return 'Faltas n\xE3o justificadas';
      }
      get_remittanceFamilyPaysColumn_yxf9kk_k$() {
        return 'Fam\xEDlia paga';
      }
      get_remittanceTcgPaysColumn_l2qjv6_k$() {
        return 'TCG paga';
      }
      get_remittanceGrandTotal_q37hep_k$() {
        return 'Total geral';
      }
      get_remittanceOpenPlacementButton_cb7i92_k$() {
        return 'Abrir coloca\xE7\xE3o';
      }
    }
    initMetadataForClass($, 'Portuguese');
    StringsForLanguage$PortugueseClass = $;
  }
  return StringsForLanguage$PortugueseClass;
}
var StringsForLanguage_Portuguese_instance;
function values() {
  static_init();
  return [StringsForLanguage_English_getInstance(), StringsForLanguage_Code_getInstance(), StringsForLanguage_Spanish_getInstance(), StringsForLanguage_Portuguese_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, StringsForLanguage$Companion$_anonymous__7esads);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  static_init();
  return Companion_instance_0;
}
var $ENTRIES;
var StringsForLanguageClass;
function StringsForLanguage() {
  if (StringsForLanguageClass === VOID) {
    class $ extends Enum() {}
    protoOf($).get_navDashboardTitle_9up0g2_k$ = get_navDashboardTitle;
    protoOf($).get_navFormulaLabTitle_ewi7uf_k$ = get_navFormulaLabTitle;
    protoOf($).get_navSignOutTitle_jmnskh_k$ = get_navSignOutTitle;
    protoOf($).get_navSwitchLanguageTitle_6fj9xq_k$ = get_navSwitchLanguageTitle;
    protoOf($).get_navProvidersTitle_oa0ysw_k$ = get_navProvidersTitle;
    protoOf($).get_navCareLocationsTitle_2k6n4r_k$ = get_navCareLocationsTitle;
    protoOf($).get_navEmployersTitle_5ougl6_k$ = get_navEmployersTitle;
    protoOf($).get_navGrantsTitle_6gc2p3_k$ = get_navGrantsTitle;
    protoOf($).get_navRemittancesTitle_qthgnx_k$ = get_navRemittancesTitle;
    protoOf($).get_navCloseOutTitle_69wx5k_k$ = get_navCloseOutTitle;
    protoOf($).get_navUsersTitle_3xs496_k$ = get_navUsersTitle;
    protoOf($).get_navProfileTitle_ud0y1_k$ = get_navProfileTitle;
    protoOf($).get_notificationsPromptTitle_6gox63_k$ = get_notificationsPromptTitle;
    protoOf($).get_notificationsPromptBody_22ny2t_k$ = get_notificationsPromptBody;
    protoOf($).get_notificationsPromptAllow_6r39bu_k$ = get_notificationsPromptAllow;
    protoOf($).get_crudGroupProgramTitle_ph6e0k_k$ = get_crudGroupProgramTitle;
    protoOf($).get_crudGroupNetworkTitle_o69yjm_k$ = get_crudGroupNetworkTitle;
    protoOf($).get_crudGroupFundingTitle_rkjttf_k$ = get_crudGroupFundingTitle;
    protoOf($).get_crudGroupAdminTitle_bj6jxb_k$ = get_crudGroupAdminTitle;
    protoOf($).get_crudCancelButton_yk4tir_k$ = get_crudCancelButton;
    protoOf($).get_crudSaveButton_lsaoza_k$ = get_crudSaveButton;
    protoOf($).get_crudSavedToast_xnj03d_k$ = get_crudSavedToast;
    protoOf($).get_appTagline_r1snd6_k$ = get_appTagline;
    protoOf($).get_closurePaidLabel_brac2y_k$ = get_closurePaidLabel;
    protoOf($).get_closureUnpaidLabel_5pnjh9_k$ = get_closureUnpaidLabel;
    protoOf($).dateRangeOnwards_e67e9b_k$ = dateRangeOnwards;
    protoOf($).get_exportCsvButton_84ycf9_k$ = get_exportCsvButton;
    protoOf($).get_goBackDescription_2wlgbo_k$ = get_goBackDescription;
    protoOf($).get_emptyRowText_pvodpf_k$ = get_emptyRowText;
    protoOf($).get_searchIconDescription_c0d0b6_k$ = get_searchIconDescription;
    protoOf($).get_validationInvalidPhoneMessage_cvge1e_k$ = get_validationInvalidPhoneMessage;
    protoOf($).get_validationInvalidEmailMessage_1bjpq8_k$ = get_validationInvalidEmailMessage;
    protoOf($).get_landingPageTitle_9rfr0l_k$ = get_landingPageTitle;
    protoOf($).get_loginPageTitle_1ofql3_k$ = get_loginPageTitle;
    protoOf($).get_loginPrompt_y6r4qs_k$ = get_loginPrompt;
    protoOf($).get_loginServerFieldLabel_24y76r_k$ = get_loginServerFieldLabel;
    protoOf($).get_homePageTitle_o7pge7_k$ = get_homePageTitle;
    protoOf($).get_homeEmptyStateMessage_lc9n17_k$ = get_homeEmptyStateMessage;
    protoOf($).get_homeApplicationsHeading_6tsmjb_k$ = get_homeApplicationsHeading;
    protoOf($).get_homeApplicationsIntro_9aamv3_k$ = get_homeApplicationsIntro;
    protoOf($).get_homeApplicationCardTitle_1x2b5s_k$ = get_homeApplicationCardTitle;
    protoOf($).get_homeProviderApplicationCardTitle_6vkqdt_k$ = get_homeProviderApplicationCardTitle;
    protoOf($).homeApplicationInvitedOn_fh8p3l_k$ = homeApplicationInvitedOn;
    protoOf($).get_homeApplicationStatusActionNeeded_pm6rp_k$ = get_homeApplicationStatusActionNeeded;
    protoOf($).get_homeApplicationStatusSubmitted_7i53pd_k$ = get_homeApplicationStatusSubmitted;
    protoOf($).get_homeApplicationStatusApproved_5joi6n_k$ = get_homeApplicationStatusApproved;
    protoOf($).get_homeApplicationStatusRejected_z7mlvs_k$ = get_homeApplicationStatusRejected;
    protoOf($).get_homeApplicationStartButton_tv1v5g_k$ = get_homeApplicationStartButton;
    protoOf($).get_homeApplicationContinueButton_kfmgbj_k$ = get_homeApplicationContinueButton;
    protoOf($).get_checkVersionTitle_5bcopt_k$ = get_checkVersionTitle;
    protoOf($).checkVersionRequiredBody_la1fe1_k$ = checkVersionRequiredBody;
    protoOf($).checkVersionOptionalBody_2r7vzs_k$ = checkVersionOptionalBody;
    protoOf($).get_checkVersionOkButton_hri5kp_k$ = get_checkVersionOkButton;
    protoOf($).attendanceNeedsEntryMessage_grklld_k$ = attendanceNeedsEntryMessage;
    protoOf($).get_submitAttendance_kcxskq_k$ = get_submitAttendance;
    protoOf($).get_attendanceChildScheduleColumnLabel_gdvgn7_k$ = get_attendanceChildScheduleColumnLabel;
    protoOf($).attendancePeriodPageTitle_p6ycjf_k$ = attendancePeriodPageTitle;
    protoOf($).attendanceLocationLabel_w7cjz0_k$ = attendanceLocationLabel;
    protoOf($).attendanceProviderLabel_uwtfq8_k$ = attendanceProviderLabel;
    protoOf($).get_attendancePeriodLabel_4v4nxb_k$ = get_attendancePeriodLabel;
    protoOf($).get_attendanceChildrenScheduledLabel_ceetoo_k$ = get_attendanceChildrenScheduledLabel;
    protoOf($).get_attendanceStatusLabel_3q3usw_k$ = get_attendanceStatusLabel;
    protoOf($).get_attendanceStatusSubmitted_swmv6f_k$ = get_attendanceStatusSubmitted;
    protoOf($).get_attendanceStatusOpen_y91qpa_k$ = get_attendanceStatusOpen;
    protoOf($).get_attendancePeriodsPageTitle_1e29ef_k$ = get_attendancePeriodsPageTitle;
    protoOf($).attendancePeriodRange_42l3v7_k$ = attendancePeriodRange;
    protoOf($).get_attendanceClosuresHeading_1l8eiw_k$ = get_attendanceClosuresHeading;
    protoOf($).get_attendanceLocationColumnLabel_dz9caf_k$ = get_attendanceLocationColumnLabel;
    protoOf($).get_attendanceUnknownLocationLabel_l7955l_k$ = get_attendanceUnknownLocationLabel;
    protoOf($).get_attendanceSubmittedColumnLabel_fx9tt7_k$ = get_attendanceSubmittedColumnLabel;
    protoOf($).get_attendanceApprovedColumnLabel_lbrr5h_k$ = get_attendanceApprovedColumnLabel;
    protoOf($).get_attendanceStatusApproved_oxievv_k$ = get_attendanceStatusApproved;
    protoOf($).get_attendanceStatusPending_wf20oj_k$ = get_attendanceStatusPending;
    protoOf($).get_attendanceNotBegunMessage_a7k34b_k$ = get_attendanceNotBegunMessage;
    protoOf($).get_attendanceFilledToast_roztnx_k$ = get_attendanceFilledToast;
    protoOf($).get_attendanceTransportProvidedLabel_ghqywq_k$ = get_attendanceTransportProvidedLabel;
    protoOf($).get_attendanceTransportToCareLabel_ssvsgh_k$ = get_attendanceTransportToCareLabel;
    protoOf($).get_attendanceTransportFromCareLabel_elz7b2_k$ = get_attendanceTransportFromCareLabel;
    protoOf($).get_attendanceStateAttended_v3hons_k$ = get_attendanceStateAttended;
    protoOf($).get_attendanceStateExplainedAbsence_9yyv4q_k$ = get_attendanceStateExplainedAbsence;
    protoOf($).get_attendanceStateUnexplainedAbsence_uqoym9_k$ = get_attendanceStateUnexplainedAbsence;
    protoOf($).get_attendanceStateClosure_cr4gsc_k$ = get_attendanceStateClosure;
    protoOf($).get_attendanceStateNotScheduled_obpiih_k$ = get_attendanceStateNotScheduled;
    protoOf($).get_attendanceStateNotPlaced_4v4cr3_k$ = get_attendanceStateNotPlaced;
    protoOf($).get_attendanceStateNeedsEntry_c829o4_k$ = get_attendanceStateNeedsEntry;
    protoOf($).get_formulaTesterHeading_uddkg6_k$ = get_formulaTesterHeading;
    protoOf($).get_formulaTesterInstructions_a6kdjz_k$ = get_formulaTesterInstructions;
    protoOf($).formulaResultLine_w5wyal_k$ = formulaResultLine;
    protoOf($).get_locationNameLabel_iz62q3_k$ = get_locationNameLabel;
    protoOf($).get_locationAddressSectionTitle_ooy4vd_k$ = get_locationAddressSectionTitle;
    protoOf($).get_locationStreetAddressLabel_1akgf5_k$ = get_locationStreetAddressLabel;
    protoOf($).get_locationAptSuiteLabel_qtfjst_k$ = get_locationAptSuiteLabel;
    protoOf($).get_locationCityLabel_jq20et_k$ = get_locationCityLabel;
    protoOf($).get_locationStateLabel_vycy69_k$ = get_locationStateLabel;
    protoOf($).get_locationZipcodeLabel_ph92sc_k$ = get_locationZipcodeLabel;
    protoOf($).get_locationContactSectionTitle_jjah7v_k$ = get_locationContactSectionTitle;
    protoOf($).get_locationContactNameLabel_3ysqd5_k$ = get_locationContactNameLabel;
    protoOf($).get_locationContactEmailLabel_efzqw6_k$ = get_locationContactEmailLabel;
    protoOf($).get_locationContactPhoneLabel_4m2zrc_k$ = get_locationContactPhoneLabel;
    protoOf($).get_locationAddDialogTitle_cinmfn_k$ = get_locationAddDialogTitle;
    protoOf($).get_locationAddButton_95bquj_k$ = get_locationAddButton;
    protoOf($).get_locationAddedToast_8hz6sl_k$ = get_locationAddedToast;
    protoOf($).get_locationAddClosureButton_djcbau_k$ = get_locationAddClosureButton;
    protoOf($).get_locationDetailsSectionTitle_d2wrk9_k$ = get_locationDetailsSectionTitle;
    protoOf($).get_locationEditButton_aysohy_k$ = get_locationEditButton;
    protoOf($).get_locationProviderLabel_b4amqt_k$ = get_locationProviderLabel;
    protoOf($).get_locationActivePlacementsSectionTitle_nw2pyz_k$ = get_locationActivePlacementsSectionTitle;
    protoOf($).get_locationChildColumnLabel_8ikusg_k$ = get_locationChildColumnLabel;
    protoOf($).get_locationRateColumnLabel_aaazvk_k$ = get_locationRateColumnLabel;
    protoOf($).get_locationActiveDatesColumnLabel_f4guo3_k$ = get_locationActiveDatesColumnLabel;
    protoOf($).get_locationAgreementStatusColumnLabel_dddsdc_k$ = get_locationAgreementStatusColumnLabel;
    protoOf($).get_locationUnknownRateLabel_ltp6qw_k$ = get_locationUnknownRateLabel;
    protoOf($).get_locationNoEndDateLabel_1tfruy_k$ = get_locationNoEndDateLabel;
    protoOf($).locationDateRange_w0af9i_k$ = locationDateRange;
    protoOf($).get_locationSaveButton_pcmeoj_k$ = get_locationSaveButton;
    protoOf($).get_locationSavedToast_9rc1s2_k$ = get_locationSavedToast;
    protoOf($).get_locationsPageTitle_w1kct0_k$ = get_locationsPageTitle;
    protoOf($).locationDetailTitle_rl62c8_k$ = locationDetailTitle;
    protoOf($).get_locationContactColumnLabel_7u4hlo_k$ = get_locationContactColumnLabel;
    protoOf($).get_locationPhoneColumnLabel_xybcky_k$ = get_locationPhoneColumnLabel;
    protoOf($).get_locationRatesHeading_uw7hbn_k$ = get_locationRatesHeading;
    protoOf($).get_locationAddRateButton_ve9lbf_k$ = get_locationAddRateButton;
    protoOf($).get_locationPrototypeColumnLabel_7abp2e_k$ = get_locationPrototypeColumnLabel;
    protoOf($).get_locationPlanLabel_xccdpp_k$ = get_locationPlanLabel;
    protoOf($).get_locationUnknownPlanLabel_i0kgn5_k$ = get_locationUnknownPlanLabel;
    protoOf($).get_locationAttendanceHeading_qbmfph_k$ = get_locationAttendanceHeading;
    protoOf($).get_locationAddAttendancePeriodButton_2ztszj_k$ = get_locationAddAttendancePeriodButton;
    protoOf($).get_locationPeriodNotSubmittedStatus_xdso1l_k$ = get_locationPeriodNotSubmittedStatus;
    protoOf($).get_locationPeriodNeedsApprovalStatus_1q9c99_k$ = get_locationPeriodNeedsApprovalStatus;
    protoOf($).get_locationClosureDateLabel_yxq7hz_k$ = get_locationClosureDateLabel;
    protoOf($).get_locationClosureKindColumnLabel_l2ckur_k$ = get_locationClosureKindColumnLabel;
    protoOf($).locationChooseMonthSubtext_17dav3_k$ = locationChooseMonthSubtext;
    protoOf($).get_locationNoEligibleMonthsMessage_5awsde_k$ = get_locationNoEligibleMonthsMessage;
    protoOf($).get_locationClosureUmbrellaWarning_b148pn_k$ = get_locationClosureUmbrellaWarning;
    protoOf($).get_locationClosureSpecificLocationHint_htzknp_k$ = get_locationClosureSpecificLocationHint;
    protoOf($).get_locationClosureReasonLabel_jr4c1f_k$ = get_locationClosureReasonLabel;
    protoOf($).get_locationAddClosuresButton_8pcv03_k$ = get_locationAddClosuresButton;
    protoOf($).get_locationClosureAddedToast_kquvus_k$ = get_locationClosureAddedToast;
    protoOf($).get_locationPrototypeNameLabel_o3rt51_k$ = get_locationPrototypeNameLabel;
    protoOf($).get_locationSelectPlanPlaceholder_e7rncg_k$ = get_locationSelectPlanPlaceholder;
    protoOf($).get_locationRateAddedToast_4hcq1n_k$ = get_locationRateAddedToast;
    protoOf($).get_rateInForceFromLabel_hamky5_k$ = get_rateInForceFromLabel;
    protoOf($).get_rateLocationLabel_u8i4x6_k$ = get_rateLocationLabel;
    protoOf($).get_ratePlanLabel_6i1kny_k$ = get_ratePlanLabel;
    protoOf($).get_rateChangeButton_dchwaz_k$ = get_rateChangeButton;
    protoOf($).rateChangePlanTitle_kxriyt_k$ = rateChangePlanTitle;
    protoOf($).get_rateStartingAtDateLabel_5za9na_k$ = get_rateStartingAtDateLabel;
    protoOf($).get_rateToRateLabel_vgzx2o_k$ = get_rateToRateLabel;
    protoOf($).rateChangeConfirmation_752i51_k$ = rateChangeConfirmation;
    protoOf($).get_rateOnThisPlanSinceLabel_vdwh5j_k$ = get_rateOnThisPlanSinceLabel;
    protoOf($).get_rateCurrentRateHeading_hraq4y_k$ = get_rateCurrentRateHeading;
    protoOf($).get_rateLocationCurrentRateSubtext_i30vi_k$ = get_rateLocationCurrentRateSubtext;
    protoOf($).get_ratePlanCurrentRateSubtext_41xbk6_k$ = get_ratePlanCurrentRateSubtext;
    protoOf($).get_rateCurrentChip_ej3r0k_k$ = get_rateCurrentChip;
    protoOf($).rateInForceSince_kfs6_k$ = rateInForceSince;
    protoOf($).get_rateHistoryHeading_245zkn_k$ = get_rateHistoryHeading;
    protoOf($).get_rateHistorySubtext_t3uw1u_k$ = get_rateHistorySubtext;
    protoOf($).get_rateInForceColumnLabel_elll5r_k$ = get_rateInForceColumnLabel;
    protoOf($).get_rateDailyRateColumnLabel_3eflwu_k$ = get_rateDailyRateColumnLabel;
    protoOf($).get_rateTemplatesPageTitle_qntbdl_k$ = get_rateTemplatesPageTitle;
    protoOf($).get_rateTemplatesHeading_o6frgy_k$ = get_rateTemplatesHeading;
    protoOf($).get_rateAddTemplateButton_h149ic_k$ = get_rateAddTemplateButton;
    protoOf($).get_rateNameColumnLabel_44vut2_k$ = get_rateNameColumnLabel;
    protoOf($).get_rateAddVersionButton_8qx842_k$ = get_rateAddVersionButton;
    protoOf($).get_rateVersionHistoryHeading_go8cgt_k$ = get_rateVersionHistoryHeading;
    protoOf($).get_rateVersionHistorySubtext_rd6t14_k$ = get_rateVersionHistorySubtext;
    protoOf($).get_rateNewVersionPageTitle_nfj0tk_k$ = get_rateNewVersionPageTitle;
    protoOf($).rateAddVersionHeading_xp6sun_k$ = rateAddVersionHeading;
    protoOf($).get_rateTemplateNameHeading_spoi4s_k$ = get_rateTemplateNameHeading;
    protoOf($).get_rateNewVersionFormHeading_o52csj_k$ = get_rateNewVersionFormHeading;
    protoOf($).get_rateAddTemplateSubmitButton_psnajo_k$ = get_rateAddTemplateSubmitButton;
    protoOf($).get_rateVersionAddedToast_45ku6u_k$ = get_rateVersionAddedToast;
    protoOf($).get_rateNewTemplatePageTitle_o1z2rc_k$ = get_rateNewTemplatePageTitle;
    protoOf($).get_rateNewTemplateHeading_sdjtlb_k$ = get_rateNewTemplateHeading;
    protoOf($).get_rateNameLabel_kv7vnk_k$ = get_rateNameLabel;
    protoOf($).get_rateShortNameLabel_odyqae_k$ = get_rateShortNameLabel;
    protoOf($).get_rateAgeStartLabel_lia3xk_k$ = get_rateAgeStartLabel;
    protoOf($).get_rateAgeEndLabel_j1qosv_k$ = get_rateAgeEndLabel;
    protoOf($).get_rateTransportOneWayLabel_hbgejv_k$ = get_rateTransportOneWayLabel;
    protoOf($).get_rateTransportTwoWayLabel_x99pbj_k$ = get_rateTransportTwoWayLabel;
    protoOf($).get_rateCareTimeLabel_lijrzh_k$ = get_rateCareTimeLabel;
    protoOf($).get_rateAvailableAsIntermittentLabel_h1v0mn_k$ = get_rateAvailableAsIntermittentLabel;
    protoOf($).get_rateFirstVersionFormHeading_9520p9_k$ = get_rateFirstVersionFormHeading;
    protoOf($).get_rateTemplateAddedToast_3485d6_k$ = get_rateTemplateAddedToast;
    protoOf($).get_providerNameLabel_yl378x_k$ = get_providerNameLabel;
    protoOf($).get_providerContactLabel_6n76gi_k$ = get_providerContactLabel;
    protoOf($).get_providerContactNameLabel_l558ot_k$ = get_providerContactNameLabel;
    protoOf($).get_providerContactEmailLabel_lc4wv2_k$ = get_providerContactEmailLabel;
    protoOf($).get_providerContactPhoneLabel_umwegk_k$ = get_providerContactPhoneLabel;
    protoOf($).get_providerOffersTransportationLabel_8w5t13_k$ = get_providerOffersTransportationLabel;
    protoOf($).get_providerAddDialogHeading_873vsd_k$ = get_providerAddDialogHeading;
    protoOf($).get_providerAddButtonLabel_34jbj9_k$ = get_providerAddButtonLabel;
    protoOf($).get_providerAddedToast_i8f4wv_k$ = get_providerAddedToast;
    protoOf($).get_providerDetailsHeading_vbtsje_k$ = get_providerDetailsHeading;
    protoOf($).get_providerEditButtonDescription_6z204a_k$ = get_providerEditButtonDescription;
    protoOf($).get_providerYesLabel_su34fb_k$ = get_providerYesLabel;
    protoOf($).get_providerNoLabel_wn67vr_k$ = get_providerNoLabel;
    protoOf($).get_providerLocationsHeading_kilnxe_k$ = get_providerLocationsHeading;
    protoOf($).get_providerAddLocationButtonLabel_ny6cyi_k$ = get_providerAddLocationButtonLabel;
    protoOf($).get_providerCityLabel_2978ep_k$ = get_providerCityLabel;
    protoOf($).get_providerSaveButtonLabel_8m3k6t_k$ = get_providerSaveButtonLabel;
    protoOf($).get_providerSavedToast_yjdohm_k$ = get_providerSavedToast;
    protoOf($).get_providersPageTitle_5b613k_k$ = get_providersPageTitle;
    protoOf($).get_providerEmailLabel_uskhea_k$ = get_providerEmailLabel;
    protoOf($).get_providerPhoneLabel_l6gtxc_k$ = get_providerPhoneLabel;
    protoOf($).get_providerVendorNumberLabel_cg5mi1_k$ = get_providerVendorNumberLabel;
    protoOf($).get_providerVendorNumberNotSet_vxdl2y_k$ = get_providerVendorNumberNotSet;
    protoOf($).get_childAddDialogTitle_h9rjhe_k$ = get_childAddDialogTitle;
    protoOf($).get_childAddButton_woryww_k$ = get_childAddButton;
    protoOf($).get_childAddedToast_qv5dui_k$ = get_childAddedToast;
    protoOf($).get_childFirstNameLabel_nfb0t0_k$ = get_childFirstNameLabel;
    protoOf($).get_childLastNameLabel_9cmbcw_k$ = get_childLastNameLabel;
    protoOf($).get_childBirthDateLabel_57yy4m_k$ = get_childBirthDateLabel;
    protoOf($).get_childRaceEthnicityLabel_1rbvt3_k$ = get_childRaceEthnicityLabel;
    protoOf($).get_childNotesLabel_i49wca_k$ = get_childNotesLabel;
    protoOf($).get_childDetailsHeading_m3xz5f_k$ = get_childDetailsHeading;
    protoOf($).childFamilyNameSuffix_vnbngi_k$ = childFamilyNameSuffix;
    protoOf($).get_childUnknownLabel_wvpdgd_k$ = get_childUnknownLabel;
    protoOf($).childBirthdateWithAge_961sp2_k$ = childBirthdateWithAge;
    protoOf($).get_childPlacementsHeading_tdetof_k$ = get_childPlacementsHeading;
    protoOf($).get_childTableHeaderLocation_z6m8z_k$ = get_childTableHeaderLocation;
    protoOf($).get_childTableHeaderRate_xtg0lk_k$ = get_childTableHeaderRate;
    protoOf($).get_childTableHeaderActiveDates_jvbf9l_k$ = get_childTableHeaderActiveDates;
    protoOf($).get_childTableHeaderAgreementStatus_cdpz04_k$ = get_childTableHeaderAgreementStatus;
    protoOf($).get_childUnknownLocationLabel_r43uzs_k$ = get_childUnknownLocationLabel;
    protoOf($).get_childUnknownProviderLabel_fsgzro_k$ = get_childUnknownProviderLabel;
    protoOf($).get_childUnknownRateLabel_o241ct_k$ = get_childUnknownRateLabel;
    protoOf($).get_childNoEndDateLabel_vluxrz_k$ = get_childNoEndDateLabel;
    protoOf($).get_childSaveButton_6zg7mm_k$ = get_childSaveButton;
    protoOf($).get_childSavedToast_8lu59v_k$ = get_childSavedToast;
    protoOf($).childPlacementDetailTitle_5imj30_k$ = childPlacementDetailTitle;
    protoOf($).get_childPlacementDetailsHeading_q87f7y_k$ = get_childPlacementDetailsHeading;
    protoOf($).signatureStatusLabel_agp5cg_k$ = signatureStatusLabel;
    protoOf($).get_childScheduleHeading_ybonig_k$ = get_childScheduleHeading;
    protoOf($).get_childScheduleTableHeaderDay_gbtbl7_k$ = get_childScheduleTableHeaderDay;
    protoOf($).get_childScheduleTableHeaderTime_8yqyxq_k$ = get_childScheduleTableHeaderTime;
    protoOf($).get_childScheduleTableHeaderIntermittent_1zk9ks_k$ = get_childScheduleTableHeaderIntermittent;
    protoOf($).get_childScheduleTableHeaderTransport_xh3sc8_k$ = get_childScheduleTableHeaderTransport;
    protoOf($).get_childNoLabel_jgme2o_k$ = get_childNoLabel;
    protoOf($).childTransportDescription_9po3ip_k$ = childTransportDescription;
    protoOf($).get_childrenListTitle_3nn3hu_k$ = get_childrenListTitle;
    protoOf($).get_childrenTableHeaderName_oazrcu_k$ = get_childrenTableHeaderName;
    protoOf($).get_childrenTableHeaderFamily_fhtlt5_k$ = get_childrenTableHeaderFamily;
    protoOf($).get_childrenTableHeaderBirthdate_iu407u_k$ = get_childrenTableHeaderBirthdate;
    protoOf($).get_placementNewTitle_31boj8_k$ = get_placementNewTitle;
    protoOf($).placementAddForChildTitle_tfmgtt_k$ = placementAddForChildTitle;
    protoOf($).get_placementDetailsHeading_3qgx4s_k$ = get_placementDetailsHeading;
    protoOf($).get_placementCareLocationLabel_w1cbma_k$ = get_placementCareLocationLabel;
    protoOf($).get_placementSearchIconDescription_uuv8wx_k$ = get_placementSearchIconDescription;
    protoOf($).placementLocationWithProvider_dft4wy_k$ = placementLocationWithProvider;
    protoOf($).get_placementSelectCareLocationPlaceholder_zi5v79_k$ = get_placementSelectCareLocationPlaceholder;
    protoOf($).get_placementChooseCareLocationTitle_7rzjtt_k$ = get_placementChooseCareLocationTitle;
    protoOf($).get_placementNoCareLocationsMatch_lqc8l_k$ = get_placementNoCareLocationsMatch;
    protoOf($).get_placementStartDateLabel_lvccn4_k$ = get_placementStartDateLabel;
    protoOf($).get_placementEndDateLabel_oohsnt_k$ = get_placementEndDateLabel;
    protoOf($).get_placementFundingHeading_tzzalb_k$ = get_placementFundingHeading;
    protoOf($).get_placementPaidByGrantsLabel_y96mde_k$ = get_placementPaidByGrantsLabel;
    protoOf($).get_placementChooseGrantsTitle_w90u32_k$ = get_placementChooseGrantsTitle;
    protoOf($).get_placementSendForSignatureTitle_fzt0kl_k$ = get_placementSendForSignatureTitle;
    protoOf($).get_placementSendForSignatureBody_ualg6t_k$ = get_placementSendForSignatureBody;
    protoOf($).get_placementSaveAndSendButton_qp8w94_k$ = get_placementSaveAndSendButton;
    protoOf($).get_placementAddedToast_9n8dct_k$ = get_placementAddedToast;
    protoOf($).get_placementNoneSelectedLabel_ryp2xn_k$ = get_placementNoneSelectedLabel;
    protoOf($).get_placementNoOptionsFoundLabel_67d80d_k$ = get_placementNoOptionsFoundLabel;
    protoOf($).get_placementDoneButton_4je2q8_k$ = get_placementDoneButton;
    protoOf($).get_childEditButton_7edijz_k$ = get_childEditButton;
    protoOf($).get_childFamilyLabel_zden0d_k$ = get_childFamilyLabel;
    protoOf($).get_childBirthdateLabel_wo149m_k$ = get_childBirthdateLabel;
    protoOf($).get_childAddPlacementButton_ol20h5_k$ = get_childAddPlacementButton;
    protoOf($).get_childPlacementChildLabel_g8ybd6_k$ = get_childPlacementChildLabel;
    protoOf($).get_childPlacementProviderLabel_a3mqvj_k$ = get_childPlacementProviderLabel;
    protoOf($).get_childPlacementGrantsLabel_lannsl_k$ = get_childPlacementGrantsLabel;
    protoOf($).get_placementSearchLocationHint_kl76yo_k$ = get_placementSearchLocationHint;
    protoOf($).get_placementTransportFromLabel_xf7eqr_k$ = get_placementTransportFromLabel;
    protoOf($).get_placementTransportToLabel_ai59v0_k$ = get_placementTransportToLabel;
    protoOf($).get_placementSearchHint_64804r_k$ = get_placementSearchHint;
    protoOf($).get_childCopyPlacementButton_2566k1_k$ = get_childCopyPlacementButton;
    protoOf($).get_placementChangeEndButton_9y5npd_k$ = get_placementChangeEndButton;
    protoOf($).get_placementEndReasonLabel_2y0sr5_k$ = get_placementEndReasonLabel;
    protoOf($).get_placementEndReasonPlaceholder_rzs88g_k$ = get_placementEndReasonPlaceholder;
    protoOf($).get_placementEndReasonNotesLabel_6gz5fa_k$ = get_placementEndReasonNotesLabel;
    protoOf($).get_childPlacementAgreementLabel_a4ki58_k$ = get_childPlacementAgreementLabel;
    protoOf($).get_childPlacementAgreementNoneSet_y46u4u_k$ = get_childPlacementAgreementNoneSet;
    protoOf($).get_childNotScheduledLabel_mg5553_k$ = get_childNotScheduledLabel;
    protoOf($).get_placementWhenSchoolIsOutLabel_som316_k$ = get_placementWhenSchoolIsOutLabel;
    protoOf($).get_placementNotIntermittentLabel_4hk03a_k$ = get_placementNotIntermittentLabel;
    protoOf($).placementPreviousEndChangeMessage_u9z0qq_k$ = placementPreviousEndChangeMessage;
    protoOf($).get_familyFirstNameLabel_j5nup2_k$ = get_familyFirstNameLabel;
    protoOf($).get_familyLastNameLabel_slk1mi_k$ = get_familyLastNameLabel;
    protoOf($).get_familyPhoneNumberLabel_28h2zu_k$ = get_familyPhoneNumberLabel;
    protoOf($).get_familyAlternatePhoneLabel_sqbdsj_k$ = get_familyAlternatePhoneLabel;
    protoOf($).get_familyEmailLabel_ow4s1n_k$ = get_familyEmailLabel;
    protoOf($).get_familyPreferredLanguageLabel_sqcw94_k$ = get_familyPreferredLanguageLabel;
    protoOf($).get_familyRaceEthnicityLabel_z00d2r_k$ = get_familyRaceEthnicityLabel;
    protoOf($).get_familyAddSecondParentLabel_6zuz7m_k$ = get_familyAddSecondParentLabel;
    protoOf($).get_familyAddressLabel_jhvmgd_k$ = get_familyAddressLabel;
    protoOf($).get_familyStreetAddressLabel_hc5wvk_k$ = get_familyStreetAddressLabel;
    protoOf($).get_familyAptSuiteLabel_c6ev78_k$ = get_familyAptSuiteLabel;
    protoOf($).get_familyCityLabel_9p20yk_k$ = get_familyCityLabel;
    protoOf($).get_familyStateLabel_kkdf00_k$ = get_familyStateLabel;
    protoOf($).get_familyZipcodeLabel_v3fgfh_k$ = get_familyZipcodeLabel;
    protoOf($).get_familyAnnualIncomeLabel_nsky2p_k$ = get_familyAnnualIncomeLabel;
    protoOf($).get_familySizeLabel_ytosca_k$ = get_familySizeLabel;
    protoOf($).get_familyPreferNotToSayLabel_t7jcq_k$ = get_familyPreferNotToSayLabel;
    protoOf($).familyDetailTitle_gwlhpl_k$ = familyDetailTitle;
    protoOf($).get_familyDetailsSectionTitle_mepryw_k$ = get_familyDetailsSectionTitle;
    protoOf($).get_familyEditIconDescription_ebeqi4_k$ = get_familyEditIconDescription;
    protoOf($).get_familyPrimaryParentLabel_xb85ed_k$ = get_familyPrimaryParentLabel;
    protoOf($).get_familyPrimaryEmailLabel_sxbo19_k$ = get_familyPrimaryEmailLabel;
    protoOf($).get_familyPrimaryPhoneLabel_n1pnad_k$ = get_familyPrimaryPhoneLabel;
    protoOf($).get_familyPrimaryAlternatePhoneLabel_l533dh_k$ = get_familyPrimaryAlternatePhoneLabel;
    protoOf($).get_familySecondaryParentLabel_xd744d_k$ = get_familySecondaryParentLabel;
    protoOf($).get_familySecondaryEmailLabel_1kj0yn_k$ = get_familySecondaryEmailLabel;
    protoOf($).get_familySecondaryPhoneLabel_kmlrm5_k$ = get_familySecondaryPhoneLabel;
    protoOf($).get_familySecondaryAlternatePhoneLabel_rncxqf_k$ = get_familySecondaryAlternatePhoneLabel;
    protoOf($).get_familyInformationVerifiedLabel_5tuhwz_k$ = get_familyInformationVerifiedLabel;
    protoOf($).get_familyNotVerifiedLabel_31381m_k$ = get_familyNotVerifiedLabel;
    protoOf($).get_familyChildrenSectionTitle_2sss81_k$ = get_familyChildrenSectionTitle;
    protoOf($).get_familyAddChildButton_udkhcq_k$ = get_familyAddChildButton;
    protoOf($).get_familyNameColumnLabel_yh58ca_k$ = get_familyNameColumnLabel;
    protoOf($).get_familyBirthdateAgeColumnLabel_djfnz5_k$ = get_familyBirthdateAgeColumnLabel;
    protoOf($).get_familyActivePlacementColumnLabel_repll8_k$ = get_familyActivePlacementColumnLabel;
    protoOf($).familyPlacementSummary_u4ho0l_k$ = familyPlacementSummary;
    protoOf($).get_familySaveFamilyButton_40ppb4_k$ = get_familySaveFamilyButton;
    protoOf($).get_familySavedToast_l5bkyb_k$ = get_familySavedToast;
    protoOf($).get_familyListTitle_7vfhpp_k$ = get_familyListTitle;
    protoOf($).get_familyAddFamilyButton_qgzmly_k$ = get_familyAddFamilyButton;
    protoOf($).get_familyColumnLabel_vxra7j_k$ = get_familyColumnLabel;
    protoOf($).get_familyCityColumnLabel_bqfeje_k$ = get_familyCityColumnLabel;
    protoOf($).get_familyNewFamilyTitle_u18ivz_k$ = get_familyNewFamilyTitle;
    protoOf($).get_familyAddPageTitle_rl7n91_k$ = get_familyAddPageTitle;
    protoOf($).get_familyAddedToast_2w0cdo_k$ = get_familyAddedToast;
    protoOf($).get_familyApplicationListTitle_c6ygp5_k$ = get_familyApplicationListTitle;
    protoOf($).get_familyApplicationColumnSentTo_7zvbzg_k$ = get_familyApplicationColumnSentTo;
    protoOf($).get_familyApplicationColumnEmployer_c2b99w_k$ = get_familyApplicationColumnEmployer;
    protoOf($).get_familyApplicationColumnStatus_87vyuj_k$ = get_familyApplicationColumnStatus;
    protoOf($).get_familyApplicationColumnInvitedAt_esy33p_k$ = get_familyApplicationColumnInvitedAt;
    protoOf($).familyApplicationDetailTitle_7az5kv_k$ = familyApplicationDetailTitle;
    protoOf($).get_familyApplicationSentToLabel_u2by72_k$ = get_familyApplicationSentToLabel;
    protoOf($).get_familyApplicationEmployerLabel_w3sr2u_k$ = get_familyApplicationEmployerLabel;
    protoOf($).get_familyApplicationStatusLabel_3spxtr_k$ = get_familyApplicationStatusLabel;
    protoOf($).get_familyApplicationNotSubmittedLabel_1cvz7t_k$ = get_familyApplicationNotSubmittedLabel;
    protoOf($).get_familyApplicationApproveButton_w2gak_k$ = get_familyApplicationApproveButton;
    protoOf($).get_familyApplicationApproveConfirmHeading_oqxjis_k$ = get_familyApplicationApproveConfirmHeading;
    protoOf($).get_familyApplicationApproveConfirmBody_j98ydk_k$ = get_familyApplicationApproveConfirmBody;
    protoOf($).get_familyApplicationApprovedToast_ghct71_k$ = get_familyApplicationApprovedToast;
    protoOf($).get_familyApplicationRejectedToast_5xw86e_k$ = get_familyApplicationRejectedToast;
    protoOf($).get_providerApplicationListTitle_52jvb0_k$ = get_providerApplicationListTitle;
    protoOf($).get_providerApplicationColumnSentTo_l9kj27_k$ = get_providerApplicationColumnSentTo;
    protoOf($).get_providerApplicationColumnInvitedAt_xa4eri_k$ = get_providerApplicationColumnInvitedAt;
    protoOf($).get_providerApplicationColumnStatus_lhl5xa_k$ = get_providerApplicationColumnStatus;
    protoOf($).providerApplicationDetailTitle_7oej8u_k$ = providerApplicationDetailTitle;
    protoOf($).get_providerApplicationSentToLabel_fc0az9_k$ = get_providerApplicationSentToLabel;
    protoOf($).get_providerApplicationStatusLabel_tfhqmk_k$ = get_providerApplicationStatusLabel;
    protoOf($).get_providerApplicationNotSubmittedLabel_wjkrfa_k$ = get_providerApplicationNotSubmittedLabel;
    protoOf($).get_providerApplicationApproveButton_dxws6v_k$ = get_providerApplicationApproveButton;
    protoOf($).get_providerApplicationApproveConfirmHeading_ifddmh_k$ = get_providerApplicationApproveConfirmHeading;
    protoOf($).get_providerApplicationApproveConfirmBody_o3mmdn_k$ = get_providerApplicationApproveConfirmBody;
    protoOf($).get_providerApplicationApprovedToast_1ndkpm_k$ = get_providerApplicationApprovedToast;
    protoOf($).get_providerApplicationRejectedToast_8w30b1_k$ = get_providerApplicationRejectedToast;
    protoOf($).get_employerNameLabel_rr9lvp_k$ = get_employerNameLabel;
    protoOf($).get_employerContactLabel_f0mfyw_k$ = get_employerContactLabel;
    protoOf($).get_employerContactNameLabel_h6hpwz_k$ = get_employerContactNameLabel;
    protoOf($).get_employerContactEmailLabel_245yvo_k$ = get_employerContactEmailLabel;
    protoOf($).get_employerContactPhoneLabel_l68pj6_k$ = get_employerContactPhoneLabel;
    protoOf($).get_employerEmailColumnLabel_siw8re_k$ = get_employerEmailColumnLabel;
    protoOf($).get_employerPhoneColumnLabel_nv3puc_k$ = get_employerPhoneColumnLabel;
    protoOf($).get_employerBillingAddressLabel_ppg2x_k$ = get_employerBillingAddressLabel;
    protoOf($).get_employerAddBillingAddressLabel_f9xuim_k$ = get_employerAddBillingAddressLabel;
    protoOf($).get_employerBillingContactLabel_g1s2i3_k$ = get_employerBillingContactLabel;
    protoOf($).get_employerBillingContactNameLabel_2furfk_k$ = get_employerBillingContactNameLabel;
    protoOf($).get_employerStreetAddressLabel_hfp9k7_k$ = get_employerStreetAddressLabel;
    protoOf($).get_employerAptSuiteLabel_72k85f_k$ = get_employerAptSuiteLabel;
    protoOf($).get_employerCityLabel_axyh97_k$ = get_employerCityLabel;
    protoOf($).get_employerStateLabel_k0y83r_k$ = get_employerStateLabel;
    protoOf($).get_employerZipcodeLabel_ioxwh6_k$ = get_employerZipcodeLabel;
    protoOf($).get_employerAddDialogHeading_48gd0j_k$ = get_employerAddDialogHeading;
    protoOf($).get_employerAddButton_d87ox_k$ = get_employerAddButton;
    protoOf($).get_employerAddedToast_3ffj9x_k$ = get_employerAddedToast;
    protoOf($).get_employerDetailsHeading_ytinek_k$ = get_employerDetailsHeading;
    protoOf($).get_employerEditButtonDescription_ojdqak_k$ = get_employerEditButtonDescription;
    protoOf($).get_employerActiveLabel_isbluy_k$ = get_employerActiveLabel;
    protoOf($).get_employerYesLabel_5tbbwv_k$ = get_employerYesLabel;
    protoOf($).get_employerNoLabel_ue8l8v_k$ = get_employerNoLabel;
    protoOf($).get_employerBalanceLabel_le7jmk_k$ = get_employerBalanceLabel;
    protoOf($).get_employerBalanceNotSynced_t35ga3_k$ = get_employerBalanceNotSynced;
    protoOf($).get_employerRatesHeading_d9zhxv_k$ = get_employerRatesHeading;
    protoOf($).get_employerRatesSubtext_urfnk2_k$ = get_employerRatesSubtext;
    protoOf($).get_employerAddNewRateButton_3qdhmd_k$ = get_employerAddNewRateButton;
    protoOf($).get_employerShareOfDayLabel_l9g9iu_k$ = get_employerShareOfDayLabel;
    protoOf($).get_employerShareColumnLabel_p5bseb_k$ = get_employerShareColumnLabel;
    protoOf($).get_employerAdministrationColumnLabel_s4ljqc_k$ = get_employerAdministrationColumnLabel;
    protoOf($).get_employerSaveButton_xr2x83_k$ = get_employerSaveButton;
    protoOf($).get_employerSavedToast_loqruk_k$ = get_employerSavedToast;
    protoOf($).get_employerNewRatePageTitle_lgm6tv_k$ = get_employerNewRatePageTitle;
    protoOf($).employerAddRateHeading_yj9ltq_k$ = employerAddRateHeading;
    protoOf($).get_employerAddRateButton_bne9o1_k$ = get_employerAddRateButton;
    protoOf($).get_employerRateAddedToast_vme6ol_k$ = get_employerRateAddedToast;
    protoOf($).get_userNameLabel_jnppqj_k$ = get_userNameLabel;
    protoOf($).get_userEmailLabel_3oltlg_k$ = get_userEmailLabel;
    protoOf($).get_userPhoneLabel_fdgx22_k$ = get_userPhoneLabel;
    protoOf($).get_userRoleLabel_yi9o5y_k$ = get_userRoleLabel;
    protoOf($).get_userDetailsSectionTitle_o8ze3l_k$ = get_userDetailsSectionTitle;
    protoOf($).get_userEditIconDescription_a205ej_k$ = get_userEditIconDescription;
    protoOf($).get_grantNameLabel_7luufe_k$ = get_grantNameLabel;
    protoOf($).get_grantFunderLabel_2sx24x_k$ = get_grantFunderLabel;
    protoOf($).get_grantAwardPeriodLabel_m5ymnd_k$ = get_grantAwardPeriodLabel;
    protoOf($).get_grantStartDateLabel_la3b0p_k$ = get_grantStartDateLabel;
    protoOf($).get_grantAddEndDateLabel_xwlt5z_k$ = get_grantAddEndDateLabel;
    protoOf($).get_grantEndDateLabel_vuktgi_k$ = get_grantEndDateLabel;
    protoOf($).get_grantAddDialogHeading_vr5wfo_k$ = get_grantAddDialogHeading;
    protoOf($).get_grantAddButton_zardz4_k$ = get_grantAddButton;
    protoOf($).get_grantAddedToast_y9kr6u_k$ = get_grantAddedToast;
    protoOf($).get_grantDetailsHeading_4bpyr7_k$ = get_grantDetailsHeading;
    protoOf($).get_grantEditButtonDescription_abff03_k$ = get_grantEditButtonDescription;
    protoOf($).get_grantBalanceLabel_6ku5mz_k$ = get_grantBalanceLabel;
    protoOf($).get_grantBalanceNotSynced_ef929w_k$ = get_grantBalanceNotSynced;
    protoOf($).get_grantRatesHeading_1jdw1q_k$ = get_grantRatesHeading;
    protoOf($).get_grantRatesSubtext_pgb0fh_k$ = get_grantRatesSubtext;
    protoOf($).get_grantAddNewRateButton_nsc1ss_k$ = get_grantAddNewRateButton;
    protoOf($).get_grantShareOfDayLabel_f9y45h_k$ = get_grantShareOfDayLabel;
    protoOf($).get_grantShareColumnLabel_2ddr0u_k$ = get_grantShareColumnLabel;
    protoOf($).get_grantSaveButton_2wxpb6_k$ = get_grantSaveButton;
    protoOf($).get_grantSavedToast_ii827n_k$ = get_grantSavedToast;
    protoOf($).get_grantNewRatePageTitle_m1sbq4_k$ = get_grantNewRatePageTitle;
    protoOf($).grantAddRateHeading_rhf7ur_k$ = grantAddRateHeading;
    protoOf($).get_grantAddRateButton_q9v2io_k$ = get_grantAddRateButton;
    protoOf($).get_grantRateAddedToast_7iufh6_k$ = get_grantRateAddedToast;
    protoOf($).get_remittancesPageTitle_yno01p_k$ = get_remittancesPageTitle;
    protoOf($).get_remittancesPreviousMonthDescription_c46s75_k$ = get_remittancesPreviousMonthDescription;
    protoOf($).get_remittancesNextMonthDescription_472mkb_k$ = get_remittancesNextMonthDescription;
    protoOf($).get_remittancesProviderColumn_b68mq5_k$ = get_remittancesProviderColumn;
    protoOf($).get_remittancesStatusColumn_9ruzm4_k$ = get_remittancesStatusColumn;
    protoOf($).get_closeOutAttendanceIncomplete_qvityy_k$ = get_closeOutAttendanceIncomplete;
    protoOf($).get_closeOutAttendanceReviewNeeded_5v2tud_k$ = get_closeOutAttendanceReviewNeeded;
    protoOf($).get_closeOutReadyForRemittance_zhgfk3_k$ = get_closeOutReadyForRemittance;
    protoOf($).get_closeOutComplete_hpmhjs_k$ = get_closeOutComplete;
    protoOf($).get_remittancesAmountColumn_vm5mg6_k$ = get_remittancesAmountColumn;
    protoOf($).get_closeOutPageTitle_igqf2i_k$ = get_closeOutPageTitle;
    protoOf($).get_remittancesDatesColumn_sy3n9t_k$ = get_remittancesDatesColumn;
    protoOf($).get_remittanceVoided_7coapm_k$ = get_remittanceVoided;
    protoOf($).get_remittanceReviewPageTitle_w5gryu_k$ = get_remittanceReviewPageTitle;
    protoOf($).remittanceReviewHeading_bk4mmq_k$ = remittanceReviewHeading;
    protoOf($).remittanceProblemsHeading_lc0nvc_k$ = remittanceProblemsHeading;
    protoOf($).remittanceIssueButton_tu58r7_k$ = remittanceIssueButton;
    protoOf($).get_remittanceIssueConfirmHeading_bxfsjw_k$ = get_remittanceIssueConfirmHeading;
    protoOf($).get_remittanceIssueConfirmBody_1w6k7k_k$ = get_remittanceIssueConfirmBody;
    protoOf($).get_remittanceIssueConfirmButton_qtcw1s_k$ = get_remittanceIssueConfirmButton;
    protoOf($).get_remittanceDetailPageTitle_pimg0h_k$ = get_remittanceDetailPageTitle;
    protoOf($).get_remittanceStatusLabel_ozb6h1_k$ = get_remittanceStatusLabel;
    protoOf($).get_remittanceIssuedAtLabel_sk6ikx_k$ = get_remittanceIssuedAtLabel;
    protoOf($).get_remittanceAmountLabel_u9neaz_k$ = get_remittanceAmountLabel;
    protoOf($).get_remittanceChildrenLabel_g31cj6_k$ = get_remittanceChildrenLabel;
    protoOf($).get_remittanceDaysBilledLabel_iaro0g_k$ = get_remittanceDaysBilledLabel;
    protoOf($).get_remittanceCostOfCareLabel_pxj9qw_k$ = get_remittanceCostOfCareLabel;
    protoOf($).get_remittanceEmployerSharesLabel_p173b2_k$ = get_remittanceEmployerSharesLabel;
    protoOf($).get_remittanceGrantSharesLabel_3d2smj_k$ = get_remittanceGrantSharesLabel;
    protoOf($).get_remittanceFamilyPaysLabel_f1jlxa_k$ = get_remittanceFamilyPaysLabel;
    protoOf($).get_remittanceTcgPaysLabel_z6hcxk_k$ = get_remittanceTcgPaysLabel;
    protoOf($).get_remittanceAdministrationLabel_spr4f_k$ = get_remittanceAdministrationLabel;
    protoOf($).get_remittanceDayAttendanceLabel_y52ora_k$ = get_remittanceDayAttendanceLabel;
    protoOf($).get_remittanceDayProgramLabel_7icdid_k$ = get_remittanceDayProgramLabel;
    protoOf($).get_remittanceAbsencesLabel_s31xd5_k$ = get_remittanceAbsencesLabel;
    protoOf($).remittanceAbsencesValue_hrzn9f_k$ = remittanceAbsencesValue;
    protoOf($).get_remittanceChildTotalsHeading_ish2aq_k$ = get_remittanceChildTotalsHeading;
    protoOf($).get_remittanceChildTotalsHint_sqdm97_k$ = get_remittanceChildTotalsHint;
    protoOf($).get_remittanceChildColumn_w7inzf_k$ = get_remittanceChildColumn;
    protoOf($).get_remittanceDaysColumn_y81ogk_k$ = get_remittanceDaysColumn;
    protoOf($).remittanceIntermittentColumn_diw8ct_k$ = remittanceIntermittentColumn;
    protoOf($).get_remittanceTransportOneWayColumn_7s8g1t_k$ = get_remittanceTransportOneWayColumn;
    protoOf($).get_remittanceTransportTwoWayColumn_2m8bh7_k$ = get_remittanceTransportTwoWayColumn;
    protoOf($).get_remittanceExplainedAbsencesColumn_949z39_k$ = get_remittanceExplainedAbsencesColumn;
    protoOf($).get_remittanceUnexplainedAbsencesColumn_7oks0u_k$ = get_remittanceUnexplainedAbsencesColumn;
    protoOf($).get_remittanceFamilyPaysColumn_yxf9kk_k$ = get_remittanceFamilyPaysColumn;
    protoOf($).get_remittanceTcgPaysColumn_l2qjv6_k$ = get_remittanceTcgPaysColumn;
    protoOf($).get_remittanceGrandTotal_q37hep_k$ = get_remittanceGrandTotal;
    protoOf($).get_remittanceOpenPlacementButton_cb7i92_k$ = get_remittanceOpenPlacementButton;
    protoOf($).yearMonthDay_bm7hs7_k$ = yearMonthDay;
    protoOf($).get_surveyTakeSubmitButton_gkww0k_k$ = get_surveyTakeSubmitButton;
    protoOf($).get_surveyTakeNeedAnswerToast_561g7r_k$ = get_surveyTakeNeedAnswerToast;
    protoOf($).get_surveyTakeThanksToast_6r9hqk_k$ = get_surveyTakeThanksToast;
    protoOf($).get_surveyTakeSavedToast_evm8s6_k$ = get_surveyTakeSavedToast;
    protoOf($).get_surveyOptionalLabel_i973rl_k$ = get_surveyOptionalLabel;
    protoOf($).get_surveyCompletedText_anx46t_k$ = get_surveyCompletedText;
    protoOf($).get_surveyTakeAgainButton_c6h420_k$ = get_surveyTakeAgainButton;
    protoOf($).get_surveyAnsweringForLabel_wb231w_k$ = get_surveyAnsweringForLabel;
    protoOf($).get_surveyLeadershipQuestion_pd6bg2_k$ = get_surveyLeadershipQuestion;
    protoOf($).get_surveyLeadershipManagesNoOne_4fq5q9_k$ = get_surveyLeadershipManagesNoOne;
    protoOf($).get_surveyLeadershipManagesEmployees_jcz2fz_k$ = get_surveyLeadershipManagesEmployees;
    protoOf($).get_surveyLeadershipManagesManagers_3jp6do_k$ = get_surveyLeadershipManagesManagers;
    protoOf($).get_surveyLeadershipSeniorLeader_he8vsv_k$ = get_surveyLeadershipSeniorLeader;
    protoOf($).get_surveyIncomeQuestion_em6voy_k$ = get_surveyIncomeQuestion;
    protoOf($).get_surveyContinueButton_w6kl50_k$ = get_surveyContinueButton;
    protoOf($).get_surveyLanguageLabel_fcb89_k$ = get_surveyLanguageLabel;
    initMetadataForClass($, 'StringsForLanguage', VOID, VOID, [BaseStrings()], VOID, VOID, {0: Companion_getInstance});
    StringsForLanguageClass = $;
  }
  return StringsForLanguageClass;
}
function get_strings(_this__u8e3s4) {
  _init_properties_strings_kt__kebw5s();
  var tmp = get_stringsProperty();
  var tmp_0 = _get_strings_$lambda_5m183g;
  return tmp.lens_drj4fu_k$(tmp_0, _get_strings_$lambda_5m183g_0);
}
function _get_strings_$lambda_5m183g(it) {
  _init_properties_strings_kt__kebw5s();
  return it == null ? StringsForLanguage_English_getInstance() : it;
}
function _get_strings_$lambda_5m183g_0(it) {
  _init_properties_strings_kt__kebw5s();
  return it;
}
function StringsForLanguage_English_getInstance() {
  static_init();
  return StringsForLanguage_English_instance;
}
function StringsForLanguage_Code_getInstance() {
  static_init();
  return StringsForLanguage_Code_instance;
}
function StringsForLanguage_Spanish_getInstance() {
  static_init();
  return StringsForLanguage_Spanish_instance;
}
function StringsForLanguage_Portuguese_getInstance() {
  static_init();
  return StringsForLanguage_Portuguese_instance;
}
var properties_initialized_strings_kt_3smqtu;
function _init_properties_strings_kt__kebw5s() {
  if (!properties_initialized_strings_kt_3smqtu) {
    properties_initialized_strings_kt_3smqtu = true;
    stringsProperty = PersistentProperty().new_com_lightningkite_kiteui_reactive_PersistentProperty_dblk10_k$('language', null, get_nullable(Companion_getInstance().serializer_9w0wvi_k$()));
  }
}
//region block: exports
export {
  StringsForLanguage_English_getInstance as StringsForLanguage_English_getInstance2jm5ip12elsyk,
  StringsForLanguage_Portuguese_getInstance as StringsForLanguage_Portuguese_getInstance3vxpdkn8xejqr,
  StringsForLanguage_Spanish_getInstance as StringsForLanguage_Spanish_getInstance352f75oly0h9y,
  get_entries as get_entries3f2xe6etyinaj,
  get_strings as get_stringsy7vodl9dj0ya,
};
//endregion

//# sourceMappingURL=strings.mjs.map
